"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }
  return ar;
};
var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function next() {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function noop() {}
var identity = function identity(x) {
  return x;
};
function assign(tar, src) {
  // @ts-ignore
  for (var k in src) {
    tar[k] = src[k];
  }
  return tar;
}
function run(fn) {
  return fn();
}
function blank_object() {
  return Object.create(null);
}
function run_all(fns) {
  fns.forEach(run);
}
function is_function(thing) {
  return typeof thing === 'function';
}
function safe_not_equal(a, b) {
  return a != a ? b == b : a !== b || a && typeof a === 'object' || typeof a === 'function';
}
var src_url_equal_anchor;
function src_url_equal(element_src, url) {
  if (!src_url_equal_anchor) {
    src_url_equal_anchor = document.createElement('a');
  }
  src_url_equal_anchor.href = url;
  return element_src === src_url_equal_anchor.href;
}
function is_empty(obj) {
  return Object.keys(obj).length === 0;
}
function subscribe(store) {
  var callbacks = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    callbacks[_i - 1] = arguments[_i];
  }
  if (store == null) {
    return noop;
  }
  var unsub = store.subscribe.apply(store, __spread(callbacks));
  return unsub.unsubscribe ? function () {
    return unsub.unsubscribe();
  } : unsub;
}
function component_subscribe(component, store, callback) {
  component.$$.on_destroy.push(subscribe(store, callback));
}
function create_slot(definition, ctx, $$scope, fn) {
  if (definition) {
    var slot_ctx = get_slot_context(definition, ctx, $$scope, fn);
    return definition[0](slot_ctx);
  }
}
function get_slot_context(definition, ctx, $$scope, fn) {
  return definition[1] && fn ? assign($$scope.ctx.slice(), definition[1](fn(ctx))) : $$scope.ctx;
}
function get_slot_changes(definition, $$scope, dirty, fn) {
  if (definition[2] && fn) {
    var lets = definition[2](fn(dirty));
    if ($$scope.dirty === undefined) {
      return lets;
    }
    if (typeof lets === 'object') {
      var merged = [];
      var len = Math.max($$scope.dirty.length, lets.length);
      for (var i = 0; i < len; i += 1) {
        merged[i] = $$scope.dirty[i] | lets[i];
      }
      return merged;
    }
    return $$scope.dirty | lets;
  }
  return $$scope.dirty;
}
function update_slot_base(slot, slot_definition, ctx, $$scope, slot_changes, get_slot_context_fn) {
  if (slot_changes) {
    var slot_context = get_slot_context(slot_definition, ctx, $$scope, get_slot_context_fn);
    slot.p(slot_context, slot_changes);
  }
}
function get_all_dirty_from_scope($$scope) {
  if ($$scope.ctx.length > 32) {
    var dirty = [];
    var length_1 = $$scope.ctx.length / 32;
    for (var i = 0; i < length_1; i++) {
      dirty[i] = -1;
    }
    return dirty;
  }
  return -1;
}
function exclude_internal_props(props) {
  var result = {};
  for (var k in props) {
    if (k[0] !== '$') result[k] = props[k];
  }
  return result;
}
function compute_rest_props(props, keys) {
  var rest = {};
  keys = new Set(keys);
  for (var k in props) {
    if (!keys.has(k) && k[0] !== '$') rest[k] = props[k];
  }
  return rest;
}
var is_client = typeof window !== 'undefined';
var now = is_client ? function () {
  return window.performance.now();
} : function () {
  return Date.now();
};
var raf = is_client ? function (cb) {
  return requestAnimationFrame(cb);
} : noop;
var tasks = new Set();
function run_tasks(now) {
  tasks.forEach(function (task) {
    if (!task.c(now)) {
      tasks.delete(task);
      task.f();
    }
  });
  if (tasks.size !== 0) raf(run_tasks);
}
/**
 * Creates a new task that runs on each raf frame
 * until it returns a falsy value or is aborted
 */
function loop(callback) {
  var task;
  if (tasks.size === 0) raf(run_tasks);
  return {
    promise: new Promise(function (fulfill) {
      tasks.add(task = {
        c: callback,
        f: fulfill
      });
    }),
    abort: function abort() {
      tasks.delete(task);
    }
  };
}
function append(target, node) {
  target.appendChild(node);
}
function append_styles(target, style_sheet_id, styles) {
  var append_styles_to = get_root_for_style(target);
  if (!append_styles_to.getElementById(style_sheet_id)) {
    var style = element('style');
    style.id = style_sheet_id;
    style.textContent = styles;
    append_stylesheet(append_styles_to, style);
  }
}
function get_root_for_style(node) {
  if (!node) return document;
  var root = node.getRootNode ? node.getRootNode() : node.ownerDocument;
  if (root && root.host) {
    return root;
  }
  return node.ownerDocument;
}
function append_empty_stylesheet(node) {
  var style_element = element('style');
  append_stylesheet(get_root_for_style(node), style_element);
  return style_element.sheet;
}
function append_stylesheet(node, style) {
  append(node.head || node, style);
}
function insert(target, node, anchor) {
  target.insertBefore(node, anchor || null);
}
function detach(node) {
  node.parentNode.removeChild(node);
}
function destroy_each(iterations, detaching) {
  for (var i = 0; i < iterations.length; i += 1) {
    if (iterations[i]) iterations[i].d(detaching);
  }
}
function element(name) {
  return document.createElement(name);
}
function svg_element(name) {
  return document.createElementNS('http://www.w3.org/2000/svg', name);
}
function text(data) {
  return document.createTextNode(data);
}
function space() {
  return text(' ');
}
function empty() {
  return text('');
}
function listen(node, event, handler, options) {
  node.addEventListener(event, handler, options);
  return function () {
    return node.removeEventListener(event, handler, options);
  };
}
function prevent_default(fn) {
  return function (event) {
    event.preventDefault();
    // @ts-ignore
    return fn.call(this, event);
  };
}
function stop_propagation(fn) {
  return function (event) {
    event.stopPropagation();
    // @ts-ignore
    return fn.call(this, event);
  };
}
function attr(node, attribute, value) {
  if (value == null) node.removeAttribute(attribute);else if (node.getAttribute(attribute) !== value) node.setAttribute(attribute, value);
}
function children(element) {
  return Array.from(element.childNodes);
}
function set_data(text, data) {
  data = '' + data;
  if (text.wholeText !== data) text.data = data;
}
function set_input_value(input, value) {
  input.value = value == null ? '' : value;
}
function set_style(node, key, value, important) {
  if (value === null) {
    node.style.removeProperty(key);
  } else {
    node.style.setProperty(key, value, important ? 'important' : '');
  }
}
function toggle_class(element, name, toggle) {
  element.classList[toggle ? 'add' : 'remove'](name);
}
function custom_event(type, detail, _a) {
  var _b = _a === void 0 ? {} : _a,
    _c = _b.bubbles,
    bubbles = _c === void 0 ? false : _c,
    _d = _b.cancelable,
    cancelable = _d === void 0 ? false : _d;
  var e = document.createEvent('CustomEvent');
  e.initCustomEvent(type, bubbles, cancelable, detail);
  return e;
}
// we need to store the information for multiple documents because a Svelte application could also contain iframes
// https://github.com/sveltejs/svelte/issues/3624
var managed_styles = new Map();
var active = 0;
// https://github.com/darkskyapp/string-hash/blob/master/index.js
function hash(str) {
  var hash = 5381;
  var i = str.length;
  while (i--) {
    hash = (hash << 5) - hash ^ str.charCodeAt(i);
  }
  return hash >>> 0;
}
function create_style_information(doc, node) {
  var info = {
    stylesheet: append_empty_stylesheet(node),
    rules: {}
  };
  managed_styles.set(doc, info);
  return info;
}
function create_rule(node, a, b, duration, delay, ease, fn, uid) {
  if (uid === void 0) {
    uid = 0;
  }
  var step = 16.666 / duration;
  var keyframes = '{\n';
  for (var p = 0; p <= 1; p += step) {
    var t = a + (b - a) * ease(p);
    keyframes += p * 100 + ("%{" + fn(t, 1 - t) + "}\n");
  }
  var rule = keyframes + ("100% {" + fn(b, 1 - b) + "}\n}");
  var name = "__svelte_" + hash(rule) + "_" + uid;
  var doc = get_root_for_style(node);
  var _a = managed_styles.get(doc) || create_style_information(doc, node),
    stylesheet = _a.stylesheet,
    rules = _a.rules;
  if (!rules[name]) {
    rules[name] = true;
    stylesheet.insertRule("@keyframes " + name + " " + rule, stylesheet.cssRules.length);
  }
  var animation = node.style.animation || '';
  node.style.animation = "" + (animation ? animation + ", " : '') + name + " " + duration + "ms linear " + delay + "ms 1 both";
  active += 1;
  return name;
}
function delete_rule(node, name) {
  var previous = (node.style.animation || '').split(', ');
  var next = previous.filter(name ? function (anim) {
    return anim.indexOf(name) < 0;
  } // remove specific animation
  : function (anim) {
    return anim.indexOf('__svelte') === -1;
  } // remove all Svelte animations
  );

  var deleted = previous.length - next.length;
  if (deleted) {
    node.style.animation = next.join(', ');
    active -= deleted;
    if (!active) clear_rules();
  }
}
function clear_rules() {
  raf(function () {
    if (active) return;
    managed_styles.forEach(function (info) {
      var stylesheet = info.stylesheet;
      var i = stylesheet.cssRules.length;
      while (i--) {
        stylesheet.deleteRule(i);
      }
      info.rules = {};
    });
    managed_styles.clear();
  });
}
var current_component;
function set_current_component(component) {
  current_component = component;
}
function get_current_component() {
  if (!current_component) throw new Error('Function called outside component initialization');
  return current_component;
}
function onMount(fn) {
  get_current_component().$$.on_mount.push(fn);
}
function onDestroy(fn) {
  get_current_component().$$.on_destroy.push(fn);
}
var dirty_components = [];
var binding_callbacks = [];
var render_callbacks = [];
var flush_callbacks = [];
var resolved_promise = Promise.resolve();
var update_scheduled = false;
function schedule_update() {
  if (!update_scheduled) {
    update_scheduled = true;
    resolved_promise.then(flush);
  }
}
function add_render_callback(fn) {
  render_callbacks.push(fn);
}
function add_flush_callback(fn) {
  flush_callbacks.push(fn);
}
// flush() calls callbacks in this order:
// 1. All beforeUpdate callbacks, in order: parents before children
// 2. All bind:this callbacks, in reverse order: children before parents.
// 3. All afterUpdate callbacks, in order: parents before children. EXCEPT
//    for afterUpdates called during the initial onMount, which are called in
//    reverse order: children before parents.
// Since callbacks might update component values, which could trigger another
// call to flush(), the following steps guard against this:
// 1. During beforeUpdate, any updated components will be added to the
//    dirty_components array and will cause a reentrant call to flush(). Because
//    the flush index is kept outside the function, the reentrant call will pick
//    up where the earlier call left off and go through all dirty components. The
//    current_component value is saved and restored so that the reentrant call will
//    not interfere with the "parent" flush() call.
// 2. bind:this callbacks cannot trigger new flush() calls.
// 3. During afterUpdate, any updated components will NOT have their afterUpdate
//    callback called a second time; the seen_callbacks set, outside the flush()
//    function, guarantees this behavior.
var seen_callbacks = new Set();
var flushidx = 0; // Do *not* move this inside the flush() function
function flush() {
  var saved_component = current_component;
  do {
    // first, call beforeUpdate functions
    // and update components
    while (flushidx < dirty_components.length) {
      var component = dirty_components[flushidx];
      flushidx++;
      set_current_component(component);
      update(component.$$);
    }
    set_current_component(null);
    dirty_components.length = 0;
    flushidx = 0;
    while (binding_callbacks.length) {
      binding_callbacks.pop()();
    }
    // then, once components are updated, call
    // afterUpdate functions. This may cause
    // subsequent updates...
    for (var i = 0; i < render_callbacks.length; i += 1) {
      var callback = render_callbacks[i];
      if (!seen_callbacks.has(callback)) {
        // ...so guard against infinite loops
        seen_callbacks.add(callback);
        callback();
      }
    }
    render_callbacks.length = 0;
  } while (dirty_components.length);
  while (flush_callbacks.length) {
    flush_callbacks.pop()();
  }
  update_scheduled = false;
  seen_callbacks.clear();
  set_current_component(saved_component);
}
function update($$) {
  if ($$.fragment !== null) {
    $$.update();
    run_all($$.before_update);
    var dirty = $$.dirty;
    $$.dirty = [-1];
    $$.fragment && $$.fragment.p($$.ctx, dirty);
    $$.after_update.forEach(add_render_callback);
  }
}
var promise;
function wait() {
  if (!promise) {
    promise = Promise.resolve();
    promise.then(function () {
      promise = null;
    });
  }
  return promise;
}
function dispatch(node, direction, kind) {
  node.dispatchEvent(custom_event("" + (direction ? 'intro' : 'outro') + kind));
}
var outroing = new Set();
var outros;
function group_outros() {
  outros = {
    r: 0,
    c: [],
    p: outros // parent group
  };
}

function check_outros() {
  if (!outros.r) {
    run_all(outros.c);
  }
  outros = outros.p;
}
function transition_in(block, local) {
  if (block && block.i) {
    outroing.delete(block);
    block.i(local);
  }
}
function transition_out(block, local, detach, callback) {
  if (block && block.o) {
    if (outroing.has(block)) return;
    outroing.add(block);
    outros.c.push(function () {
      outroing.delete(block);
      if (callback) {
        if (detach) block.d(1);
        callback();
      }
    });
    block.o(local);
  }
}
var null_transition = {
  duration: 0
};
function create_bidirectional_transition(node, fn, params, intro) {
  var config = fn(node, params);
  var t = intro ? 0 : 1;
  var running_program = null;
  var pending_program = null;
  var animation_name = null;
  function clear_animation() {
    if (animation_name) delete_rule(node, animation_name);
  }
  function init(program, duration) {
    var d = program.b - t;
    duration *= Math.abs(d);
    return {
      a: t,
      b: program.b,
      d: d,
      duration: duration,
      start: program.start,
      end: program.start + duration,
      group: program.group
    };
  }
  function go(b) {
    var _a = config || null_transition,
      _b = _a.delay,
      delay = _b === void 0 ? 0 : _b,
      _c = _a.duration,
      duration = _c === void 0 ? 300 : _c,
      _d = _a.easing,
      easing = _d === void 0 ? identity : _d,
      _e = _a.tick,
      tick = _e === void 0 ? noop : _e,
      css = _a.css;
    var program = {
      start: now() + delay,
      b: b
    };
    if (!b) {
      // @ts-ignore todo: improve typings
      program.group = outros;
      outros.r += 1;
    }
    if (running_program || pending_program) {
      pending_program = program;
    } else {
      // if this is an intro, and there's a delay, we need to do
      // an initial tick and/or apply CSS animation immediately
      if (css) {
        clear_animation();
        animation_name = create_rule(node, t, b, duration, delay, easing, css);
      }
      if (b) tick(0, 1);
      running_program = init(program, duration);
      add_render_callback(function () {
        return dispatch(node, b, 'start');
      });
      loop(function (now) {
        if (pending_program && now > pending_program.start) {
          running_program = init(pending_program, duration);
          pending_program = null;
          dispatch(node, running_program.b, 'start');
          if (css) {
            clear_animation();
            animation_name = create_rule(node, t, running_program.b, running_program.duration, 0, easing, config.css);
          }
        }
        if (running_program) {
          if (now >= running_program.end) {
            tick(t = running_program.b, 1 - t);
            dispatch(node, running_program.b, 'end');
            if (!pending_program) {
              // we're done
              if (running_program.b) {
                // intro — we can tidy up immediately
                clear_animation();
              } else {
                // outro — needs to be coordinated
                if (! --running_program.group.r) run_all(running_program.group.c);
              }
            }
            running_program = null;
          } else if (now >= running_program.start) {
            var p = now - running_program.start;
            t = running_program.a + running_program.d * easing(p / running_program.duration);
            tick(t, 1 - t);
          }
        }
        return !!(running_program || pending_program);
      });
    }
  }
  return {
    run: function run(b) {
      if (is_function(config)) {
        wait().then(function () {
          // @ts-ignore
          config = config();
          go(b);
        });
      } else {
        go(b);
      }
    },
    end: function end() {
      clear_animation();
      running_program = pending_program = null;
    }
  };
}
function destroy_block(block, lookup) {
  block.d(1);
  lookup.delete(block.key);
}
function update_keyed_each(old_blocks, dirty, get_key, dynamic, ctx, list, lookup, node, destroy, create_each_block, next, get_context) {
  var o = old_blocks.length;
  var n = list.length;
  var i = o;
  var old_indexes = {};
  while (i--) {
    old_indexes[old_blocks[i].key] = i;
  }
  var new_blocks = [];
  var new_lookup = new Map();
  var deltas = new Map();
  i = n;
  while (i--) {
    var child_ctx = get_context(ctx, list, i);
    var key = get_key(child_ctx);
    var block = lookup.get(key);
    if (!block) {
      block = create_each_block(key, child_ctx);
      block.c();
    } else if (dynamic) {
      block.p(child_ctx, dirty);
    }
    new_lookup.set(key, new_blocks[i] = block);
    if (key in old_indexes) deltas.set(key, Math.abs(i - old_indexes[key]));
  }
  var will_move = new Set();
  var did_move = new Set();
  function insert(block) {
    transition_in(block, 1);
    block.m(node, next);
    lookup.set(block.key, block);
    next = block.first;
    n--;
  }
  while (o && n) {
    var new_block = new_blocks[n - 1];
    var old_block = old_blocks[o - 1];
    var new_key = new_block.key;
    var old_key = old_block.key;
    if (new_block === old_block) {
      // do nothing
      next = new_block.first;
      o--;
      n--;
    } else if (!new_lookup.has(old_key)) {
      // remove old block
      destroy(old_block, lookup);
      o--;
    } else if (!lookup.has(new_key) || will_move.has(new_key)) {
      insert(new_block);
    } else if (did_move.has(old_key)) {
      o--;
    } else if (deltas.get(new_key) > deltas.get(old_key)) {
      did_move.add(new_key);
      insert(new_block);
    } else {
      will_move.add(old_key);
      o--;
    }
  }
  while (o--) {
    var old_block = old_blocks[o];
    if (!new_lookup.has(old_block.key)) destroy(old_block, lookup);
  }
  while (n) {
    insert(new_blocks[n - 1]);
  }
  return new_blocks;
}
function bind(component, name, callback) {
  var index = component.$$.props[name];
  if (index !== undefined) {
    component.$$.bound[index] = callback;
    callback(component.$$.ctx[index]);
  }
}
function create_component(block) {
  block && block.c();
}
function mount_component(component, target, anchor, customElement) {
  var _a = component.$$,
    fragment = _a.fragment,
    on_mount = _a.on_mount,
    on_destroy = _a.on_destroy,
    after_update = _a.after_update;
  fragment && fragment.m(target, anchor);
  if (!customElement) {
    // onMount happens before the initial afterUpdate
    add_render_callback(function () {
      var new_on_destroy = on_mount.map(run).filter(is_function);
      if (on_destroy) {
        on_destroy.push.apply(on_destroy, __spread(new_on_destroy));
      } else {
        // Edge case - component was destroyed immediately,
        // most likely as a result of a binding initialising
        run_all(new_on_destroy);
      }
      component.$$.on_mount = [];
    });
  }
  after_update.forEach(add_render_callback);
}
function destroy_component(component, detaching) {
  var $$ = component.$$;
  if ($$.fragment !== null) {
    run_all($$.on_destroy);
    $$.fragment && $$.fragment.d(detaching);
    // TODO null out other refs, including component.$$ (but need to
    // preserve final state?)
    $$.on_destroy = $$.fragment = null;
    $$.ctx = [];
  }
}
function make_dirty(component, i) {
  if (component.$$.dirty[0] === -1) {
    dirty_components.push(component);
    schedule_update();
    component.$$.dirty.fill(0);
  }
  component.$$.dirty[i / 31 | 0] |= 1 << i % 31;
}
function init(component, options, instance, create_fragment, not_equal, props, append_styles, dirty) {
  if (dirty === void 0) {
    dirty = [-1];
  }
  var parent_component = current_component;
  set_current_component(component);
  var $$ = component.$$ = {
    fragment: null,
    ctx: null,
    // state
    props: props,
    update: noop,
    not_equal: not_equal,
    bound: blank_object(),
    // lifecycle
    on_mount: [],
    on_destroy: [],
    on_disconnect: [],
    before_update: [],
    after_update: [],
    context: new Map(options.context || (parent_component ? parent_component.$$.context : [])),
    // everything else
    callbacks: blank_object(),
    dirty: dirty,
    skip_bound: false,
    root: options.target || parent_component.$$.root
  };
  append_styles && append_styles($$.root);
  var ready = false;
  $$.ctx = instance ? instance(component, options.props || {}, function (i, ret) {
    var rest = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      rest[_i - 2] = arguments[_i];
    }
    var value = rest.length ? rest[0] : ret;
    if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
      if (!$$.skip_bound && $$.bound[i]) $$.bound[i](value);
      if (ready) make_dirty(component, i);
    }
    return ret;
  }) : [];
  $$.update();
  ready = true;
  run_all($$.before_update);
  // `false` as a special case of no DOM component
  $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
  if (options.target) {
    if (options.hydrate) {
      var nodes = children(options.target);
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      $$.fragment && $$.fragment.l(nodes);
      nodes.forEach(detach);
    } else {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      $$.fragment && $$.fragment.c();
    }
    if (options.intro) transition_in(component.$$.fragment);
    mount_component(component, options.target, options.anchor, options.customElement);
    flush();
  }
  set_current_component(parent_component);
}
/**
 * Base class for Svelte components. Used when dev=false.
 */
var SvelteComponent = /** @class */function () {
  function SvelteComponent() {}
  SvelteComponent.prototype.$destroy = function () {
    destroy_component(this, 1);
    this.$destroy = noop;
  };
  SvelteComponent.prototype.$on = function (type, callback) {
    var callbacks = this.$$.callbacks[type] || (this.$$.callbacks[type] = []);
    callbacks.push(callback);
    return function () {
      var index = callbacks.indexOf(callback);
      if (index !== -1) callbacks.splice(index, 1);
    };
  };
  SvelteComponent.prototype.$set = function ($$props) {
    if (this.$$set && !is_empty($$props)) {
      this.$$.skip_bound = true;
      this.$$set($$props);
      this.$$.skip_bound = false;
    }
  };
  return SvelteComponent;
}();
var subscriber_queue = [];
/**
 * Create a `Writable` store that allows both updating and reading by subscription.
 * @param {*=}value initial value
 * @param {StartStopNotifier=}start start and stop notifications for subscriptions
 */
function writable(value, start) {
  if (start === void 0) {
    start = noop;
  }
  var stop;
  var subscribers = new Set();
  function set(new_value) {
    var e_1, _a;
    if (safe_not_equal(value, new_value)) {
      value = new_value;
      if (stop) {
        // store is ready
        var run_queue = !subscriber_queue.length;
        try {
          for (var subscribers_1 = __values(subscribers), subscribers_1_1 = subscribers_1.next(); !subscribers_1_1.done; subscribers_1_1 = subscribers_1.next()) {
            var subscriber = subscribers_1_1.value;
            subscriber[1]();
            subscriber_queue.push(subscriber, value);
          }
        } catch (e_1_1) {
          e_1 = {
            error: e_1_1
          };
        } finally {
          try {
            if (subscribers_1_1 && !subscribers_1_1.done && (_a = subscribers_1.return)) _a.call(subscribers_1);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
        if (run_queue) {
          for (var i = 0; i < subscriber_queue.length; i += 2) {
            subscriber_queue[i][0](subscriber_queue[i + 1]);
          }
          subscriber_queue.length = 0;
        }
      }
    }
  }
  function update(fn) {
    set(fn(value));
  }
  function subscribe(run, invalidate) {
    if (invalidate === void 0) {
      invalidate = noop;
    }
    var subscriber = [run, invalidate];
    subscribers.add(subscriber);
    if (subscribers.size === 1) {
      stop = start(set) || noop;
    }
    run(value);
    return function () {
      subscribers.delete(subscriber);
      if (subscribers.size === 0) {
        stop();
        stop = null;
      }
    };
  }
  return {
    set: set,
    update: update,
    subscribe: subscribe
  };
}
var AppStore = writable({
  initialValue: true,
  customFields: [],
  branding: {
    logo: "",
    colors: {
      lightMode: {}
    }
  }
});
var TextStore = writable({
  text: {
    // "login_to_your_account": "Login to your account (T)",
    // "dont_have_an_account": "Don't have an account? (T)",
    // "email_address": "Email Address (T)",
    // "email_error_message": "Please enter a valid email address (T)",
    // "password": "Password (T)",
    // "password_placeholder": "Enter password (T)",
    // "password_error_message": "Minimum 8 characters required (T)",
    // "forgot_password": "Forgot password? (T)",
    // "login": "Log in (T)",
    // "continue_with": "Continue with (T)",
    // "or": "or (T)",
    // "reset_your_password": "Reset your password (T)",
    // "reset_instructions": "We’ll email you a secure link to reset the password for your account. (T)",
    // "reset": "Send link (T)",
    // "reset_already_have_code": "I already have a code (T)",
    // "reset_enter_code": "Enter your 6-digit code (T)",
    // "reset_confirm_reset": "Confirm & Reset (T)",
  }
});
/* src/components/MediaQuery.svelte generated by Svelte v3.48.0 */
var get_default_slot_changes = function get_default_slot_changes(dirty) {
  return {
    matches: dirty & /*matches*/1
  };
};
var get_default_slot_context = function get_default_slot_context(ctx) {
  return {
    matches: /*matches*/ctx[0]
  };
};
function create_fragment$G(ctx) {
  var current;
  var default_slot_template = /*#slots*/ctx[4].default;
  var default_slot = create_slot(default_slot_template, ctx, /*$$scope*/ctx[3], get_default_slot_context);
  return {
    c: function c() {
      if (default_slot) default_slot.c();
    },
    m: function m(target, anchor) {
      if (default_slot) {
        default_slot.m(target, anchor);
      }
      current = true;
    },
    p: function p(ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      if (default_slot) {
        if (default_slot.p && (!current || dirty & /*$$scope, matches*/9)) {
          update_slot_base(default_slot, default_slot_template, ctx, /*$$scope*/ctx[3], !current ? get_all_dirty_from_scope( /*$$scope*/ctx[3]) : get_slot_changes(default_slot_template, /*$$scope*/ctx[3], dirty, get_default_slot_changes), get_default_slot_context);
        }
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(default_slot, local);
      current = true;
    },
    o: function o(local) {
      transition_out(default_slot, local);
      current = false;
    },
    d: function d(detaching) {
      if (default_slot) default_slot.d(detaching);
    }
  };
}
function instance$o($$self, $$props, $$invalidate) {
  var _a = $$props.$$slots,
    slots = _a === void 0 ? {} : _a,
    $$scope = $$props.$$scope;
  var query = $$props.query;
  var mql;
  var mqlListener;
  var wasMounted = false;
  var matches = false;
  onMount(function () {
    $$invalidate(2, wasMounted = true);
    return function () {
      removeActiveListener();
    };
  });
  function addNewListener(query) {
    mql = window.matchMedia(query);
    mqlListener = function mqlListener(v) {
      return $$invalidate(0, matches = v.matches);
    };
    mql.addListener(mqlListener);
    $$invalidate(0, matches = mql.matches);
  }
  function removeActiveListener() {
    if (mql && mqlListener) {
      mql.removeListener(mqlListener);
    }
  }
  $$self.$$set = function ($$props) {
    if ('query' in $$props) $$invalidate(1, query = $$props.query);
    if ('$$scope' in $$props) $$invalidate(3, $$scope = $$props.$$scope);
  };
  $$self.$$.update = function () {
    if ($$self.$$.dirty & /*wasMounted, query*/6) {
      {
        if (wasMounted) {
          removeActiveListener();
          addNewListener(query);
        }
      }
    }
  };
  return [matches, query, wasMounted, $$scope, slots];
}
var MediaQuery = /** @class */function (_super) {
  __extends(MediaQuery, _super);
  function MediaQuery(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$o, create_fragment$G, safe_not_equal, {
      query: 1
    });
    return _this;
  }
  return MediaQuery;
}(SvelteComponent);
/* src/icons/LoadingIcon.svelte generated by Svelte v3.48.0 */
function create_fragment$F(ctx) {
  var svg;
  var path;
  var animateTransform;
  return {
    c: function c() {
      svg = svg_element("svg");
      path = svg_element("path");
      animateTransform = svg_element("animateTransform");
      attr(animateTransform, "attributeName", "transform");
      attr(animateTransform, "attributeType", "xml");
      attr(animateTransform, "dur", "0.6s");
      attr(animateTransform, "from", "0 25 25");
      attr(animateTransform, "repeatCount", "indefinite");
      attr(animateTransform, "to", "360 25 25");
      attr(animateTransform, "type", "rotate");
      attr(path, "fill", "currentColor");
      attr(path, "d", "m43.935 25.145c0-10.318-8.364-18.683-18.683-18.683-10.318 0-18.683 8.365-18.683 18.683h4.068c0-8.071 6.543-14.615 14.615-14.615s14.615 6.543 14.615 14.615h4.068z");
      attr(svg, "width", "40px");
      attr(svg, "height", "40px");
      attr(svg, "enable-background", "new 0 0 50 50");
      set_style(svg, "z-index", "1000000");
      attr(svg, "version", "1.1");
      attr(svg, "viewBox", "0 0 50 50");
      attr(svg, "xml:space", "preserve");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m: function m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
      append(path, animateTransform);
    },
    p: noop,
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(svg);
    }
  };
}
var LoadingIcon = /** @class */function (_super) {
  __extends(LoadingIcon, _super);
  function LoadingIcon(options) {
    var _this = _super.call(this) || this;
    init(_this, options, null, create_fragment$F, safe_not_equal, {});
    return _this;
  }
  return LoadingIcon;
}(SvelteComponent);
/* src/components/Loader.svelte generated by Svelte v3.48.0 */
function create_fragment$E(ctx) {
  var div;
  var loadingicon;
  var current;
  loadingicon = new LoadingIcon({});
  return {
    c: function c() {
      div = element("div");
      create_component(loadingicon.$$.fragment);
      attr(div, "class", "ms__loader");
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      mount_component(loadingicon, div, null);
      current = true;
    },
    p: noop,
    i: function i(local) {
      if (current) return;
      transition_in(loadingicon.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(loadingicon.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div);
      destroy_component(loadingicon);
    }
  };
}
var Loader = /** @class */function (_super) {
  __extends(Loader, _super);
  function Loader(options) {
    var _this = _super.call(this) || this;
    init(_this, options, null, create_fragment$E, safe_not_equal, {});
    return _this;
  }
  return Loader;
}(SvelteComponent);
/* src/icons/CloseIcon.svelte generated by Svelte v3.48.0 */
function create_fragment$D(ctx) {
  var svg;
  var path;
  return {
    c: function c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "shape-rendering", "geometricPrecision");
      attr(path, "d", "M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z");
      attr(svg, "fill", "none");
      set_style(svg, "width", "100%");
      attr(svg, "viewBox", "0 0 14 14");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m: function m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(svg);
    }
  };
}
var CloseIcon = /** @class */function (_super) {
  __extends(CloseIcon, _super);
  function CloseIcon(options) {
    var _this = _super.call(this) || this;
    init(_this, options, null, create_fragment$D, safe_not_equal, {});
    return _this;
  }
  return CloseIcon;
}(SvelteComponent);
/* src/components/CloseButton.svelte generated by Svelte v3.48.0 */
function create_fragment$C(ctx) {
  var div;
  var button;
  var closeicon;
  var current;
  var mounted;
  var dispose;
  closeicon = new CloseIcon({});
  return {
    c: function c() {
      div = element("div");
      button = element("button");
      create_component(closeicon.$$.fragment);
      attr(div, "class", "ms-modal__close");
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      append(div, button);
      mount_component(closeicon, button, null);
      current = true;
      if (!mounted) {
        dispose = listen(button, "click", function () {
          if (is_function( /*closeModal*/ctx[0])) /*closeModal*/
            ctx[0].apply(this, arguments);
        });
        mounted = true;
      }
    },
    p: function p(new_ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      ctx = new_ctx;
    },
    i: function i(local) {
      if (current) return;
      transition_in(closeicon.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(closeicon.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div);
      destroy_component(closeicon);
      mounted = false;
      dispose();
    }
  };
}
function instance$n($$self, $$props, $$invalidate) {
  var closeModal = $$props.closeModal;
  $$self.$$set = function ($$props) {
    if ('closeModal' in $$props) $$invalidate(0, closeModal = $$props.closeModal);
  };
  return [closeModal];
}
var CloseButton = /** @class */function (_super) {
  __extends(CloseButton, _super);
  function CloseButton(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$n, create_fragment$C, safe_not_equal, {
      closeModal: 0
    });
    return _this;
  }
  return CloseButton;
}(SvelteComponent);
/* src/icons/MemberstackIcon.svelte generated by Svelte v3.48.0 */
function create_fragment$B(ctx) {
  var svg;
  var path0;
  var path1;
  var path2;
  var path3;
  var path4;
  var path5;
  return {
    c: function c() {
      svg = svg_element("svg");
      path0 = svg_element("path");
      path1 = svg_element("path");
      path2 = svg_element("path");
      path3 = svg_element("path");
      path4 = svg_element("path");
      path5 = svg_element("path");
      attr(path0, "d", "m259.078 190.582 16.797-39.611c7.315-20.421 26.982-34.665 49.897-34.665 13.187 0 25.344 4.817 34.6 12.818l32.818 73.118c9.656 21.709-.097 47.144-21.786 56.809-21.688 9.666-47.097-.098-56.753-21.807l-38.573-86.723-17 40.088v-.027Z");
      attr(path0, "fill", "#2AA8FF");
      attr(path1, "d", "m111.31 169.64 8.002-18.679c-7.22-20.585-26.82-35.345-49.866-35.345-12.678 0-24.901 4.865-34.007 12.314 6.6063-2.796 14.34-3.575 21.988-3.575 26.999 0 49.435 19.445 53.884 45.285z");
      attr(path2, "d", "m111.31 169.64-28.66 68.126c-9.2762 21.875-34.511 32.081-56.365 22.795-21.853-9.285-32.049-34.545-22.773-56.42l31.925-76.211c6.7448-2.988 14.142-3.575 21.988-3.575 27.086 0 49.537 19.321 53.884 45.285z");
      attr(path2, "fill", "#393939");
      attr(path3, "d", "m197.57 115.46-39.756-89.506c-7.148-16.07-22.929-25.595-39.443-25.537-16.786-0.058576-32.766 9.7896-39.736 26.227l-43.199 101.28c9.1064-7.45 21.329-12.314 34.008-12.314 23.046 0 42.646 14.76 49.866 35.345l0.093 0.337c5.784 1.658 11.893 2.546 18.21 2.546 26.578 0 49.487-15.722 59.958-38.382z");
      attr(path3, "fill", "#017ACE");
      attr(path4, "d", "m197.57 115.46c-10.071 21.796-31.651 37.172-56.934 38.314-1.052 0.05-2.11 0.075-3.175 0.075-6.316 0-12.425-0.888-18.21-2.546l38.425 86.387c3.996 8.986 10.692 15.926 18.706 20.288 1.908 1.196 3.935 2.257 6.073 3.165 21.853 9.286 47.088-0.92 56.364-22.795l37.055-87.381c7.315-20.421 26.982-34.665 49.896-34.665 13.188 0 25.345 4.817 34.601 12.818l-45.994-103.17c-7.148-16.07-22.929-25.595-39.442-25.537-16.786-0.058576-32.767 9.7896-39.737 26.227l-37.628 88.816z");
      attr(path4, "fill", "#AEDEFF");
      attr(path5, "d", "m325.77 116.31c-22.915 0-42.379 13.795-49.694 34.216l8.919 20.052c5.873-25.763 28.931-44.989 56.481-44.989 6.67 0 12.931 1.465 18.894 3.539-9.256-8-21.413-12.818-34.6-12.818z");
      attr(path5, "fill", "#2D91D7");
      set_style(svg, "width", "100%");
      attr(svg, "viewBox", "0 0 397 265");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m: function m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path0);
      append(svg, path1);
      append(svg, path2);
      append(svg, path3);
      append(svg, path4);
      append(svg, path5);
    },
    p: noop,
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(svg);
    }
  };
}
var MemberstackIcon = /** @class */function (_super) {
  __extends(MemberstackIcon, _super);
  function MemberstackIcon(options) {
    var _this = _super.call(this) || this;
    init(_this, options, null, create_fragment$B, safe_not_equal, {});
    return _this;
  }
  return MemberstackIcon;
}(SvelteComponent);
/* src/components/FigureElement.svelte generated by Svelte v3.48.0 */
function create_else_block$7(ctx) {
  var memberstackicon;
  var current;
  memberstackicon = new MemberstackIcon({});
  return {
    c: function c() {
      create_component(memberstackicon.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(memberstackicon, target, anchor);
      current = true;
    },
    p: noop,
    i: function i(local) {
      if (current) return;
      transition_in(memberstackicon.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(memberstackicon.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(memberstackicon, detaching);
    }
  };
}
// (13:2) {#if app.branding.logo}
function create_if_block$i(ctx) {
  var img;
  var img_src_value;
  var img_alt_value;
  return {
    c: function c() {
      img = element("img");
      if (!src_url_equal(img.src, img_src_value = /*app*/ctx[0].branding.logo)) attr(img, "src", img_src_value);
      attr(img, "alt", img_alt_value = /*app*/ctx[0].name);
      attr(img, "data-cy", "logo");
    },
    m: function m(target, anchor) {
      insert(target, img, anchor);
    },
    p: function p(ctx, dirty) {
      if (dirty & /*app*/1 && !src_url_equal(img.src, img_src_value = /*app*/ctx[0].branding.logo)) {
        attr(img, "src", img_src_value);
      }
      if (dirty & /*app*/1 && img_alt_value !== (img_alt_value = /*app*/ctx[0].name)) {
        attr(img, "alt", img_alt_value);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(img);
    }
  };
}
function create_fragment$A(ctx) {
  var figure;
  var current_block_type_index;
  var if_block;
  var current;
  var if_block_creators = [create_if_block$i, create_else_block$7];
  var if_blocks = [];
  function select_block_type(ctx, dirty) {
    if ( /*app*/ctx[0].branding.logo) return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c: function c() {
      figure = element("figure");
      if_block.c();
      attr(figure, "class", "ms-modal__figure");
    },
    m: function m(target, anchor) {
      insert(target, figure, anchor);
      if_blocks[current_block_type_index].m(figure, null);
      current = true;
    },
    p: function p(ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      var previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, function () {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
          if_block.c();
        } else {
          if_block.p(ctx, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(figure, null);
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o: function o(local) {
      transition_out(if_block);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(figure);
      if_blocks[current_block_type_index].d();
    }
  };
}
function instance$m($$self, $$props, $$invalidate) {
  var app = {};
  AppStore.subscribe(function (data) {
    $$invalidate(0, app = data);
  });
  return [app];
}
var FigureElement = /** @class */function (_super) {
  __extends(FigureElement, _super);
  function FigureElement(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$m, create_fragment$A, safe_not_equal, {});
    return _this;
  }
  return FigureElement;
}(SvelteComponent);
/* src/components/SubmitButton.svelte generated by Svelte v3.48.0 */
function create_else_block$6(ctx) {
  var button;
  var loadingicon;
  var current;
  loadingicon = new LoadingIcon({});
  return {
    c: function c() {
      button = element("button");
      create_component(loadingicon.$$.fragment);
      attr(button, "class", "ms-form__button");
      attr(button, "type", "button");
      set_style(button, "background-color", /*buttonColor*/ctx[2]);
      button.disabled = true;
    },
    m: function m(target, anchor) {
      insert(target, button, anchor);
      mount_component(loadingicon, button, null);
      current = true;
    },
    p: function p(ctx, dirty) {
      if (!current || dirty & /*buttonColor*/4) {
        set_style(button, "background-color", /*buttonColor*/ctx[2]);
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(loadingicon.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(loadingicon.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(button);
      destroy_component(loadingicon);
    }
  };
}
// (15:2) {#if !isLoading}
function create_if_block$h(ctx) {
  var button;
  var t;
  return {
    c: function c() {
      button = element("button");
      t = text( /*buttonText*/ctx[0]);
      attr(button, "class", "ms-form__button");
      attr(button, "type", "submit");
      set_style(button, "background-color", /*buttonColor*/ctx[2]);
    },
    m: function m(target, anchor) {
      insert(target, button, anchor);
      append(button, t);
    },
    p: function p(ctx, dirty) {
      if (dirty & /*buttonText*/1) set_data(t, /*buttonText*/ctx[0]);
      if (dirty & /*buttonColor*/4) {
        set_style(button, "background-color", /*buttonColor*/ctx[2]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(button);
    }
  };
}
function create_fragment$z(ctx) {
  var div;
  var current_block_type_index;
  var if_block;
  var current;
  var if_block_creators = [create_if_block$h, create_else_block$6];
  var if_blocks = [];
  function select_block_type(ctx, dirty) {
    if (!ctx[1]) return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c: function c() {
      div = element("div");
      if_block.c();
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      if_blocks[current_block_type_index].m(div, null);
      current = true;
    },
    p: function p(ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      var previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, function () {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
          if_block.c();
        } else {
          if_block.p(ctx, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(div, null);
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o: function o(local) {
      transition_out(if_block);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div);
      if_blocks[current_block_type_index].d();
    }
  };
}
function instance$l($$self, $$props, $$invalidate) {
  var $app;
  component_subscribe($$self, AppStore, function ($$value) {
    return $$invalidate(3, $app = $$value);
  });
  var _a = $$props.buttonText,
    buttonText = _a === void 0 ? "Submit" : _a;
  var _b = $$props.isLoading,
    isLoading = _b === void 0 ? false : _b;
  var buttonColor = "rgb(41, 98, 255)";
  if ($app.branding.colors.lightMode.primaryButton) {
    buttonColor = $app.branding.colors.lightMode.primaryButton;
  }
  $$self.$$set = function ($$props) {
    if ('buttonText' in $$props) $$invalidate(0, buttonText = $$props.buttonText);
    if ('isLoading' in $$props) $$invalidate(1, isLoading = $$props.isLoading);
  };
  return [buttonText, isLoading, buttonColor];
}
var SubmitButton = /** @class */function (_super) {
  __extends(SubmitButton, _super);
  function SubmitButton(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$l, create_fragment$z, safe_not_equal, {
      buttonText: 0,
      isLoading: 1
    });
    return _this;
  }
  return SubmitButton;
}(SvelteComponent);
/* src/icons/ErrorIcon.svelte generated by Svelte v3.48.0 */
function create_fragment$y(ctx) {
  var svg;
  var path;
  return {
    c: function c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "m10 0c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10zm1 15h-2v-2h2v2zm0-4h-2v-6h2v6z");
      attr(svg, "fill", "none");
      attr(svg, "viewBox", "0 0 20 20");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m: function m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(svg);
    }
  };
}
var ErrorIcon = /** @class */function (_super) {
  __extends(ErrorIcon, _super);
  function ErrorIcon(options) {
    var _this = _super.call(this) || this;
    init(_this, options, null, create_fragment$y, safe_not_equal, {});
    return _this;
  }
  return ErrorIcon;
}(SvelteComponent);
/* src/components/EmailInput.svelte generated by Svelte v3.48.0 */
function create_if_block$g(ctx) {
  var div;
  var erroricon;
  var t0;
  var t1;
  var current;
  erroricon = new ErrorIcon({});
  return {
    c: function c() {
      div = element("div");
      create_component(erroricon.$$.fragment);
      t0 = space();
      t1 = text( /*errorMessage*/ctx[4]);
      attr(div, "class", "ms-form__error");
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      mount_component(erroricon, div, null);
      append(div, t0);
      append(div, t1);
      current = true;
    },
    p: noop,
    i: function i(local) {
      if (current) return;
      transition_in(erroricon.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(erroricon.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div);
      destroy_component(erroricon);
    }
  };
}
function create_fragment$x(ctx) {
  var div;
  var label;
  var t1;
  var input;
  var t2;
  var current;
  var mounted;
  var dispose;
  var if_block = /*inputError*/ctx[2] && create_if_block$g(ctx);
  return {
    c: function c() {
      div = element("div");
      label = element("label");
      label.textContent = "" + ctx[3];
      t1 = space();
      input = element("input");
      t2 = space();
      if (if_block) if_block.c();
      attr(label, "class", "ms-form__label");
      attr(label, "for", "eml");
      attr(input, "class", "ms-form__input");
      attr(input, "type", "email");
      attr(input, "placeholder", /*placeholder*/ctx[1]);
      attr(input, "name", "eml");
      input.required = true;
      attr(div, "class", "ms-form__group");
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      append(div, label);
      append(div, t1);
      append(div, input);
      set_input_value(input, /*emailValue*/ctx[0]);
      append(div, t2);
      if (if_block) if_block.m(div, null);
      current = true;
      if (!mounted) {
        dispose = [listen(input, "change", /*validateField*/ctx[5]), listen(input, "input", /*input_input_handler*/ctx[7])];
        mounted = true;
      }
    },
    p: function p(ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      if (!current || dirty & /*placeholder*/2) {
        attr(input, "placeholder", /*placeholder*/ctx[1]);
      }
      if (dirty & /*emailValue*/1 && input.value !== /*emailValue*/ctx[0]) {
        set_input_value(input, /*emailValue*/ctx[0]);
      }
      if ( /*inputError*/ctx[2]) {
        if (if_block) {
          if_block.p(ctx, dirty);
          if (dirty & /*inputError*/4) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$g(ctx);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(div, null);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, function () {
          if_block = null;
        });
        check_outros();
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o: function o(local) {
      transition_out(if_block);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div);
      if (if_block) if_block.d();
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$k($$self, $$props, $$invalidate) {
  var $textStore;
  component_subscribe($$self, TextStore, function ($$value) {
    return $$invalidate(8, $textStore = $$value);
  });
  var _a = $$props.emailInputValid,
    emailInputValid = _a === void 0 ? false : _a;
  var emailValue = $$props.emailValue;
  var _b = $$props.placeholder,
    placeholder = _b === void 0 ? "example@domain.com" : _b;
  var text = $textStore.text;
  var emailLabel = text["email_address"] || "Email Address";
  var inputError = false;
  var errorMessage = text["email_error_message"] || "Please enter a valid email address";
  var validateField = function validateField(e) {
    var emailInput = e.target;
    var hasValidEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(emailInput.value);
    if (!hasValidEmail && e.target.value.length > 0) {
      $$invalidate(6, emailInputValid = false);
      $$invalidate(2, inputError = true);
    } else {
      $$invalidate(6, emailInputValid = true);
      $$invalidate(2, inputError = false);
    }
  };
  function input_input_handler() {
    emailValue = this.value;
    $$invalidate(0, emailValue);
  }
  $$self.$$set = function ($$props) {
    if ('emailInputValid' in $$props) $$invalidate(6, emailInputValid = $$props.emailInputValid);
    if ('emailValue' in $$props) $$invalidate(0, emailValue = $$props.emailValue);
    if ('placeholder' in $$props) $$invalidate(1, placeholder = $$props.placeholder);
  };
  return [emailValue, placeholder, inputError, emailLabel, errorMessage, validateField, emailInputValid, input_input_handler];
}
var EmailInput = /** @class */function (_super) {
  __extends(EmailInput, _super);
  function EmailInput(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$k, create_fragment$x, safe_not_equal, {
      emailInputValid: 6,
      emailValue: 0,
      placeholder: 1
    });
    return _this;
  }
  return EmailInput;
}(SvelteComponent);
/* src/icons/EyeIcon.svelte generated by Svelte v3.48.0 */
function create_fragment$w(ctx) {
  var svg;
  var path;
  return {
    c: function c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "m11 0.5c-5 0-9.27 3.11-11 7.5 1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zm0 12.5c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z");
      attr(svg, "class", "ms-form__eye");
      attr(svg, "fill", "none");
      attr(svg, "viewBox", "0 0 22 16");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m: function m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(svg);
    }
  };
}
var EyeIcon = /** @class */function (_super) {
  __extends(EyeIcon, _super);
  function EyeIcon(options) {
    var _this = _super.call(this) || this;
    init(_this, options, null, create_fragment$w, safe_not_equal, {});
    return _this;
  }
  return EyeIcon;
}(SvelteComponent);
/* src/icons/EyeSlashIcon.svelte generated by Svelte v3.48.0 */
function create_fragment$v(ctx) {
  var svg;
  var path;
  return {
    c: function c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "m11 4c2.76 0 5 2.24 5 5 0 0.65-0.13 1.26-0.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74 0.25-3.98 0.7l2.16 2.16c0.57-0.23 1.18-0.36 1.83-0.36zm-10-2.73 2.74 2.74c-1.66 1.29-2.96 3.01-3.74 4.99 1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-0.3 4.38-0.84l0.42 0.42 2.93 2.92 1.27-1.27-17.73-17.73-1.27 1.27zm5.53 5.53 1.55 1.55c-0.05 0.21-0.08 0.43-0.08 0.65 0 1.66 1.34 3 3 3 0.22 0 0.44-0.03 0.65-0.08l1.55 1.55c-0.67 0.33-1.41 0.53-2.2 0.53-2.76 0-5-2.24-5-5 0-0.79 0.2-1.53 0.53-2.2zm4.31-0.78 3.15 3.15 0.02-0.16c0-1.66-1.34-3-3-3l-0.17 0.01z");
      attr(svg, "class", "ms-form__eye-slash");
      attr(svg, "fill", "none");
      attr(svg, "viewBox", "0 0 22 19");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m: function m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(svg);
    }
  };
}
var EyeSlashIcon = /** @class */function (_super) {
  __extends(EyeSlashIcon, _super);
  function EyeSlashIcon(options) {
    var _this = _super.call(this) || this;
    init(_this, options, null, create_fragment$v, safe_not_equal, {});
    return _this;
  }
  return EyeSlashIcon;
}(SvelteComponent);
/* src/components/PasswordInput.svelte generated by Svelte v3.48.0 */
function create_if_block_2$6(ctx) {
  var div;
  var button;
  var mounted;
  var dispose;
  return {
    c: function c() {
      div = element("div");
      button = element("button");
      button.textContent = "" + (ctx[8]["forgot_password"] || "Forgot Password?");
      attr(button, "data-cy", "forgot-password-btn");
      attr(button, "class", "ms-form__button ms-form__button--text");
      attr(button, "tabindex", "-1");
      attr(button, "type", "button");
      attr(div, "class", "ms-form__label ms-form__label--right");
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      append(div, button);
      if (!mounted) {
        dispose = listen(button, "click", /*click_handler*/ctx[14]);
        mounted = true;
      }
    },
    p: noop,
    d: function d(detaching) {
      if (detaching) detach(div);
      mounted = false;
      dispose();
    }
  };
}
// (60:6) {:else}
function create_else_block$5(ctx) {
  var eyeslashicon;
  var current;
  eyeslashicon = new EyeSlashIcon({});
  return {
    c: function c() {
      create_component(eyeslashicon.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(eyeslashicon, target, anchor);
      current = true;
    },
    i: function i(local) {
      if (current) return;
      transition_in(eyeslashicon.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(eyeslashicon.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(eyeslashicon, detaching);
    }
  };
}
// (58:6) {#if !passwordVisible}
function create_if_block_1$b(ctx) {
  var eyeicon;
  var current;
  eyeicon = new EyeIcon({});
  return {
    c: function c() {
      create_component(eyeicon.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(eyeicon, target, anchor);
      current = true;
    },
    i: function i(local) {
      if (current) return;
      transition_in(eyeicon.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(eyeicon.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(eyeicon, detaching);
    }
  };
}
// (65:2) {#if inputError}
function create_if_block$f(ctx) {
  var div;
  var erroricon;
  var t0;
  var t1;
  var current;
  erroricon = new ErrorIcon({});
  return {
    c: function c() {
      div = element("div");
      create_component(erroricon.$$.fragment);
      t0 = space();
      t1 = text( /*errorMessage*/ctx[9]);
      attr(div, "class", "ms-form__error");
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      mount_component(erroricon, div, null);
      append(div, t0);
      append(div, t1);
      current = true;
    },
    p: noop,
    i: function i(local) {
      if (current) return;
      transition_in(erroricon.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(erroricon.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div);
      destroy_component(erroricon);
    }
  };
}
function create_fragment$u(ctx) {
  var div3;
  var div0;
  var label;
  var t0;
  var t1;
  var t2;
  var div2;
  var input;
  var input_value_value;
  var t3;
  var div1;
  var current_block_type_index;
  var if_block1;
  var t4;
  var current;
  var mounted;
  var dispose;
  var if_block0 = /*showForgotPasswordLabel*/ctx[2] && create_if_block_2$6(ctx);
  var if_block_creators = [create_if_block_1$b, create_else_block$5];
  var if_blocks = [];
  function select_block_type(ctx, dirty) {
    if (!ctx[5]) return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  var if_block2 = /*inputError*/ctx[6] && create_if_block$f(ctx);
  return {
    c: function c() {
      div3 = element("div");
      div0 = element("div");
      label = element("label");
      t0 = text( /*passwordLabel*/ctx[3]);
      t1 = space();
      if (if_block0) if_block0.c();
      t2 = space();
      div2 = element("div");
      input = element("input");
      t3 = space();
      div1 = element("div");
      if_block1.c();
      t4 = space();
      if (if_block2) if_block2.c();
      attr(label, "class", "ms-form__label");
      attr(label, "for", "psw");
      attr(div0, "class", "ms-form__flex");
      attr(input, "class", "ms-form__input ms-form__input--password");
      attr(input, "type", /*type*/ctx[7]);
      attr(input, "placeholder", /*passwordPlaceholder*/ctx[4]);
      input.value = input_value_value = /*passwordValue*/ctx[0] || "";
      attr(input, "name", "psw");
      attr(input, "autocomplete", "off");
      input.required = true;
      attr(div1, "class", "ms-form__show-toggle");
      attr(div1, "id", "togglePassword");
      attr(div2, "class", "ms-form__password-container");
      attr(div3, "class", "ms-form__group");
    },
    m: function m(target, anchor) {
      insert(target, div3, anchor);
      append(div3, div0);
      append(div0, label);
      append(label, t0);
      append(div0, t1);
      if (if_block0) if_block0.m(div0, null);
      append(div3, t2);
      append(div3, div2);
      append(div2, input);
      append(div2, t3);
      append(div2, div1);
      if_blocks[current_block_type_index].m(div1, null);
      append(div3, t4);
      if (if_block2) if_block2.m(div3, null);
      current = true;
      if (!mounted) {
        dispose = [listen(input, "input", /*handleInput*/ctx[11]), listen(input, "change", /*validateField*/ctx[12]), listen(div1, "click", /*togglePassword*/ctx[10])];
        mounted = true;
      }
    },
    p: function p(ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      if (!current || dirty & /*passwordLabel*/8) set_data(t0, /*passwordLabel*/ctx[3]);
      if ( /*showForgotPasswordLabel*/ctx[2]) {
        if (if_block0) {
          if_block0.p(ctx, dirty);
        } else {
          if_block0 = create_if_block_2$6(ctx);
          if_block0.c();
          if_block0.m(div0, null);
        }
      } else if (if_block0) {
        if_block0.d(1);
        if_block0 = null;
      }
      if (!current || dirty & /*type*/128) {
        attr(input, "type", /*type*/ctx[7]);
      }
      if (!current || dirty & /*passwordPlaceholder*/16) {
        attr(input, "placeholder", /*passwordPlaceholder*/ctx[4]);
      }
      if (!current || dirty & /*passwordValue*/1 && input_value_value !== (input_value_value = /*passwordValue*/ctx[0] || "") && input.value !== input_value_value) {
        input.value = input_value_value;
      }
      var previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx);
      if (current_block_type_index !== previous_block_index) {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, function () {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block1 = if_blocks[current_block_type_index];
        if (!if_block1) {
          if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
          if_block1.c();
        }
        transition_in(if_block1, 1);
        if_block1.m(div1, null);
      }
      if ( /*inputError*/ctx[6]) {
        if (if_block2) {
          if_block2.p(ctx, dirty);
          if (dirty & /*inputError*/64) {
            transition_in(if_block2, 1);
          }
        } else {
          if_block2 = create_if_block$f(ctx);
          if_block2.c();
          transition_in(if_block2, 1);
          if_block2.m(div3, null);
        }
      } else if (if_block2) {
        group_outros();
        transition_out(if_block2, 1, 1, function () {
          if_block2 = null;
        });
        check_outros();
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(if_block1);
      transition_in(if_block2);
      current = true;
    },
    o: function o(local) {
      transition_out(if_block1);
      transition_out(if_block2);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div3);
      if (if_block0) if_block0.d();
      if_blocks[current_block_type_index].d();
      if (if_block2) if_block2.d();
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$j($$self, $$props, $$invalidate) {
  var type;
  var $textStore;
  component_subscribe($$self, TextStore, function ($$value) {
    return $$invalidate(15, $textStore = $$value);
  });
  var text = $textStore.text;
  var _a = $$props.showForgotPasswordLabel,
    showForgotPasswordLabel = _a === void 0 ? false : _a;
  var _b = $$props.passwordInputValid,
    passwordInputValid = _b === void 0 ? false : _b;
  var _c = $$props.passwordLabel,
    passwordLabel = _c === void 0 ? text["password"] || "Password" : _c;
  var _d = $$props.passwordPlaceholder,
    passwordPlaceholder = _d === void 0 ? "Enter Password" : _d;
  var passwordValue = $$props.passwordValue;
  var display = $$props.display;
  var inputError = false;
  var errorMessage = text["password_error_message"] || "Minimum 8 characters required";
  var passwordVisible = false;
  function togglePassword() {
    $$invalidate(5, passwordVisible = !passwordVisible);
  }
  function handleInput(e) {
    $$invalidate(0, passwordValue = e.target.value);
  }
  var validateField = function validateField(e) {
    var hasValidPassword = e.target.value.length >= 8 ? true : false;
    if (!hasValidPassword) {
      $$invalidate(13, passwordInputValid = false);
      $$invalidate(6, inputError = true);
    } else {
      $$invalidate(13, passwordInputValid = true);
      $$invalidate(6, inputError = false);
    }
  };
  var click_handler = function click_handler() {
    return $$invalidate(1, display = "forgot_password");
  };
  $$self.$$set = function ($$props) {
    if ('showForgotPasswordLabel' in $$props) $$invalidate(2, showForgotPasswordLabel = $$props.showForgotPasswordLabel);
    if ('passwordInputValid' in $$props) $$invalidate(13, passwordInputValid = $$props.passwordInputValid);
    if ('passwordLabel' in $$props) $$invalidate(3, passwordLabel = $$props.passwordLabel);
    if ('passwordPlaceholder' in $$props) $$invalidate(4, passwordPlaceholder = $$props.passwordPlaceholder);
    if ('passwordValue' in $$props) $$invalidate(0, passwordValue = $$props.passwordValue);
    if ('display' in $$props) $$invalidate(1, display = $$props.display);
  };
  $$self.$$.update = function () {
    if ($$self.$$.dirty & /*passwordVisible*/32) {
      $$invalidate(7, type = passwordVisible ? "text" : "password");
    }
  };
  return [passwordValue, display, showForgotPasswordLabel, passwordLabel, passwordPlaceholder, passwordVisible, inputError, type, text, errorMessage, togglePassword, handleInput, validateField, passwordInputValid, click_handler];
}
var PasswordInput = /** @class */function (_super) {
  __extends(PasswordInput, _super);
  function PasswordInput(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$j, create_fragment$u, safe_not_equal, {
      showForgotPasswordLabel: 2,
      passwordInputValid: 13,
      passwordLabel: 3,
      passwordPlaceholder: 4,
      passwordValue: 0,
      display: 1
    });
    return _this;
  }
  return PasswordInput;
}(SvelteComponent);
/* src/icons/SecuredIcon.svelte generated by Svelte v3.48.0 */
function create_fragment$t(ctx) {
  var svg;
  var path;
  return {
    c: function c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "shape-rendering", "geometricPrecision");
      attr(path, "d", "m9 0-9 4v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12v-6l-9-4zm-2 16-4-4 1.41-1.41 2.59 2.58 6.59-6.59 1.41 1.42-8 8z");
      attr(svg, "fill", "none");
      attr(svg, "viewBox", "0 0 18 22");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m: function m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(svg);
    }
  };
}
var SecuredIcon = /** @class */function (_super) {
  __extends(SecuredIcon, _super);
  function SecuredIcon(options) {
    var _this = _super.call(this) || this;
    init(_this, options, null, create_fragment$t, safe_not_equal, {});
    return _this;
  }
  return SecuredIcon;
}(SvelteComponent);
/* src/components/ModalFooter.svelte generated by Svelte v3.48.0 */
function create_fragment$s(ctx) {
  var div;
  var a;
  var securedicon;
  var t;
  var current;
  securedicon = new SecuredIcon({});
  return {
    c: function c() {
      div = element("div");
      a = element("a");
      create_component(securedicon.$$.fragment);
      t = text(" Secured by Memberstack");
      attr(a, "href", "https://www.memberstack.com");
      attr(a, "target", "_blank");
      attr(div, "class", "ms-modal__footer");
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      append(div, a);
      mount_component(securedicon, a, null);
      append(a, t);
      current = true;
    },
    p: noop,
    i: function i(local) {
      if (current) return;
      transition_in(securedicon.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(securedicon.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div);
      destroy_component(securedicon);
    }
  };
}
var ModalFooter = /** @class */function (_super) {
  __extends(ModalFooter, _super);
  function ModalFooter(options) {
    var _this = _super.call(this) || this;
    init(_this, options, null, create_fragment$s, safe_not_equal, {});
    return _this;
  }
  return ModalFooter;
}(SvelteComponent);
/* src/modals/LoginModal.svelte generated by Svelte v3.48.0 */
function get_each_context$6(ctx, list, i) {
  var child_ctx = ctx.slice();
  child_ctx[17] = list[i];
  return child_ctx;
}
// (80:6) {#if params && params.signup && params.signup.plans}
function create_if_block_1$a(ctx) {
  var div;
  var button;
  var mounted;
  var dispose;
  return {
    c: function c() {
      div = element("div");
      button = element("button");
      button.textContent = "" + (ctx[7]["dont_have_an_account"] || "Don't have an account?");
      attr(button, "class", "ms-form__button ms-form__button--text");
      attr(button, "type", "button");
      attr(div, "class", "ms-form__flex ms-form__flex--centered");
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      append(div, button);
      if (!mounted) {
        dispose = listen(button, "click", /*click_handler*/ctx[14]);
        mounted = true;
      }
    },
    p: noop,
    d: function d(detaching) {
      if (detaching) detach(div);
      mounted = false;
      dispose();
    }
  };
}
// (87:4) {#if $app.authProviders.length > 0}
function create_if_block$e(ctx) {
  var div4;
  var div3;
  var div0;
  var t0;
  var div1;
  var t2;
  var div2;
  var t3;
  var each_value = /*$app*/ctx[6].authProviders;
  var each_blocks = [];
  for (var i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$6(get_each_context$6(ctx, each_value, i));
  }
  return {
    c: function c() {
      div4 = element("div");
      div3 = element("div");
      div0 = element("div");
      t0 = space();
      div1 = element("div");
      div1.textContent = "" + (ctx[7]["or"] || "or");
      t2 = space();
      div2 = element("div");
      t3 = space();
      for (var i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      attr(div0, "class", "ms-modal__divider-line");
      attr(div1, "class", "ms-modal__divider-text");
      attr(div2, "class", "ms-modal__divider-line");
      attr(div3, "class", "ms-modal__social-divider");
      attr(div4, "class", "ms-modal__social");
    },
    m: function m(target, anchor) {
      insert(target, div4, anchor);
      append(div4, div3);
      append(div3, div0);
      append(div3, t0);
      append(div3, div1);
      append(div3, t2);
      append(div3, div2);
      append(div4, t3);
      for (var i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].m(div4, null);
      }
    },
    p: function p(ctx, dirty) {
      if (dirty & /*submitLoginWithProvider, $app, text*/704) {
        each_value = /*$app*/ctx[6].authProviders;
        var i = void 0;
        for (i = 0; i < each_value.length; i += 1) {
          var child_ctx = get_each_context$6(ctx, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
          } else {
            each_blocks[i] = create_each_block$6(child_ctx);
            each_blocks[i].c();
            each_blocks[i].m(div4, null);
          }
        }
        for (; i < each_blocks.length; i += 1) {
          each_blocks[i].d(1);
        }
        each_blocks.length = each_value.length;
      }
    },
    d: function d(detaching) {
      if (detaching) detach(div4);
      destroy_each(each_blocks, detaching);
    }
  };
}
// (94:8) {#each $app.authProviders as provider}
function create_each_block$6(ctx) {
  var div;
  var button;
  var img;
  var img_src_value;
  var img_alt_value;
  var t0;
  var span;
  var t1_value = ( /*text*/ctx[7]["continue_with"] || "Continue with") + "";
  var t1;
  var t2;
  var t3_value = /*provider*/ctx[17].name + "";
  var t3;
  var t4;
  var mounted;
  var dispose;
  function click_handler_1() {
    return (/*click_handler_1*/ctx[15]( /*provider*/ctx[17])
    );
  }
  return {
    c: function c() {
      div = element("div");
      button = element("button");
      img = element("img");
      t0 = space();
      span = element("span");
      t1 = text(t1_value);
      t2 = space();
      t3 = text(t3_value);
      t4 = space();
      if (!src_url_equal(img.src, img_src_value = /*provider*/ctx[17].icon)) attr(img, "src", img_src_value);
      attr(img, "alt", img_alt_value = /*provider*/ctx[17].name);
      attr(button, "class", "ms-modal__social-button");
      attr(button, "type", "button");
      attr(div, "class", "ms-modal__social-buttons");
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      append(div, button);
      append(button, img);
      append(button, t0);
      append(button, span);
      append(span, t1);
      append(span, t2);
      append(span, t3);
      append(div, t4);
      if (!mounted) {
        dispose = listen(button, "click", click_handler_1);
        mounted = true;
      }
    },
    p: function p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty & /*$app*/64 && !src_url_equal(img.src, img_src_value = /*provider*/ctx[17].icon)) {
        attr(img, "src", img_src_value);
      }
      if (dirty & /*$app*/64 && img_alt_value !== (img_alt_value = /*provider*/ctx[17].name)) {
        attr(img, "alt", img_alt_value);
      }
      if (dirty & /*$app*/64 && t3_value !== (t3_value = /*provider*/ctx[17].name + "")) set_data(t3, t3_value);
    },
    d: function d(detaching) {
      if (detaching) detach(div);
      mounted = false;
      dispose();
    }
  };
}
function create_fragment$r(ctx) {
  var div1;
  var closebutton;
  var t0;
  var div0;
  var figureelement;
  var t1;
  var h2;
  var t3;
  var form;
  var emailinput;
  var updating_emailInputValid;
  var t4;
  var passwordinput;
  var updating_passwordInputValid;
  var updating_display;
  var t5;
  var submitbutton;
  var t6;
  var t7;
  var t8;
  var modalfooter;
  var current;
  var mounted;
  var dispose;
  closebutton = new CloseButton({
    props: {
      closeModal: /*closeModal*/ctx[1]
    }
  });
  figureelement = new FigureElement({});
  function emailinput_emailInputValid_binding(value) {
    /*emailinput_emailInputValid_binding*/ctx[11](value);
  }
  var emailinput_props = {
    placeholder: /*text*/ctx[7]["login_email_placeholder"]
  };
  if ( /*emailInputValid*/ctx[4] !== void 0) {
    emailinput_props.emailInputValid = /*emailInputValid*/ctx[4];
  }
  emailinput = new EmailInput({
    props: emailinput_props
  });
  binding_callbacks.push(function () {
    return bind(emailinput, 'emailInputValid', emailinput_emailInputValid_binding);
  });
  function passwordinput_passwordInputValid_binding(value) {
    /*passwordinput_passwordInputValid_binding*/ctx[12](value);
  }
  function passwordinput_display_binding(value) {
    /*passwordinput_display_binding*/ctx[13](value);
  }
  var passwordinput_props = {
    passwordPlaceholder: /*text*/ctx[7]["login_password_placeholder"],
    "||": true,
    showForgotPasswordLabel: true
  };
  if ( /*passwordInputValid*/ctx[5] !== void 0) {
    passwordinput_props.passwordInputValid = /*passwordInputValid*/ctx[5];
  }
  if ( /*display*/ctx[0] !== void 0) {
    passwordinput_props.display = /*display*/ctx[0];
  }
  passwordinput = new PasswordInput({
    props: passwordinput_props
  });
  binding_callbacks.push(function () {
    return bind(passwordinput, 'passwordInputValid', passwordinput_passwordInputValid_binding);
  });
  binding_callbacks.push(function () {
    return bind(passwordinput, 'display', passwordinput_display_binding);
  });
  submitbutton = new SubmitButton({
    props: {
      buttonText: /*text*/ctx[7]["login"] || "Log in",
      isLoading: /*showLoader*/ctx[3]
    }
  });
  var if_block0 = /*params*/ctx[2] && /*params*/ctx[2].signup && /*params*/ctx[2].signup.plans && create_if_block_1$a(ctx);
  var if_block1 = /*$app*/ctx[6].authProviders.length > 0 && create_if_block$e(ctx);
  modalfooter = new ModalFooter({});
  return {
    c: function c() {
      div1 = element("div");
      create_component(closebutton.$$.fragment);
      t0 = space();
      div0 = element("div");
      create_component(figureelement.$$.fragment);
      t1 = space();
      h2 = element("h2");
      h2.textContent = "" + (ctx[7]["login_to_your_account"] || "Login to your account");
      t3 = space();
      form = element("form");
      create_component(emailinput.$$.fragment);
      t4 = space();
      create_component(passwordinput.$$.fragment);
      t5 = space();
      create_component(submitbutton.$$.fragment);
      t6 = space();
      if (if_block0) if_block0.c();
      t7 = space();
      if (if_block1) if_block1.c();
      t8 = space();
      create_component(modalfooter.$$.fragment);
      attr(h2, "class", "ms-modal__title");
      attr(form, "class", "ms-form");
      attr(form, "action", "");
      attr(form, "method", "post");
      attr(form, "autocomplete", "off");
      attr(div0, "class", "ms-modal__content");
      attr(div1, "class", "ms-modal");
      attr(div1, "id", "LoginModal");
    },
    m: function m(target, anchor) {
      insert(target, div1, anchor);
      mount_component(closebutton, div1, null);
      append(div1, t0);
      append(div1, div0);
      mount_component(figureelement, div0, null);
      append(div0, t1);
      append(div0, h2);
      append(div0, t3);
      append(div0, form);
      mount_component(emailinput, form, null);
      append(form, t4);
      mount_component(passwordinput, form, null);
      append(form, t5);
      mount_component(submitbutton, form, null);
      append(form, t6);
      if (if_block0) if_block0.m(form, null);
      append(div0, t7);
      if (if_block1) if_block1.m(div0, null);
      append(div1, t8);
      mount_component(modalfooter, div1, null);
      current = true;
      if (!mounted) {
        dispose = listen(form, "submit", stop_propagation(prevent_default( /*submitLogin*/ctx[8])));
        mounted = true;
      }
    },
    p: function p(ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      var closebutton_changes = {};
      if (dirty & /*closeModal*/2) closebutton_changes.closeModal = /*closeModal*/ctx[1];
      closebutton.$set(closebutton_changes);
      var emailinput_changes = {};
      if (!updating_emailInputValid && dirty & /*emailInputValid*/16) {
        updating_emailInputValid = true;
        emailinput_changes.emailInputValid = /*emailInputValid*/ctx[4];
        add_flush_callback(function () {
          return updating_emailInputValid = false;
        });
      }
      emailinput.$set(emailinput_changes);
      var passwordinput_changes = {};
      if (!updating_passwordInputValid && dirty & /*passwordInputValid*/32) {
        updating_passwordInputValid = true;
        passwordinput_changes.passwordInputValid = /*passwordInputValid*/ctx[5];
        add_flush_callback(function () {
          return updating_passwordInputValid = false;
        });
      }
      if (!updating_display && dirty & /*display*/1) {
        updating_display = true;
        passwordinput_changes.display = /*display*/ctx[0];
        add_flush_callback(function () {
          return updating_display = false;
        });
      }
      passwordinput.$set(passwordinput_changes);
      var submitbutton_changes = {};
      if (dirty & /*showLoader*/8) submitbutton_changes.isLoading = /*showLoader*/ctx[3];
      submitbutton.$set(submitbutton_changes);
      if ( /*params*/ctx[2] && /*params*/ctx[2].signup && /*params*/ctx[2].signup.plans) {
        if (if_block0) {
          if_block0.p(ctx, dirty);
        } else {
          if_block0 = create_if_block_1$a(ctx);
          if_block0.c();
          if_block0.m(form, null);
        }
      } else if (if_block0) {
        if_block0.d(1);
        if_block0 = null;
      }
      if ( /*$app*/ctx[6].authProviders.length > 0) {
        if (if_block1) {
          if_block1.p(ctx, dirty);
        } else {
          if_block1 = create_if_block$e(ctx);
          if_block1.c();
          if_block1.m(div0, null);
        }
      } else if (if_block1) {
        if_block1.d(1);
        if_block1 = null;
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(closebutton.$$.fragment, local);
      transition_in(figureelement.$$.fragment, local);
      transition_in(emailinput.$$.fragment, local);
      transition_in(passwordinput.$$.fragment, local);
      transition_in(submitbutton.$$.fragment, local);
      transition_in(modalfooter.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(closebutton.$$.fragment, local);
      transition_out(figureelement.$$.fragment, local);
      transition_out(emailinput.$$.fragment, local);
      transition_out(passwordinput.$$.fragment, local);
      transition_out(submitbutton.$$.fragment, local);
      transition_out(modalfooter.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div1);
      destroy_component(closebutton);
      destroy_component(figureelement);
      destroy_component(emailinput);
      destroy_component(passwordinput);
      destroy_component(submitbutton);
      if (if_block0) if_block0.d();
      if (if_block1) if_block1.d();
      destroy_component(modalfooter);
      mounted = false;
      dispose();
    }
  };
}
function instance$i($$self, $$props, $$invalidate) {
  var $textStore;
  var $app;
  component_subscribe($$self, TextStore, function ($$value) {
    return $$invalidate(16, $textStore = $$value);
  });
  component_subscribe($$self, AppStore, function ($$value) {
    return $$invalidate(6, $app = $$value);
  });
  var closeModal = $$props.closeModal;
  var display = $$props.display;
  var onSuccessLogin = $$props.onSuccessLogin;
  var params = $$props.params;
  var text = $textStore.text;
  var showLoader = false;
  var emailInputValid = false;
  var passwordInputValid = false;
  function submitLogin(e) {
    return __awaiter(this, void 0, void 0, function () {
      var emailInput, passwordInput, data, err_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            emailInput = e.target.querySelector("[name=eml]");
            passwordInput = e.target.querySelector("[name=psw]");
            if (!emailInputValid || !passwordInputValid) return [2 /*return*/];
            $$invalidate(3, showLoader = true);
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, window.$memberstackDom.loginMemberEmailPassword({
              email: emailInput.value,
              password: passwordInput.value
            }, {
              includeContentGroups: true
            })];
          case 2:
            data = _a.sent().data;
            onSuccessLogin({
              type: "LOGIN",
              data: data
            });
            $$invalidate(3, showLoader = false);
            return [3 /*break*/, 4];
          case 3:
            err_1 = _a.sent();
            $$invalidate(3, showLoader = false);
            window.$memberstackDom._showMessage(err_1.message, true);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  }

  function submitLoginWithProvider(provider) {
    return __awaiter(this, void 0, void 0, function () {
      var data, err_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            return [4 /*yield*/, window.$memberstackDom.loginWithProvider({
              provider: provider
            })];
          case 1:
            data = _a.sent().data;
            onSuccessLogin({
              type: "LOGIN",
              data: data
            });
            return [3 /*break*/, 3];
          case 2:
            err_2 = _a.sent();
            $$invalidate(3, showLoader = false);
            window.$memberstackDom._showMessage(err_2.message, true);
            return [3 /*break*/, 3];
          case 3:
            return [2 /*return*/];
        }
      });
    });
  }

  function emailinput_emailInputValid_binding(value) {
    emailInputValid = value;
    $$invalidate(4, emailInputValid);
  }
  function passwordinput_passwordInputValid_binding(value) {
    passwordInputValid = value;
    $$invalidate(5, passwordInputValid);
  }
  function passwordinput_display_binding(value) {
    display = value;
    $$invalidate(0, display);
  }
  var click_handler = function click_handler() {
    return $$invalidate(0, display = "signup");
  };
  var click_handler_1 = function click_handler_1(provider) {
    return submitLoginWithProvider(provider.provider);
  };
  $$self.$$set = function ($$props) {
    if ('closeModal' in $$props) $$invalidate(1, closeModal = $$props.closeModal);
    if ('display' in $$props) $$invalidate(0, display = $$props.display);
    if ('onSuccessLogin' in $$props) $$invalidate(10, onSuccessLogin = $$props.onSuccessLogin);
    if ('params' in $$props) $$invalidate(2, params = $$props.params);
  };
  return [display, closeModal, params, showLoader, emailInputValid, passwordInputValid, $app, text, submitLogin, submitLoginWithProvider, onSuccessLogin, emailinput_emailInputValid_binding, passwordinput_passwordInputValid_binding, passwordinput_display_binding, click_handler, click_handler_1];
}
var LoginModal = /** @class */function (_super) {
  __extends(LoginModal, _super);
  function LoginModal(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$i, create_fragment$r, safe_not_equal, {
      closeModal: 1,
      display: 0,
      onSuccessLogin: 10,
      params: 2
    });
    return _this;
  }
  return LoginModal;
}(SvelteComponent);
/* src/modals/SignupModal.svelte generated by Svelte v3.48.0 */
function get_each_context$5(ctx, list, i) {
  var child_ctx = ctx.slice();
  child_ctx[14] = list[i];
  return child_ctx;
}
function get_each_context_1(ctx, list, i) {
  var child_ctx = ctx.slice();
  child_ctx[17] = list[i];
  child_ctx[19] = i;
  return child_ctx;
}
// (93:6) {#if customField.hidden !== true}
function create_if_block_1$9(ctx) {
  var div1;
  var div0;
  var label;
  var t0_value = /*customField*/ctx[17].label + "";
  var t0;
  var label_for_value;
  var t1;
  var input;
  var input_placeholder_value;
  var input_name_value;
  return {
    c: function c() {
      div1 = element("div");
      div0 = element("div");
      label = element("label");
      t0 = text(t0_value);
      t1 = space();
      input = element("input");
      attr(label, "class", "ms-form__label");
      attr(label, "for", label_for_value = /*customField*/ctx[17].key);
      attr(input, "class", "ms-form__input");
      attr(input, "data-ms-custom-field", "");
      attr(input, "type", "text");
      attr(input, "placeholder", input_placeholder_value = /*customField*/ctx[17].label);
      attr(input, "name", input_name_value = /*customField*/ctx[17].key);
      attr(div0, "class", "ms-form__group");
      attr(div1, "class", "ms-modal__custom-field-container");
    },
    m: function m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, div0);
      append(div0, label);
      append(label, t0);
      append(div0, t1);
      append(div0, input);
    },
    p: function p(ctx, dirty) {
      if (dirty & /*$app*/32 && t0_value !== (t0_value = /*customField*/ctx[17].label + "")) set_data(t0, t0_value);
      if (dirty & /*$app*/32 && label_for_value !== (label_for_value = /*customField*/ctx[17].key)) {
        attr(label, "for", label_for_value);
      }
      if (dirty & /*$app*/32 && input_placeholder_value !== (input_placeholder_value = /*customField*/ctx[17].label)) {
        attr(input, "placeholder", input_placeholder_value);
      }
      if (dirty & /*$app*/32 && input_name_value !== (input_name_value = /*customField*/ctx[17].key)) {
        attr(input, "name", input_name_value);
      }
    },
    d: function d(detaching) {
      if (detaching) detach(div1);
    }
  };
}
// (92:6) {#each $app.customFields as customField, i}
function create_each_block_1(ctx) {
  var if_block_anchor;
  var if_block = /*customField*/ctx[17].hidden !== true && create_if_block_1$9(ctx);
  return {
    c: function c() {
      if (if_block) if_block.c();
      if_block_anchor = empty();
    },
    m: function m(target, anchor) {
      if (if_block) if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p: function p(ctx, dirty) {
      if ( /*customField*/ctx[17].hidden !== true) {
        if (if_block) {
          if_block.p(ctx, dirty);
        } else {
          if_block = create_if_block_1$9(ctx);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    d: function d(detaching) {
      if (if_block) if_block.d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
// (113:4) {#if $app.authProviders.length > 0}
function create_if_block$d(ctx) {
  var div4;
  var div3;
  var t3;
  var each_value = /*$app*/ctx[5].authProviders;
  var each_blocks = [];
  for (var i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$5(get_each_context$5(ctx, each_value, i));
  }
  return {
    c: function c() {
      div4 = element("div");
      div3 = element("div");
      div3.innerHTML = "<div class=\"ms-modal__divider-line\"></div> \n          <div class=\"ms-modal__divider-text\">or</div> \n          <div class=\"ms-modal__divider-line\"></div>";
      t3 = space();
      for (var i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      attr(div3, "class", "ms-modal__social-divider");
      attr(div4, "class", "ms-modal__social");
    },
    m: function m(target, anchor) {
      insert(target, div4, anchor);
      append(div4, div3);
      append(div4, t3);
      for (var i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].m(div4, null);
      }
    },
    p: function p(ctx, dirty) {
      if (dirty & /*submitSignupWithProvider, $app*/160) {
        each_value = /*$app*/ctx[5].authProviders;
        var i = void 0;
        for (i = 0; i < each_value.length; i += 1) {
          var child_ctx = get_each_context$5(ctx, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
          } else {
            each_blocks[i] = create_each_block$5(child_ctx);
            each_blocks[i].c();
            each_blocks[i].m(div4, null);
          }
        }
        for (; i < each_blocks.length; i += 1) {
          each_blocks[i].d(1);
        }
        each_blocks.length = each_value.length;
      }
    },
    d: function d(detaching) {
      if (detaching) detach(div4);
      destroy_each(each_blocks, detaching);
    }
  };
}
// (120:8) {#each $app.authProviders as provider}
function create_each_block$5(ctx) {
  var div;
  var button;
  var img;
  var img_src_value;
  var img_alt_value;
  var t0;
  var span;
  var t1;
  var t2_value = /*provider*/ctx[14].name + "";
  var t2;
  var t3;
  var mounted;
  var dispose;
  function click_handler_1() {
    return (/*click_handler_1*/ctx[13]( /*provider*/ctx[14])
    );
  }
  return {
    c: function c() {
      div = element("div");
      button = element("button");
      img = element("img");
      t0 = space();
      span = element("span");
      t1 = text("Continue with ");
      t2 = text(t2_value);
      t3 = space();
      if (!src_url_equal(img.src, img_src_value = /*provider*/ctx[14].icon)) attr(img, "src", img_src_value);
      attr(img, "alt", img_alt_value = /*provider*/ctx[14].name);
      attr(button, "class", "ms-modal__social-button");
      attr(button, "type", "button");
      attr(div, "class", "ms-modal__social-buttons");
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      append(div, button);
      append(button, img);
      append(button, t0);
      append(button, span);
      append(span, t1);
      append(span, t2);
      append(div, t3);
      if (!mounted) {
        dispose = listen(button, "click", click_handler_1);
        mounted = true;
      }
    },
    p: function p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty & /*$app*/32 && !src_url_equal(img.src, img_src_value = /*provider*/ctx[14].icon)) {
        attr(img, "src", img_src_value);
      }
      if (dirty & /*$app*/32 && img_alt_value !== (img_alt_value = /*provider*/ctx[14].name)) {
        attr(img, "alt", img_alt_value);
      }
      if (dirty & /*$app*/32 && t2_value !== (t2_value = /*provider*/ctx[14].name + "")) set_data(t2, t2_value);
    },
    d: function d(detaching) {
      if (detaching) detach(div);
      mounted = false;
      dispose();
    }
  };
}
function create_fragment$q(ctx) {
  var div2;
  var closebutton;
  var t0;
  var div1;
  var figureelement;
  var t1;
  var h2;
  var t3;
  var form;
  var t4;
  var emailinput;
  var updating_emailInputValid;
  var t5;
  var passwordinput;
  var updating_passwordInputValid;
  var t6;
  var submitbutton;
  var t7;
  var div0;
  var button;
  var t9;
  var t10;
  var modalfooter;
  var current;
  var mounted;
  var dispose;
  closebutton = new CloseButton({
    props: {
      closeModal: /*closeModal*/ctx[1]
    }
  });
  figureelement = new FigureElement({});
  var each_value_1 = /*$app*/ctx[5].customFields;
  var each_blocks = [];
  for (var i = 0; i < each_value_1.length; i += 1) {
    each_blocks[i] = create_each_block_1(get_each_context_1(ctx, each_value_1, i));
  }
  function emailinput_emailInputValid_binding(value) {
    /*emailinput_emailInputValid_binding*/ctx[10](value);
  }
  var emailinput_props = {};
  if ( /*emailInputValid*/ctx[3] !== void 0) {
    emailinput_props.emailInputValid = /*emailInputValid*/ctx[3];
  }
  emailinput = new EmailInput({
    props: emailinput_props
  });
  binding_callbacks.push(function () {
    return bind(emailinput, 'emailInputValid', emailinput_emailInputValid_binding);
  });
  function passwordinput_passwordInputValid_binding(value) {
    /*passwordinput_passwordInputValid_binding*/ctx[11](value);
  }
  var passwordinput_props = {};
  if ( /*passwordInputValid*/ctx[4] !== void 0) {
    passwordinput_props.passwordInputValid = /*passwordInputValid*/ctx[4];
  }
  passwordinput = new PasswordInput({
    props: passwordinput_props
  });
  binding_callbacks.push(function () {
    return bind(passwordinput, 'passwordInputValid', passwordinput_passwordInputValid_binding);
  });
  submitbutton = new SubmitButton({
    props: {
      buttonText: "Sign up",
      isLoading: /*showLoader*/ctx[2]
    }
  });
  var if_block = /*$app*/ctx[5].authProviders.length > 0 && create_if_block$d(ctx);
  modalfooter = new ModalFooter({});
  return {
    c: function c() {
      div2 = element("div");
      create_component(closebutton.$$.fragment);
      t0 = space();
      div1 = element("div");
      create_component(figureelement.$$.fragment);
      t1 = space();
      h2 = element("h2");
      h2.textContent = "Create an account";
      t3 = space();
      form = element("form");
      for (var i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      t4 = space();
      create_component(emailinput.$$.fragment);
      t5 = space();
      create_component(passwordinput.$$.fragment);
      t6 = space();
      create_component(submitbutton.$$.fragment);
      t7 = space();
      div0 = element("div");
      button = element("button");
      button.textContent = "Already have an account?";
      t9 = space();
      if (if_block) if_block.c();
      t10 = space();
      create_component(modalfooter.$$.fragment);
      attr(h2, "class", "ms-modal__title");
      attr(button, "class", "ms-form__button ms-form__button--text ms-form__button--top-spacing");
      attr(div0, "class", "ms-form__flex ms-form__flex--centered");
      attr(form, "class", "ms-form");
      attr(form, "action", "");
      attr(form, "method", "post");
      attr(form, "autocomplete", "off");
      attr(div1, "class", "ms-modal__content");
      attr(div2, "class", "ms-modal");
      attr(div2, "id", "SignupModal");
    },
    m: function m(target, anchor) {
      insert(target, div2, anchor);
      mount_component(closebutton, div2, null);
      append(div2, t0);
      append(div2, div1);
      mount_component(figureelement, div1, null);
      append(div1, t1);
      append(div1, h2);
      append(div1, t3);
      append(div1, form);
      for (var i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].m(form, null);
      }
      append(form, t4);
      mount_component(emailinput, form, null);
      append(form, t5);
      mount_component(passwordinput, form, null);
      append(form, t6);
      mount_component(submitbutton, form, null);
      append(form, t7);
      append(form, div0);
      append(div0, button);
      append(div1, t9);
      if (if_block) if_block.m(div1, null);
      append(div2, t10);
      mount_component(modalfooter, div2, null);
      current = true;
      if (!mounted) {
        dispose = [listen(button, "click", /*click_handler*/ctx[12]), listen(form, "submit", stop_propagation(prevent_default( /*submitSignup*/ctx[6])))];
        mounted = true;
      }
    },
    p: function p(ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      var closebutton_changes = {};
      if (dirty & /*closeModal*/2) closebutton_changes.closeModal = /*closeModal*/ctx[1];
      closebutton.$set(closebutton_changes);
      if (dirty & /*$app*/32) {
        each_value_1 = /*$app*/ctx[5].customFields;
        var i = void 0;
        for (i = 0; i < each_value_1.length; i += 1) {
          var child_ctx = get_each_context_1(ctx, each_value_1, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
          } else {
            each_blocks[i] = create_each_block_1(child_ctx);
            each_blocks[i].c();
            each_blocks[i].m(form, t4);
          }
        }
        for (; i < each_blocks.length; i += 1) {
          each_blocks[i].d(1);
        }
        each_blocks.length = each_value_1.length;
      }
      var emailinput_changes = {};
      if (!updating_emailInputValid && dirty & /*emailInputValid*/8) {
        updating_emailInputValid = true;
        emailinput_changes.emailInputValid = /*emailInputValid*/ctx[3];
        add_flush_callback(function () {
          return updating_emailInputValid = false;
        });
      }
      emailinput.$set(emailinput_changes);
      var passwordinput_changes = {};
      if (!updating_passwordInputValid && dirty & /*passwordInputValid*/16) {
        updating_passwordInputValid = true;
        passwordinput_changes.passwordInputValid = /*passwordInputValid*/ctx[4];
        add_flush_callback(function () {
          return updating_passwordInputValid = false;
        });
      }
      passwordinput.$set(passwordinput_changes);
      var submitbutton_changes = {};
      if (dirty & /*showLoader*/4) submitbutton_changes.isLoading = /*showLoader*/ctx[2];
      submitbutton.$set(submitbutton_changes);
      if ( /*$app*/ctx[5].authProviders.length > 0) {
        if (if_block) {
          if_block.p(ctx, dirty);
        } else {
          if_block = create_if_block$d(ctx);
          if_block.c();
          if_block.m(div1, null);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(closebutton.$$.fragment, local);
      transition_in(figureelement.$$.fragment, local);
      transition_in(emailinput.$$.fragment, local);
      transition_in(passwordinput.$$.fragment, local);
      transition_in(submitbutton.$$.fragment, local);
      transition_in(modalfooter.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(closebutton.$$.fragment, local);
      transition_out(figureelement.$$.fragment, local);
      transition_out(emailinput.$$.fragment, local);
      transition_out(passwordinput.$$.fragment, local);
      transition_out(submitbutton.$$.fragment, local);
      transition_out(modalfooter.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div2);
      destroy_component(closebutton);
      destroy_component(figureelement);
      destroy_each(each_blocks, detaching);
      destroy_component(emailinput);
      destroy_component(passwordinput);
      destroy_component(submitbutton);
      if (if_block) if_block.d();
      destroy_component(modalfooter);
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$h($$self, $$props, $$invalidate) {
  var $app;
  component_subscribe($$self, AppStore, function ($$value) {
    return $$invalidate(5, $app = $$value);
  });
  var closeModal = $$props.closeModal;
  var display = $$props.display;
  var onSuccessSignup = $$props.onSuccessSignup;
  var params = $$props.params;
  var showLoader = false;
  var emailInputValid = false;
  var passwordInputValid = false;
  function submitSignup(e) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
      var emailInput, passwordInput, customFields, customFieldInputs, plans, data, err_3;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            emailInput = e.target.querySelector("[type=email]");
            passwordInput = e.target.querySelector("[type=password]");
            customFields = {};
            customFieldInputs = Array.from(e.target.querySelectorAll("[data-ms-custom-field]"));
            customFieldInputs.map(function (input) {
              customFields[input.getAttribute("name")] = input.value;
            }).length;
            if (!emailInputValid || !passwordInputValid) return [2 /*return*/];
            $$invalidate(2, showLoader = true);
            _b.label = 1;
          case 1:
            _b.trys.push([1, 3,, 4]);
            plans = (((_a = params === null || params === void 0 ? void 0 : params.signup) === null || _a === void 0 ? void 0 : _a.plans) || []).map(function (plan) {
              return {
                planId: plan
              };
            });
            return [4 /*yield*/, window.$memberstackDom.signupMemberEmailPassword({
              email: emailInput.value,
              password: passwordInput.value,
              plans: plans,
              customFields: customFields
            }, {
              includeContentGroups: true
            })];
          case 2:
            data = _b.sent().data;
            onSuccessSignup({
              type: "SIGNUP",
              data: data
            });
            $$invalidate(2, showLoader = false);
            return [3 /*break*/, 4];
          case 3:
            err_3 = _b.sent();
            $$invalidate(2, showLoader = false);
            window.$memberstackDom._showMessage(err_3.message, true);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  }

  function submitSignupWithProvider(provider) {
    return __awaiter(this, void 0, void 0, function () {
      var data, err_4;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            return [4 /*yield*/, window.$memberstackDom.signupWithProvider({
              provider: provider
            })];
          case 1:
            data = _a.sent().data;
            onSuccessSignup({
              type: "SIGNUP",
              data: data
            });
            return [3 /*break*/, 3];
          case 2:
            err_4 = _a.sent();
            $$invalidate(2, showLoader = false);
            window.$memberstackDom._showMessage(err_4.message, true);
            return [3 /*break*/, 3];
          case 3:
            return [2 /*return*/];
        }
      });
    });
  }

  function emailinput_emailInputValid_binding(value) {
    emailInputValid = value;
    $$invalidate(3, emailInputValid);
  }
  function passwordinput_passwordInputValid_binding(value) {
    passwordInputValid = value;
    $$invalidate(4, passwordInputValid);
  }
  var click_handler = function click_handler() {
    return $$invalidate(0, display = "login");
  };
  var click_handler_1 = function click_handler_1(provider) {
    return submitSignupWithProvider(provider.provider);
  };
  $$self.$$set = function ($$props) {
    if ('closeModal' in $$props) $$invalidate(1, closeModal = $$props.closeModal);
    if ('display' in $$props) $$invalidate(0, display = $$props.display);
    if ('onSuccessSignup' in $$props) $$invalidate(8, onSuccessSignup = $$props.onSuccessSignup);
    if ('params' in $$props) $$invalidate(9, params = $$props.params);
  };
  return [display, closeModal, showLoader, emailInputValid, passwordInputValid, $app, submitSignup, submitSignupWithProvider, onSuccessSignup, params, emailinput_emailInputValid_binding, passwordinput_passwordInputValid_binding, click_handler, click_handler_1];
}
var SignupModal = /** @class */function (_super) {
  __extends(SignupModal, _super);
  function SignupModal(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$h, create_fragment$q, safe_not_equal, {
      closeModal: 1,
      display: 0,
      onSuccessSignup: 8,
      params: 9
    });
    return _this;
  }
  return SignupModal;
}(SvelteComponent);
/* src/icons/BackIcon.svelte generated by Svelte v3.48.0 */
function create_fragment$p(ctx) {
  var svg;
  var path;
  return {
    c: function c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "M7.41 1.41L6 0L0 6L6 12L7.41 10.59L2.83 6L7.41 1.41Z");
      attr(svg, "fill", "none");
      attr(svg, "viewBox", "0 0 8 12");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m: function m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(svg);
    }
  };
}
var BackIcon = /** @class */function (_super) {
  __extends(BackIcon, _super);
  function BackIcon(options) {
    var _this = _super.call(this) || this;
    init(_this, options, null, create_fragment$p, safe_not_equal, {});
    return _this;
  }
  return BackIcon;
}(SvelteComponent);
/* src/modals/PassResetModal.svelte generated by Svelte v3.48.0 */
function create_fragment$o(ctx) {
  var div4;
  var div0;
  var button;
  var backicon;
  var t0;
  var closebutton;
  var t1;
  var div3;
  var figureelement;
  var t2;
  var h2;
  var t4;
  var p;
  var t6;
  var form;
  var emailinput;
  var updating_emailInputValid;
  var t7;
  var submitbutton;
  var t8;
  var div2;
  var div1;
  var t10;
  var modalfooter;
  var current;
  var mounted;
  var dispose;
  backicon = new BackIcon({});
  closebutton = new CloseButton({
    props: {
      closeModal: /*closeModal*/ctx[1]
    }
  });
  figureelement = new FigureElement({});
  function emailinput_emailInputValid_binding(value) {
    /*emailinput_emailInputValid_binding*/ctx[7](value);
  }
  var emailinput_props = {
    placeholder: /*text*/ctx[4]["reset_email_placeholder"]
  };
  if ( /*emailInputValid*/ctx[2] !== void 0) {
    emailinput_props.emailInputValid = /*emailInputValid*/ctx[2];
  }
  emailinput = new EmailInput({
    props: emailinput_props
  });
  binding_callbacks.push(function () {
    return bind(emailinput, 'emailInputValid', emailinput_emailInputValid_binding);
  });
  submitbutton = new SubmitButton({
    props: {
      buttonText: /*text*/ctx[4]["reset"] || "Send Link",
      isLoading: /*showLoader*/ctx[3]
    }
  });
  modalfooter = new ModalFooter({});
  return {
    c: function c() {
      div4 = element("div");
      div0 = element("div");
      button = element("button");
      create_component(backicon.$$.fragment);
      t0 = space();
      create_component(closebutton.$$.fragment);
      t1 = space();
      div3 = element("div");
      create_component(figureelement.$$.fragment);
      t2 = space();
      h2 = element("h2");
      h2.textContent = "" + (ctx[4]["reset_your_password"] || "Reset your password");
      t4 = space();
      p = element("p");
      p.textContent = "" + (ctx[4]["reset_instructions"] || "We’ll email you a secure link to reset the password for your account.");
      t6 = space();
      form = element("form");
      create_component(emailinput.$$.fragment);
      t7 = space();
      create_component(submitbutton.$$.fragment);
      t8 = space();
      div2 = element("div");
      div1 = element("div");
      div1.textContent = "" + (ctx[4]["reset_already_have_code"] || "I already have a code");
      t10 = space();
      create_component(modalfooter.$$.fragment);
      attr(div0, "data-cy", "back-btn");
      attr(div0, "class", "ms-modal__back");
      attr(h2, "class", "ms-modal__title ms-modal__title--sub-text");
      attr(p, "class", "ms-modal__text");
      attr(div1, "class", "ms-form__link");
      attr(div2, "class", "ms-form__flex ms-form__flex--centered");
      attr(form, "class", "ms-form");
      attr(form, "action", "");
      attr(form, "method", "post");
      attr(form, "autocomplete", "off");
      attr(div3, "class", "ms-modal__content");
      attr(div4, "class", "ms-modal");
      attr(div4, "id", "PasswordResetModal");
    },
    m: function m(target, anchor) {
      insert(target, div4, anchor);
      append(div4, div0);
      append(div0, button);
      mount_component(backicon, button, null);
      append(div4, t0);
      mount_component(closebutton, div4, null);
      append(div4, t1);
      append(div4, div3);
      mount_component(figureelement, div3, null);
      append(div3, t2);
      append(div3, h2);
      append(div3, t4);
      append(div3, p);
      append(div3, t6);
      append(div3, form);
      mount_component(emailinput, form, null);
      append(form, t7);
      mount_component(submitbutton, form, null);
      append(form, t8);
      append(form, div2);
      append(div2, div1);
      append(div4, t10);
      mount_component(modalfooter, div4, null);
      current = true;
      if (!mounted) {
        dispose = [listen(button, "click", /*click_handler*/ctx[6]), listen(div1, "click", /*click_handler_1*/ctx[8]), listen(form, "submit", stop_propagation(prevent_default( /*submitPasswordReset*/ctx[5])))];
        mounted = true;
      }
    },
    p: function p(ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      var closebutton_changes = {};
      if (dirty & /*closeModal*/2) closebutton_changes.closeModal = /*closeModal*/ctx[1];
      closebutton.$set(closebutton_changes);
      var emailinput_changes = {};
      if (!updating_emailInputValid && dirty & /*emailInputValid*/4) {
        updating_emailInputValid = true;
        emailinput_changes.emailInputValid = /*emailInputValid*/ctx[2];
        add_flush_callback(function () {
          return updating_emailInputValid = false;
        });
      }
      emailinput.$set(emailinput_changes);
      var submitbutton_changes = {};
      if (dirty & /*showLoader*/8) submitbutton_changes.isLoading = /*showLoader*/ctx[3];
      submitbutton.$set(submitbutton_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(backicon.$$.fragment, local);
      transition_in(closebutton.$$.fragment, local);
      transition_in(figureelement.$$.fragment, local);
      transition_in(emailinput.$$.fragment, local);
      transition_in(submitbutton.$$.fragment, local);
      transition_in(modalfooter.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(backicon.$$.fragment, local);
      transition_out(closebutton.$$.fragment, local);
      transition_out(figureelement.$$.fragment, local);
      transition_out(emailinput.$$.fragment, local);
      transition_out(submitbutton.$$.fragment, local);
      transition_out(modalfooter.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div4);
      destroy_component(backicon);
      destroy_component(closebutton);
      destroy_component(figureelement);
      destroy_component(emailinput);
      destroy_component(submitbutton);
      destroy_component(modalfooter);
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$g($$self, $$props, $$invalidate) {
  var $textStore;
  component_subscribe($$self, TextStore, function ($$value) {
    return $$invalidate(9, $textStore = $$value);
  });
  var text = $textStore.text;
  var closeModal = $$props.closeModal;
  var display = $$props.display;
  var emailInputValid = false;
  var showLoader = false;
  function submitPasswordReset(e) {
    return __awaiter(this, void 0, void 0, function () {
      var emailInput, err_5;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            emailInput = e.target[0];
            if (!emailInputValid) return [2 /*return*/];
            $$invalidate(3, showLoader = true);
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, window.$memberstackDom.sendMemberResetPasswordEmail({
              email: emailInput.value
            })];
          case 2:
            _a.sent();
            $$invalidate(0, display = "reset_password");
            return [3 /*break*/, 4];
          case 3:
            err_5 = _a.sent();
            console.log(err_5);
            $$invalidate(3, showLoader = false);
            if (err_5.message) {
              window.$memberstackDom._showMessage(err_5.message, false);
            }
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  }

  var click_handler = function click_handler() {
    return $$invalidate(0, display = "login");
  };
  function emailinput_emailInputValid_binding(value) {
    emailInputValid = value;
    $$invalidate(2, emailInputValid);
  }
  var click_handler_1 = function click_handler_1() {
    return $$invalidate(0, display = "reset_password");
  };
  $$self.$$set = function ($$props) {
    if ('closeModal' in $$props) $$invalidate(1, closeModal = $$props.closeModal);
    if ('display' in $$props) $$invalidate(0, display = $$props.display);
  };
  return [display, closeModal, emailInputValid, showLoader, text, submitPasswordReset, click_handler, emailinput_emailInputValid_binding, click_handler_1];
}
var PassResetModal = /** @class */function (_super) {
  __extends(PassResetModal, _super);
  function PassResetModal(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$g, create_fragment$o, safe_not_equal, {
      closeModal: 1,
      display: 0
    });
    return _this;
  }
  return PassResetModal;
}(SvelteComponent);
/* src/modals/PassTokenModal.svelte generated by Svelte v3.48.0 */
function create_if_block$c(ctx) {
  var div;
  var erroricon;
  var t;
  var current;
  erroricon = new ErrorIcon({});
  return {
    c: function c() {
      div = element("div");
      create_component(erroricon.$$.fragment);
      t = text(" Please enter a valid code");
      attr(div, "class", "ms-form__error");
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      mount_component(erroricon, div, null);
      append(div, t);
      current = true;
    },
    i: function i(local) {
      if (current) return;
      transition_in(erroricon.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(erroricon.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div);
      destroy_component(erroricon);
    }
  };
}
function create_fragment$n(ctx) {
  var div3;
  var div0;
  var button;
  var backicon;
  var t0;
  var closebutton;
  var t1;
  var div2;
  var figureelement;
  var t2;
  var h2;
  var t4;
  var form;
  var div1;
  var label;
  var t6;
  var fieldset;
  var t12;
  var t13;
  var passwordinput;
  var updating_passwordInputValid;
  var t14;
  var submitbutton;
  var t15;
  var modalfooter;
  var current;
  var mounted;
  var dispose;
  backicon = new BackIcon({});
  closebutton = new CloseButton({
    props: {
      closeModal: /*closeModal*/ctx[1]
    }
  });
  figureelement = new FigureElement({});
  var if_block = !ctx[3] && create_if_block$c();
  function passwordinput_passwordInputValid_binding(value) {
    /*passwordinput_passwordInputValid_binding*/ctx[9](value);
  }
  var passwordinput_props = {
    passwordPlaceholder: /*text*/ctx[5]["reset_password_placeholder"],
    passwordLabel: /*text*/ctx[5]["password"] || "Password"
  };
  if ( /*passwordInputValid*/ctx[4] !== void 0) {
    passwordinput_props.passwordInputValid = /*passwordInputValid*/ctx[4];
  }
  passwordinput = new PasswordInput({
    props: passwordinput_props
  });
  binding_callbacks.push(function () {
    return bind(passwordinput, 'passwordInputValid', passwordinput_passwordInputValid_binding);
  });
  submitbutton = new SubmitButton({
    props: {
      buttonText: /*text*/ctx[5]["reset_confirm_reset"] || "Confirm & Reset",
      isLoading: /*showLoader*/ctx[2]
    }
  });
  modalfooter = new ModalFooter({});
  return {
    c: function c() {
      div3 = element("div");
      div0 = element("div");
      button = element("button");
      create_component(backicon.$$.fragment);
      t0 = space();
      create_component(closebutton.$$.fragment);
      t1 = space();
      div2 = element("div");
      create_component(figureelement.$$.fragment);
      t2 = space();
      h2 = element("h2");
      h2.textContent = "" + (ctx[5]["reset_your_password"] || "Reset your password");
      t4 = space();
      form = element("form");
      div1 = element("div");
      label = element("label");
      label.textContent = "" + (ctx[5]["reset_enter_code"] || "Enter your 6-digit code");
      t6 = space();
      fieldset = element("fieldset");
      fieldset.innerHTML = "<input name=\"token\" class=\"ms-form__input ms-form__input--token\" required=\"\"/> \n          <input name=\"token\" class=\"ms-form__input ms-form__input--token\" required=\"\"/> \n          <input name=\"token\" class=\"ms-form__input ms-form__input--token\" required=\"\"/> \n          <input name=\"token\" class=\"ms-form__input ms-form__input--token\" required=\"\"/> \n          <input name=\"token\" class=\"ms-form__input ms-form__input--token\" required=\"\"/> \n          <input name=\"token\" class=\"ms-form__input ms-form__input--token\"/>";
      t12 = space();
      if (if_block) if_block.c();
      t13 = space();
      create_component(passwordinput.$$.fragment);
      t14 = space();
      create_component(submitbutton.$$.fragment);
      t15 = space();
      create_component(modalfooter.$$.fragment);
      attr(div0, "class", "ms-modal__back");
      attr(h2, "class", "ms-modal__title");
      attr(label, "class", "ms-form__label");
      attr(label, "for", "token-fieldset");
      attr(fieldset, "class", "ms-form__fieldset");
      attr(fieldset, "name", "token-fieldset");
      attr(div1, "class", "ms-form__group");
      attr(form, "class", "ms-form");
      attr(form, "action", "");
      attr(form, "method", "post");
      attr(form, "autocomplete", "off");
      attr(div2, "class", "ms-modal__content");
      attr(div3, "class", "ms-modal");
      attr(div3, "id", "PasswordTokenModal");
    },
    m: function m(target, anchor) {
      insert(target, div3, anchor);
      append(div3, div0);
      append(div0, button);
      mount_component(backicon, button, null);
      append(div3, t0);
      mount_component(closebutton, div3, null);
      append(div3, t1);
      append(div3, div2);
      mount_component(figureelement, div2, null);
      append(div2, t2);
      append(div2, h2);
      append(div2, t4);
      append(div2, form);
      append(form, div1);
      append(div1, label);
      append(div1, t6);
      append(div1, fieldset);
      append(div1, t12);
      if (if_block) if_block.m(div1, null);
      append(form, t13);
      mount_component(passwordinput, form, null);
      append(form, t14);
      mount_component(submitbutton, form, null);
      append(div3, t15);
      mount_component(modalfooter, div3, null);
      current = true;
      if (!mounted) {
        dispose = [listen(button, "click", /*click_handler*/ctx[8]), listen(form, "submit", stop_propagation(prevent_default( /*submitPasswordToken*/ctx[6])))];
        mounted = true;
      }
    },
    p: function p(ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      var closebutton_changes = {};
      if (dirty & /*closeModal*/2) closebutton_changes.closeModal = /*closeModal*/ctx[1];
      closebutton.$set(closebutton_changes);
      if (!ctx[3]) {
        if (if_block) {
          if (dirty & /*tokenInputValid*/8) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$c();
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(div1, null);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, function () {
          if_block = null;
        });
        check_outros();
      }
      var passwordinput_changes = {};
      if (!updating_passwordInputValid && dirty & /*passwordInputValid*/16) {
        updating_passwordInputValid = true;
        passwordinput_changes.passwordInputValid = /*passwordInputValid*/ctx[4];
        add_flush_callback(function () {
          return updating_passwordInputValid = false;
        });
      }
      passwordinput.$set(passwordinput_changes);
      var submitbutton_changes = {};
      if (dirty & /*showLoader*/4) submitbutton_changes.isLoading = /*showLoader*/ctx[2];
      submitbutton.$set(submitbutton_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(backicon.$$.fragment, local);
      transition_in(closebutton.$$.fragment, local);
      transition_in(figureelement.$$.fragment, local);
      transition_in(if_block);
      transition_in(passwordinput.$$.fragment, local);
      transition_in(submitbutton.$$.fragment, local);
      transition_in(modalfooter.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(backicon.$$.fragment, local);
      transition_out(closebutton.$$.fragment, local);
      transition_out(figureelement.$$.fragment, local);
      transition_out(if_block);
      transition_out(passwordinput.$$.fragment, local);
      transition_out(submitbutton.$$.fragment, local);
      transition_out(modalfooter.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div3);
      destroy_component(backicon);
      destroy_component(closebutton);
      destroy_component(figureelement);
      if (if_block) if_block.d();
      destroy_component(passwordinput);
      destroy_component(submitbutton);
      destroy_component(modalfooter);
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$f($$self, $$props, $$invalidate) {
  var $textStore;
  component_subscribe($$self, TextStore, function ($$value) {
    return $$invalidate(10, $textStore = $$value);
  });
  var text = $textStore.text;
  var closeModal = $$props.closeModal;
  var display = $$props.display;
  var onSuccessPasswordReset = $$props.onSuccessPasswordReset;
  var showLoader = false;
  var tokenInputValid = true;
  var passwordInputValid = true;
  onMount(function () {
    var tokenElements = __spread(document.querySelectorAll("input.ms-form__input--token"));
    tokenElements.forEach(function (ele, index) {
      ele.addEventListener("keydown", function (e) {
        if (e.keyCode === 8 && e.target.value === "") tokenElements[Math.max(0, index - 1)].focus();
      });
      ele.addEventListener("input", function (e) {
        var _a = __read(e.target.value),
          first = _a[0],
          rest = _a.slice(1);
        e.target.value = first !== null && first !== void 0 ? first : "";
        var lastInputBox = index === tokenElements.length - 1;
        var insertedContent = first !== undefined;
        if (insertedContent && !lastInputBox) {
          tokenElements[index + 1].focus();
          tokenElements[index + 1].value = rest.join("");
          tokenElements[index + 1].dispatchEvent(new Event("input"));
        }
      });
    });
  });
  var validateFields = function validateFields(e) {
    var tokenElements = __spread(document.querySelectorAll("input.ms-form__input--token"));
    var hasEmpty = tokenElements.some(function (el) {
      if (!el.value) {
        return true;
      }
      return false;
    });
    if (hasEmpty) {
      $$invalidate(3, tokenInputValid = false);
    } else {
      $$invalidate(3, tokenInputValid = true);
    }
    return !hasEmpty;
  };
  function submitPasswordToken(e) {
    return __awaiter(this, void 0, void 0, function () {
      var passwordInput, isValid, token, err_6;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            passwordInput = e.target[7];
            isValid = validateFields();
            if (!isValid) return [2 /*return*/];
            token = __spread(document.getElementsByName("token")).filter(function (_a) {
              var name = _a.name;
              return name;
            }).map(function (_a) {
              var value = _a.value;
              return value;
            }).join("");
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            $$invalidate(2, showLoader = true);
            return [4 /*yield*/, window.$memberstackDom.resetMemberPassword({
              token: token,
              newPassword: passwordInput.value
            })];
          case 2:
            _a.sent();
            window.$memberstackDom._showMessage("Password successfully reset", false);
            onSuccessPasswordReset({
              type: "PASSWORD_RESET",
              data: {}
            });
            $$invalidate(2, showLoader = false);
            $$invalidate(0, display = "reset_password_success");
            return [3 /*break*/, 4];
          case 3:
            err_6 = _a.sent();
            $$invalidate(2, showLoader = false);
            console.log(err_6);
            if (err_6.message) {
              window.$memberstackDom._showMessage(err_6.message, true);
            }
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  }

  var click_handler = function click_handler() {
    return $$invalidate(0, display = "forgot_password");
  };
  function passwordinput_passwordInputValid_binding(value) {
    passwordInputValid = value;
    $$invalidate(4, passwordInputValid);
  }
  $$self.$$set = function ($$props) {
    if ('closeModal' in $$props) $$invalidate(1, closeModal = $$props.closeModal);
    if ('display' in $$props) $$invalidate(0, display = $$props.display);
    if ('onSuccessPasswordReset' in $$props) $$invalidate(7, onSuccessPasswordReset = $$props.onSuccessPasswordReset);
  };
  return [display, closeModal, showLoader, tokenInputValid, passwordInputValid, text, submitPasswordToken, onSuccessPasswordReset, click_handler, passwordinput_passwordInputValid_binding];
}
var PassTokenModal = /** @class */function (_super) {
  __extends(PassTokenModal, _super);
  function PassTokenModal(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$f, create_fragment$n, safe_not_equal, {
      closeModal: 1,
      display: 0,
      onSuccessPasswordReset: 7
    });
    return _this;
  }
  return PassTokenModal;
}(SvelteComponent);
/* src/modals/PassSuccessModal.svelte generated by Svelte v3.48.0 */
function create_fragment$m(ctx) {
  var div2;
  var div0;
  var t0;
  var closebutton;
  var t1;
  var div1;
  var figureelement;
  var t2;
  var h2;
  var t4;
  var p;
  var t7;
  var modalfooter;
  var current;
  closebutton = new CloseButton({
    props: {
      closeModal: /*closeModal*/ctx[0]
    }
  });
  figureelement = new FigureElement({});
  modalfooter = new ModalFooter({});
  return {
    c: function c() {
      div2 = element("div");
      div0 = element("div");
      t0 = space();
      create_component(closebutton.$$.fragment);
      t1 = space();
      div1 = element("div");
      create_component(figureelement.$$.fragment);
      t2 = space();
      h2 = element("h2");
      h2.textContent = "Success!";
      t4 = space();
      p = element("p");
      p.innerHTML = "Your password has been reset. <br/>\n      Please login with your new credentials.";
      t7 = space();
      create_component(modalfooter.$$.fragment);
      attr(div0, "data-cy", "back-btn");
      attr(div0, "class", "ms-modal__back");
      attr(h2, "class", "ms-modal__title ms-modal__title--sub-text");
      attr(p, "class", "ms-modal__text");
      attr(div1, "class", "ms-modal__content");
      attr(div2, "class", "ms-modal");
      attr(div2, "id", "PasswordSuccessModal");
    },
    m: function m(target, anchor) {
      insert(target, div2, anchor);
      append(div2, div0);
      append(div2, t0);
      mount_component(closebutton, div2, null);
      append(div2, t1);
      append(div2, div1);
      mount_component(figureelement, div1, null);
      append(div1, t2);
      append(div1, h2);
      append(div1, t4);
      append(div1, p);
      append(div2, t7);
      mount_component(modalfooter, div2, null);
      current = true;
    },
    p: function p(ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      var closebutton_changes = {};
      if (dirty & /*closeModal*/1) closebutton_changes.closeModal = /*closeModal*/ctx[0];
      closebutton.$set(closebutton_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(closebutton.$$.fragment, local);
      transition_in(figureelement.$$.fragment, local);
      transition_in(modalfooter.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(closebutton.$$.fragment, local);
      transition_out(figureelement.$$.fragment, local);
      transition_out(modalfooter.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div2);
      destroy_component(closebutton);
      destroy_component(figureelement);
      destroy_component(modalfooter);
    }
  };
}
function instance$e($$self, $$props, $$invalidate) {
  var closeModal = $$props.closeModal;
  $$self.$$set = function ($$props) {
    if ('closeModal' in $$props) $$invalidate(0, closeModal = $$props.closeModal);
  };
  return [closeModal];
}
var PassSuccessModal = /** @class */function (_super) {
  __extends(PassSuccessModal, _super);
  function PassSuccessModal(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$e, create_fragment$m, safe_not_equal, {
      closeModal: 0
    });
    return _this;
  }
  return PassSuccessModal;
}(SvelteComponent);
/* src/icons/ProfileIcon.svelte generated by Svelte v3.48.0 */
function create_fragment$l(ctx) {
  var svg;
  var path;
  return {
    c: function c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "d", "m8 8c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z");
      attr(path, "fill", "currentColor");
      attr(svg, "fill", "none");
      attr(svg, "viewBox", "0 0 16 16");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m: function m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(svg);
    }
  };
}
var ProfileIcon = /** @class */function (_super) {
  __extends(ProfileIcon, _super);
  function ProfileIcon(options) {
    var _this = _super.call(this) || this;
    init(_this, options, null, create_fragment$l, safe_not_equal, {});
    return _this;
  }
  return ProfileIcon;
}(SvelteComponent);
/* src/icons/SecurityIcon.svelte generated by Svelte v3.48.0 */
function create_fragment$k(ctx) {
  var svg;
  var path;
  return {
    c: function c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "d", "m9 0-9 4v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12v-6l-9-4zm0 10.99h7c-0.53 4.12-3.28 7.79-7 8.94v-8.93h-7v-5.7l7-3.11v8.8z");
      attr(path, "fill", "currentColor");
      attr(svg, "fill", "none");
      attr(svg, "viewBox", "0 0 18 22");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m: function m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(svg);
    }
  };
}
var SecurityIcon = /** @class */function (_super) {
  __extends(SecurityIcon, _super);
  function SecurityIcon(options) {
    var _this = _super.call(this) || this;
    init(_this, options, null, create_fragment$k, safe_not_equal, {});
    return _this;
  }
  return SecurityIcon;
}(SvelteComponent);
/* src/icons/LinkOutIcon.svelte generated by Svelte v3.48.0 */
function create_fragment$j(ctx) {
  var svg;
  var path;
  return {
    c: function c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "M16 16H2V2H9V0H2C0.89 0 0 0.9 0 2V16C0 17.1 0.89 18 2 18H16C17.1 18 18 17.1 18 16V9H16V16ZM11 0V2H14.59L4.76 11.83L6.17 13.24L16 3.41V7H18V0H11Z");
      attr(svg, "fill", "none");
      attr(svg, "viewBox", "0 0 18 18");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m: function m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(svg);
    }
  };
}
var LinkOutIcon = /** @class */function (_super) {
  __extends(LinkOutIcon, _super);
  function LinkOutIcon(options) {
    var _this = _super.call(this) || this;
    init(_this, options, null, create_fragment$j, safe_not_equal, {});
    return _this;
  }
  return LinkOutIcon;
}(SvelteComponent);
/* src/icons/LogoutIcon.svelte generated by Svelte v3.48.0 */
function create_fragment$i(ctx) {
  var svg;
  var path;
  return {
    c: function c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "d", "M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z");
      attr(path, "fill", "currentColor");
      attr(svg, "width", "16");
      attr(svg, "height", "16");
      attr(svg, "viewBox", "0 0 16 16");
      attr(svg, "fill", "none");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m: function m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(svg);
    }
  };
}
var LogoutIcon = /** @class */function (_super) {
  __extends(LogoutIcon, _super);
  function LogoutIcon(options) {
    var _this = _super.call(this) || this;
    init(_this, options, null, create_fragment$i, safe_not_equal, {});
    return _this;
  }
  return LogoutIcon;
}(SvelteComponent);
/* src/icons/PlansIcon.svelte generated by Svelte v3.48.0 */
function create_fragment$h(ctx) {
  var svg;
  var path;
  return {
    c: function c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "M12 2l-5.5 9h11L12 2zm0 3.84L13.93 9h-3.87L12 5.84zM17.5 13c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5 4.5-2.01 4.5-4.5-2.01-4.5-4.5-4.5zm0 7c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM3 21.5h8v-8H3v8zm2-6h4v4H5v-4z");
      attr(svg, "fill", "none");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
      attr(svg, "viewBox", "3 2 19 20");
    },
    m: function m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(svg);
    }
  };
}
var PlansIcon = /** @class */function (_super) {
  __extends(PlansIcon, _super);
  function PlansIcon(options) {
    var _this = _super.call(this) || this;
    init(_this, options, null, create_fragment$h, safe_not_equal, {});
    return _this;
  }
  return PlansIcon;
}(SvelteComponent);
/* src/components/ProfileModalNav.svelte generated by Svelte v3.48.0 */
function create_if_block_1$8(ctx) {
  var button;
  var profileicon;
  var t;
  var current;
  var mounted;
  var dispose;
  profileicon = new ProfileIcon({});
  return {
    c: function c() {
      button = element("button");
      create_component(profileicon.$$.fragment);
      t = text(" Profile");
      attr(button, "data-cy", "profile-btn");
      attr(button, "class", "ms-modal__profile-option");
      toggle_class(button, "ms-modal__profile-option--active", /*displayProfile*/ctx[0] === "profile");
    },
    m: function m(target, anchor) {
      insert(target, button, anchor);
      mount_component(profileicon, button, null);
      append(button, t);
      current = true;
      if (!mounted) {
        dispose = listen(button, "click", /*click_handler*/ctx[7]);
        mounted = true;
      }
    },
    p: function p(ctx, dirty) {
      if (dirty & /*displayProfile*/1) {
        toggle_class(button, "ms-modal__profile-option--active", /*displayProfile*/ctx[0] === "profile");
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(profileicon.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(profileicon.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(button);
      destroy_component(profileicon);
      mounted = false;
      dispose();
    }
  };
}
// (61:0) {#if showPlansNavButton()}
function create_if_block$b(ctx) {
  var button;
  var plansicon;
  var t;
  var current;
  var mounted;
  var dispose;
  plansicon = new PlansIcon({});
  return {
    c: function c() {
      button = element("button");
      create_component(plansicon.$$.fragment);
      t = text(" Plans");
      attr(button, "data-cy", "plans-btn");
      attr(button, "class", "ms-modal__profile-option");
      toggle_class(button, "ms-modal__profile-option--active", /*displayProfile*/ctx[0] === "plans");
    },
    m: function m(target, anchor) {
      insert(target, button, anchor);
      mount_component(plansicon, button, null);
      append(button, t);
      current = true;
      if (!mounted) {
        dispose = listen(button, "click", /*click_handler_2*/ctx[9]);
        mounted = true;
      }
    },
    p: function p(ctx, dirty) {
      if (dirty & /*displayProfile*/1) {
        toggle_class(button, "ms-modal__profile-option--active", /*displayProfile*/ctx[0] === "plans");
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(plansicon.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(plansicon.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(button);
      destroy_component(plansicon);
      mounted = false;
      dispose();
    }
  };
}
function create_fragment$g(ctx) {
  var t0;
  var button0;
  var securityicon;
  var t1;
  var t2;
  var show_if = /*showPlansNavButton*/ctx[3]();
  var t3;
  var button1;
  var logouticon;
  var t4;
  var current;
  var mounted;
  var dispose;
  var if_block0 = !ctx[1] && create_if_block_1$8(ctx);
  securityicon = new SecurityIcon({});
  var if_block1 = show_if && create_if_block$b(ctx);
  logouticon = new LogoutIcon({});
  return {
    c: function c() {
      if (if_block0) if_block0.c();
      t0 = space();
      button0 = element("button");
      create_component(securityicon.$$.fragment);
      t1 = text(" Security");
      t2 = space();
      if (if_block1) if_block1.c();
      t3 = space();
      button1 = element("button");
      create_component(logouticon.$$.fragment);
      t4 = text(" Logout");
      attr(button0, "data-cy", "security-btn");
      attr(button0, "class", "ms-modal__profile-option");
      toggle_class(button0, "ms-modal__profile-option--active", /*displayProfile*/ctx[0] === "security" || /*displayProfile*/ctx[0] === "changePassword");
      attr(button1, "data-cy", "logout-btn");
      attr(button1, "class", "ms-modal__profile-option");
    },
    m: function m(target, anchor) {
      if (if_block0) if_block0.m(target, anchor);
      insert(target, t0, anchor);
      insert(target, button0, anchor);
      mount_component(securityicon, button0, null);
      append(button0, t1);
      insert(target, t2, anchor);
      if (if_block1) if_block1.m(target, anchor);
      insert(target, t3, anchor);
      insert(target, button1, anchor);
      mount_component(logouticon, button1, null);
      append(button1, t4);
      current = true;
      if (!mounted) {
        dispose = [listen(button0, "click", /*click_handler_1*/ctx[8]), listen(button1, "click", /*logout*/ctx[2])];
        mounted = true;
      }
    },
    p: function p(ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      if (!ctx[1]) {
        if (if_block0) {
          if_block0.p(ctx, dirty);
          if (dirty & /*hideProfileSection*/2) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_1$8(ctx);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(t0.parentNode, t0);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, function () {
          if_block0 = null;
        });
        check_outros();
      }
      if (dirty & /*displayProfile*/1) {
        toggle_class(button0, "ms-modal__profile-option--active", /*displayProfile*/ctx[0] === "security" || /*displayProfile*/ctx[0] === "changePassword");
      }
      if (show_if) if_block1.p(ctx, dirty);
    },
    i: function i(local) {
      if (current) return;
      transition_in(if_block0);
      transition_in(securityicon.$$.fragment, local);
      transition_in(if_block1);
      transition_in(logouticon.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(if_block0);
      transition_out(securityicon.$$.fragment, local);
      transition_out(if_block1);
      transition_out(logouticon.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (if_block0) if_block0.d(detaching);
      if (detaching) detach(t0);
      if (detaching) detach(button0);
      destroy_component(securityicon);
      if (detaching) detach(t2);
      if (if_block1) if_block1.d(detaching);
      if (detaching) detach(t3);
      if (detaching) detach(button1);
      destroy_component(logouticon);
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$d($$self, $$props, $$invalidate) {
  var member = $$props.member;
  var onSuccessLogout = $$props.onSuccessLogout;
  var displayProfile = $$props.displayProfile;
  var profileLoader = $$props.profileLoader;
  var hideProfileSection = $$props.hideProfileSection;
  var unsubscribe = AppStore.subscribe(function (data) {
    if (!data.initialValue) {
      var container = document.getElementById("msOverlay");
      var css = document.createElement("style");
      var color = data.branding.colors.lightMode.primaryButton;
      var fullCSS = ".ms-modal__profile-option:hover { color: " + color + ";} .ms-modal__profile-option--active { color: " + color + ";} .ms-modal__save-button { background: " + color + ";} .ms-modal__save-button:disabled { background: " + color + ";}";
      css.appendChild(document.createTextNode(fullCSS));
      container.appendChild(css);
    }
  });
  onDestroy(function () {
    unsubscribe();
  });
  function logout(e) {
    return __awaiter(this, void 0, void 0, function () {
      var data, err_7;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            return [4 /*yield*/, window.$memberstackDom.logout()];
          case 1:
            data = _a.sent().data;
            window.$memberstackDom._showMessage("Logout successful", false);
            onSuccessLogout({
              type: "LOGOUT",
              data: data
            });
            return [3 /*break*/, 3];
          case 2:
            err_7 = _a.sent();
            window.$memberstackDom._showMessage(err_7.message, true);
            return [3 /*break*/, 3];
          case 3:
            return [2 /*return*/];
        }
      });
    });
  }

  function showPlansNavButton() {
    return member.stripeCustomerId || member.planConnections.some(function (plan) {
      return plan.type === "FREE";
    });
  }
  var click_handler = function click_handler() {
    return $$invalidate(0, displayProfile = "profile");
  };
  var click_handler_1 = function click_handler_1() {
    return $$invalidate(0, displayProfile = "security");
  };
  var click_handler_2 = function click_handler_2() {
    return $$invalidate(0, displayProfile = "plans");
  };
  $$self.$$set = function ($$props) {
    if ('member' in $$props) $$invalidate(4, member = $$props.member);
    if ('onSuccessLogout' in $$props) $$invalidate(5, onSuccessLogout = $$props.onSuccessLogout);
    if ('displayProfile' in $$props) $$invalidate(0, displayProfile = $$props.displayProfile);
    if ('profileLoader' in $$props) $$invalidate(6, profileLoader = $$props.profileLoader);
    if ('hideProfileSection' in $$props) $$invalidate(1, hideProfileSection = $$props.hideProfileSection);
  };
  return [displayProfile, hideProfileSection, logout, showPlansNavButton, member, onSuccessLogout, profileLoader, click_handler, click_handler_1, click_handler_2];
}
var ProfileModalNav = /** @class */function (_super) {
  __extends(ProfileModalNav, _super);
  function ProfileModalNav(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$d, create_fragment$g, safe_not_equal, {
      member: 4,
      onSuccessLogout: 5,
      displayProfile: 0,
      profileLoader: 6,
      hideProfileSection: 1
    });
    return _this;
  }
  return ProfileModalNav;
}(SvelteComponent);
/* src/components/ProfileInfoContent.svelte generated by Svelte v3.48.0 */
function get_each_context$4(ctx, list, i) {
  var child_ctx = ctx.slice();
  child_ctx[5] = list[i];
  child_ctx[6] = list;
  child_ctx[7] = i;
  return child_ctx;
}
// (26:2) {#if customField.hidden !== true}
function create_if_block$a(ctx) {
  var div1;
  var div0;
  var label;
  var t0_value = /*customField*/ctx[5].label + "";
  var t0;
  var label_for_value;
  var t1;
  var input;
  var input_placeholder_value;
  var input_name_value;
  var t2;
  var mounted;
  var dispose;
  function input_input_handler() {
    /*input_input_handler*/ctx[4].call(input, /*customField*/ctx[5]);
  }
  return {
    c: function c() {
      div1 = element("div");
      div0 = element("div");
      label = element("label");
      t0 = text(t0_value);
      t1 = space();
      input = element("input");
      t2 = space();
      attr(label, "class", "ms-form__label");
      attr(label, "for", label_for_value = /*customField*/ctx[5].key);
      attr(input, "class", "ms-form__input");
      attr(input, "type", "text");
      attr(input, "placeholder", input_placeholder_value = /*customField*/ctx[5].label);
      attr(input, "name", input_name_value = /*customField*/ctx[5].key);
      attr(div0, "class", "ms-form__group");
      attr(div1, "class", "ms-modal__custom-field-container");
    },
    m: function m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, div0);
      append(div0, label);
      append(label, t0);
      append(div0, t1);
      append(div0, input);
      set_input_value(input, /*member*/ctx[0].customFields[/*customField*/ctx[5].key]);
      append(div1, t2);
      if (!mounted) {
        dispose = listen(input, "input", input_input_handler);
        mounted = true;
      }
    },
    p: function p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty & /*customFields*/2 && t0_value !== (t0_value = /*customField*/ctx[5].label + "")) set_data(t0, t0_value);
      if (dirty & /*customFields*/2 && label_for_value !== (label_for_value = /*customField*/ctx[5].key)) {
        attr(label, "for", label_for_value);
      }
      if (dirty & /*customFields*/2 && input_placeholder_value !== (input_placeholder_value = /*customField*/ctx[5].label)) {
        attr(input, "placeholder", input_placeholder_value);
      }
      if (dirty & /*customFields*/2 && input_name_value !== (input_name_value = /*customField*/ctx[5].key)) {
        attr(input, "name", input_name_value);
      }
      if (dirty & /*member, customFields*/3 && input.value !== /*member*/ctx[0].customFields[/*customField*/ctx[5].key]) {
        set_input_value(input, /*member*/ctx[0].customFields[/*customField*/ctx[5].key]);
      }
    },
    d: function d(detaching) {
      if (detaching) detach(div1);
      mounted = false;
      dispose();
    }
  };
}
// (25:1) {#each customFields as customField, i}
function create_each_block$4(ctx) {
  var if_block_anchor;
  var if_block = /*customField*/ctx[5].hidden !== true && create_if_block$a(ctx);
  return {
    c: function c() {
      if (if_block) if_block.c();
      if_block_anchor = empty();
    },
    m: function m(target, anchor) {
      if (if_block) if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p: function p(ctx, dirty) {
      if ( /*customField*/ctx[5].hidden !== true) {
        if (if_block) {
          if_block.p(ctx, dirty);
        } else {
          if_block = create_if_block$a(ctx);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    d: function d(detaching) {
      if (if_block) if_block.d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
function create_fragment$f(ctx) {
  var div1;
  var h2;
  var t1;
  var div0;
  var button;
  var t3;
  var form;
  var mounted;
  var dispose;
  var each_value = /*customFields*/ctx[1];
  var each_blocks = [];
  for (var i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$4(get_each_context$4(ctx, each_value, i));
  }
  return {
    c: function c() {
      div1 = element("div");
      h2 = element("h2");
      h2.textContent = "Profile Information";
      t1 = space();
      div0 = element("div");
      button = element("button");
      button.textContent = "Save";
      t3 = space();
      form = element("form");
      for (var i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      attr(h2, "class", "ms-modal__title ms-modal__title--profile");
      attr(button, "class", "ms-modal__save-button");
      attr(div0, "class", "ms-modal__action-container");
      attr(div1, "class", "ms-modal__title-container");
      attr(form, "class", "ms-form");
      attr(form, "action", "");
      attr(form, "method", "post");
      attr(form, "autocomplete", "off");
    },
    m: function m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, h2);
      append(div1, t1);
      append(div1, div0);
      append(div0, button);
      insert(target, t3, anchor);
      insert(target, form, anchor);
      for (var i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].m(form, null);
      }
      if (!mounted) {
        dispose = [listen(button, "click", /*saveProfile*/ctx[2]), listen(form, "submit", stop_propagation(prevent_default( /*saveProfile*/ctx[2])))];
        mounted = true;
      }
    },
    p: function p(ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      if (dirty & /*customFields, member*/3) {
        each_value = /*customFields*/ctx[1];
        var i = void 0;
        for (i = 0; i < each_value.length; i += 1) {
          var child_ctx = get_each_context$4(ctx, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
          } else {
            each_blocks[i] = create_each_block$4(child_ctx);
            each_blocks[i].c();
            each_blocks[i].m(form, null);
          }
        }
        for (; i < each_blocks.length; i += 1) {
          each_blocks[i].d(1);
        }
        each_blocks.length = each_value.length;
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(div1);
      if (detaching) detach(t3);
      if (detaching) detach(form);
      destroy_each(each_blocks, detaching);
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$c($$self, $$props, $$invalidate) {
  var customFields = $$props.customFields;
  var member = $$props.member;
  var profileLoader = $$props.profileLoader;
  function saveProfile(e) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            $$invalidate(3, profileLoader = true);
            return [4 /*yield*/, window.$memberstackDom.updateMember({
              customFields: member.customFields
            })];
          case 1:
            _a.sent();
            $$invalidate(3, profileLoader = false);
            return [2 /*return*/];
        }
      });
    });
  }

  function input_input_handler(customField) {
    member.customFields[customField.key] = this.value;
    $$invalidate(0, member);
  }
  $$self.$$set = function ($$props) {
    if ('customFields' in $$props) $$invalidate(1, customFields = $$props.customFields);
    if ('member' in $$props) $$invalidate(0, member = $$props.member);
    if ('profileLoader' in $$props) $$invalidate(3, profileLoader = $$props.profileLoader);
  };
  return [member, customFields, saveProfile, profileLoader, input_input_handler];
}
var ProfileInfoContent = /** @class */function (_super) {
  __extends(ProfileInfoContent, _super);
  function ProfileInfoContent(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$c, create_fragment$f, safe_not_equal, {
      customFields: 1,
      member: 0,
      profileLoader: 3
    });
    return _this;
  }
  return ProfileInfoContent;
}(SvelteComponent);
/* src/icons/PasswordLockIcon.svelte generated by Svelte v3.48.0 */
function create_fragment$e(ctx) {
  var svg;
  var path;
  return {
    c: function c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "m14 7h-1v-2c0-2.76-2.24-5-5-5s-5 2.24-5 5v2h-1c-1.1 0-2 0.9-2 2v10c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-10c0-1.1-0.9-2-2-2zm-9-2c0-1.66 1.34-3 3-3s3 1.34 3 3v2h-6v-2zm9 14h-12v-10h12v10zm-6-3c1.1 0 2-0.9 2-2s-0.9-2-2-2-2 0.9-2 2 0.9 2 2 2z");
      attr(svg, "fill", "none");
      attr(svg, "viewBox", "0 0 16 21");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m: function m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(svg);
    }
  };
}
var PasswordLockIcon = /** @class */function (_super) {
  __extends(PasswordLockIcon, _super);
  function PasswordLockIcon(options) {
    var _this = _super.call(this) || this;
    init(_this, options, null, create_fragment$e, safe_not_equal, {});
    return _this;
  }
  return PasswordLockIcon;
}(SvelteComponent);
/* src/components/SecurityInfoContent.svelte generated by Svelte v3.48.0 */
function get_each_context$3(ctx, list, i) {
  var child_ctx = ctx.slice();
  child_ctx[16] = list[i];
  return child_ctx;
}
// (97:69) {:else}
function create_else_block_1$1(ctx) {
  var t;
  return {
    c: function c() {
      t = text("Change Password");
    },
    m: function m(target, anchor) {
      insert(target, t, anchor);
    },
    d: function d(detaching) {
      if (detaching) detach(t);
    }
  };
}
// (97:25) {#if !member.auth.hasPassword}
function create_if_block_2$5(ctx) {
  var t;
  return {
    c: function c() {
      t = text("Set Password");
    },
    m: function m(target, anchor) {
      insert(target, t, anchor);
    },
    d: function d(detaching) {
      if (detaching) detach(t);
    }
  };
}
// (101:0) {#if $app.authProviders.length > 0}
function create_if_block$9(ctx) {
  var p;
  var t1;
  var div;
  var each_blocks = [];
  var each_1_lookup = new Map();
  var each_value = /*$app*/ctx[4].authProviders;
  var get_key = function get_key(ctx) {
    /*provider*/return ctx[16].provider;
  };
  for (var i = 0; i < each_value.length; i += 1) {
    var child_ctx = get_each_context$3(ctx, each_value, i);
    var key = get_key(child_ctx);
    each_1_lookup.set(key, each_blocks[i] = create_each_block$3(key, child_ctx));
  }
  return {
    c: function c() {
      p = element("p");
      p.textContent = "Connect Additional Accounts";
      t1 = space();
      div = element("div");
      for (var i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      attr(p, "class", "ms-form__label");
      attr(div, "class", "ms-modal__social");
    },
    m: function m(target, anchor) {
      insert(target, p, anchor);
      insert(target, t1, anchor);
      insert(target, div, anchor);
      for (var i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].m(div, null);
      }
    },
    p: function p(ctx, dirty) {
      if (dirty & /*disconnectProvider, $app, member, connectAdditionalProvider*/210) {
        each_value = /*$app*/ctx[4].authProviders;
        each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, div, destroy_block, create_each_block$3, null, get_each_context$3);
      }
    },
    d: function d(detaching) {
      if (detaching) detach(p);
      if (detaching) detach(t1);
      if (detaching) detach(div);
      for (var i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].d();
      }
    }
  };
}
// (111:6) {:else}
function create_else_block$4(ctx) {
  var button;
  var img;
  var img_src_value;
  var img_alt_value;
  var t0;
  var span;
  var t1;
  var t2_value = /*provider*/ctx[16].name + "";
  var t2;
  var mounted;
  var dispose;
  function click_handler_2() {
    return (/*click_handler_2*/ctx[14]( /*provider*/ctx[16])
    );
  }
  return {
    c: function c() {
      button = element("button");
      img = element("img");
      t0 = space();
      span = element("span");
      t1 = text("Connect with ");
      t2 = text(t2_value);
      if (!src_url_equal(img.src, img_src_value = /*provider*/ctx[16].icon)) attr(img, "src", img_src_value);
      attr(img, "alt", img_alt_value = /*provider*/ctx[16].name);
      attr(button, "class", "ms-modal__social-button");
      attr(button, "type", "button");
    },
    m: function m(target, anchor) {
      insert(target, button, anchor);
      append(button, img);
      append(button, t0);
      append(button, span);
      append(span, t1);
      append(span, t2);
      if (!mounted) {
        dispose = listen(button, "click", click_handler_2);
        mounted = true;
      }
    },
    p: function p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty & /*$app*/16 && !src_url_equal(img.src, img_src_value = /*provider*/ctx[16].icon)) {
        attr(img, "src", img_src_value);
      }
      if (dirty & /*$app*/16 && img_alt_value !== (img_alt_value = /*provider*/ctx[16].name)) {
        attr(img, "alt", img_alt_value);
      }
      if (dirty & /*$app*/16 && t2_value !== (t2_value = /*provider*/ctx[16].name + "")) set_data(t2, t2_value);
    },
    d: function d(detaching) {
      if (detaching) detach(button);
      mounted = false;
      dispose();
    }
  };
}
// (106:6) {#if member.auth.providers.some((prv) => prv.provider === provider.provider)}
function create_if_block_1$7(ctx) {
  var button;
  var img;
  var img_src_value;
  var img_alt_value;
  var t0;
  var span;
  var t1;
  var t2_value = /*provider*/ctx[16].name + "";
  var t2;
  var mounted;
  var dispose;
  function click_handler_1() {
    return (/*click_handler_1*/ctx[13]( /*provider*/ctx[16])
    );
  }
  return {
    c: function c() {
      button = element("button");
      img = element("img");
      t0 = space();
      span = element("span");
      t1 = text("Disconnect ");
      t2 = text(t2_value);
      if (!src_url_equal(img.src, img_src_value = /*provider*/ctx[16].icon)) attr(img, "src", img_src_value);
      attr(img, "alt", img_alt_value = /*provider*/ctx[16].name);
      attr(button, "class", "ms-modal__social-button");
      set_style(button, "background-color", "#F6F6F6");
      attr(button, "type", "button");
    },
    m: function m(target, anchor) {
      insert(target, button, anchor);
      append(button, img);
      append(button, t0);
      append(button, span);
      append(span, t1);
      append(span, t2);
      if (!mounted) {
        dispose = listen(button, "click", click_handler_1);
        mounted = true;
      }
    },
    p: function p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty & /*$app*/16 && !src_url_equal(img.src, img_src_value = /*provider*/ctx[16].icon)) {
        attr(img, "src", img_src_value);
      }
      if (dirty & /*$app*/16 && img_alt_value !== (img_alt_value = /*provider*/ctx[16].name)) {
        attr(img, "alt", img_alt_value);
      }
      if (dirty & /*$app*/16 && t2_value !== (t2_value = /*provider*/ctx[16].name + "")) set_data(t2, t2_value);
    },
    d: function d(detaching) {
      if (detaching) detach(button);
      mounted = false;
      dispose();
    }
  };
}
// (104:2) {#each $app.authProviders as provider (provider.provider)}
function create_each_block$3(key_1, ctx) {
  var div;
  var show_if;
  var t;
  function func() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    return (/*func*/ctx[9].apply( /*func*/ctx, __spread([/*provider*/ctx[16]], args))
    );
  }
  function select_block_type_1(ctx, dirty) {
    if (dirty & /*member, $app*/18) show_if = null;
    if (show_if == null) show_if = !!ctx[1].auth.providers.some(func);
    if (show_if) return create_if_block_1$7;
    return create_else_block$4;
  }
  var current_block_type = select_block_type_1(ctx, -1);
  var if_block = current_block_type(ctx);
  return {
    key: key_1,
    first: null,
    c: function c() {
      div = element("div");
      if_block.c();
      t = space();
      attr(div, "class", "ms-modal__social-buttons");
      this.first = div;
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      if_block.m(div, null);
      append(div, t);
    },
    p: function p(new_ctx, dirty) {
      ctx = new_ctx;
      if (current_block_type === (current_block_type = select_block_type_1(ctx, dirty)) && if_block) {
        if_block.p(ctx, dirty);
      } else {
        if_block.d(1);
        if_block = current_block_type(ctx);
        if (if_block) {
          if_block.c();
          if_block.m(div, t);
        }
      }
    },
    d: function d(detaching) {
      if (detaching) detach(div);
      if_block.d();
    }
  };
}
function create_fragment$d(ctx) {
  var div1;
  var h2;
  var t1;
  var div0;
  var button0;
  var t2;
  var button0_disabled_value;
  var t3;
  var form;
  var emailinput;
  var updating_emailInputValid;
  var updating_emailValue;
  var t4;
  var div2;
  var label;
  var t6;
  var button1;
  var passwordlockicon;
  var t7;
  var t8;
  var if_block1_anchor;
  var current;
  var mounted;
  var dispose;
  function emailinput_emailInputValid_binding(value) {
    /*emailinput_emailInputValid_binding*/ctx[10](value);
  }
  function emailinput_emailValue_binding(value) {
    /*emailinput_emailValue_binding*/ctx[11](value);
  }
  var emailinput_props = {};
  if ( /*emailInputValid*/ctx[3] !== void 0) {
    emailinput_props.emailInputValid = /*emailInputValid*/ctx[3];
  }
  if ( /*emailValue*/ctx[2] !== void 0) {
    emailinput_props.emailValue = /*emailValue*/ctx[2];
  }
  emailinput = new EmailInput({
    props: emailinput_props
  });
  binding_callbacks.push(function () {
    return bind(emailinput, 'emailInputValid', emailinput_emailInputValid_binding);
  });
  binding_callbacks.push(function () {
    return bind(emailinput, 'emailValue', emailinput_emailValue_binding);
  });
  passwordlockicon = new PasswordLockIcon({});
  function select_block_type(ctx, dirty) {
    if (!ctx[1].auth.hasPassword) return create_if_block_2$5;
    return create_else_block_1$1;
  }
  var current_block_type = select_block_type(ctx);
  var if_block0 = current_block_type(ctx);
  var if_block1 = /*$app*/ctx[4].authProviders.length > 0 && create_if_block$9(ctx);
  return {
    c: function c() {
      div1 = element("div");
      h2 = element("h2");
      h2.textContent = "Security";
      t1 = space();
      div0 = element("div");
      button0 = element("button");
      t2 = text("Save");
      t3 = space();
      form = element("form");
      create_component(emailinput.$$.fragment);
      t4 = space();
      div2 = element("div");
      label = element("label");
      label.textContent = "Password";
      t6 = space();
      button1 = element("button");
      create_component(passwordlockicon.$$.fragment);
      t7 = space();
      if_block0.c();
      t8 = space();
      if (if_block1) if_block1.c();
      if_block1_anchor = empty();
      attr(h2, "class", "ms-modal__title ms-modal__title--profile");
      attr(button0, "class", "ms-modal__save-button");
      button0.disabled = button0_disabled_value = !ctx[3];
      attr(div0, "class", "ms-modal__action-container");
      attr(div1, "class", "ms-modal__title-container");
      attr(form, "class", "ms-form");
      attr(form, "action", "");
      attr(form, "method", "post");
      attr(form, "autocomplete", "off");
      attr(label, "class", "ms-form__label");
      attr(label, "for", "setPassword");
      attr(button1, "data-cy", "change-password-btn");
      attr(button1, "class", "ms-modal__outline-button");
      attr(button1, "name", "setPassword");
      attr(div2, "class", "ms-form__group");
    },
    m: function m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, h2);
      append(div1, t1);
      append(div1, div0);
      append(div0, button0);
      append(button0, t2);
      insert(target, t3, anchor);
      insert(target, form, anchor);
      mount_component(emailinput, form, null);
      insert(target, t4, anchor);
      insert(target, div2, anchor);
      append(div2, label);
      append(div2, t6);
      append(div2, button1);
      mount_component(passwordlockicon, button1, null);
      append(button1, t7);
      if_block0.m(button1, null);
      insert(target, t8, anchor);
      if (if_block1) if_block1.m(target, anchor);
      insert(target, if_block1_anchor, anchor);
      current = true;
      if (!mounted) {
        dispose = [listen(button0, "click", /*submitEmailChange*/ctx[5]), listen(form, "submit", stop_propagation(prevent_default( /*submitEmailChange*/ctx[5]))), listen(button1, "click", /*click_handler*/ctx[12])];
        mounted = true;
      }
    },
    p: function p(ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      if (!current || dirty & /*emailInputValid*/8 && button0_disabled_value !== (button0_disabled_value = !ctx[3])) {
        button0.disabled = button0_disabled_value;
      }
      var emailinput_changes = {};
      if (!updating_emailInputValid && dirty & /*emailInputValid*/8) {
        updating_emailInputValid = true;
        emailinput_changes.emailInputValid = /*emailInputValid*/ctx[3];
        add_flush_callback(function () {
          return updating_emailInputValid = false;
        });
      }
      if (!updating_emailValue && dirty & /*emailValue*/4) {
        updating_emailValue = true;
        emailinput_changes.emailValue = /*emailValue*/ctx[2];
        add_flush_callback(function () {
          return updating_emailValue = false;
        });
      }
      emailinput.$set(emailinput_changes);
      if (current_block_type !== (current_block_type = select_block_type(ctx))) {
        if_block0.d(1);
        if_block0 = current_block_type(ctx);
        if (if_block0) {
          if_block0.c();
          if_block0.m(button1, null);
        }
      }
      if ( /*$app*/ctx[4].authProviders.length > 0) {
        if (if_block1) {
          if_block1.p(ctx, dirty);
        } else {
          if_block1 = create_if_block$9(ctx);
          if_block1.c();
          if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
        }
      } else if (if_block1) {
        if_block1.d(1);
        if_block1 = null;
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(emailinput.$$.fragment, local);
      transition_in(passwordlockicon.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(emailinput.$$.fragment, local);
      transition_out(passwordlockicon.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div1);
      if (detaching) detach(t3);
      if (detaching) detach(form);
      destroy_component(emailinput);
      if (detaching) detach(t4);
      if (detaching) detach(div2);
      destroy_component(passwordlockicon);
      if_block0.d();
      if (detaching) detach(t8);
      if (if_block1) if_block1.d(detaching);
      if (detaching) detach(if_block1_anchor);
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$b($$self, $$props, $$invalidate) {
  var $app;
  component_subscribe($$self, AppStore, function ($$value) {
    return $$invalidate(4, $app = $$value);
  });
  var displayProfile = $$props.displayProfile;
  var member = $$props.member;
  var emailValue = $$props.emailValue;
  var profileLoader = $$props.profileLoader;
  // sort
  $app.authProviders.sort(function (a, b) {
    if (isConnected(a) === isConnected(b)) {
      return a.order - b.order;
    }
    return isConnected(a) ? -1 : 1;
  });
  var emailInputValid = false;
  function submitEmailChange(e) {
    return __awaiter(this, void 0, void 0, function () {
      var err_8;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!emailInputValid || !emailValue) return [2 /*return*/];
            $$invalidate(8, profileLoader = true);
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, window.$memberstackDom.updateMemberAuth({
              email: emailValue
            })];
          case 2:
            _a.sent();
            window.$memberstackDom._showMessage("Email successfully changed", false);
            $$invalidate(8, profileLoader = false);
            return [3 /*break*/, 4];
          case 3:
            err_8 = _a.sent();
            window.$memberstackDom._showMessage(err_8.message, true);
            $$invalidate(8, profileLoader = false);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  }

  function disconnectProvider(provider) {
    return __awaiter(this, void 0, void 0, function () {
      var data, err_9;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            $$invalidate(8, profileLoader = true);
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, window.$memberstackDom.disconnectProvider({
              provider: provider
            })];
          case 2:
            data = _a.sent().data;
            $$invalidate(1, member = __assign(__assign({}, member), {
              auth: __assign(__assign({}, member.auth), {
                providers: data.providers
              })
            }));
            window.$memberstackDom._showMessage("Provider successfully disconnected", false);
            $$invalidate(8, profileLoader = false);
            return [3 /*break*/, 4];
          case 3:
            err_9 = _a.sent();
            window.$memberstackDom._showMessage(err_9.message, true);
            $$invalidate(8, profileLoader = false);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  }

  function connectAdditionalProvider(provider) {
    return __awaiter(this, void 0, void 0, function () {
      var data, err_10;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            console.log("connect", provider);
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, window.$memberstackDom.connectProvider({
              provider: provider
            })];
          case 2:
            data = _a.sent().data;
            $$invalidate(1, member = __assign(__assign({}, member), {
              auth: __assign(__assign({}, member.auth), {
                providers: data.providers
              })
            }));
            window.$memberstackDom._showMessage("You have successfully connected your account.", false);
            return [3 /*break*/, 4];
          case 3:
            err_10 = _a.sent();
            window.$memberstackDom._showMessage(err_10.message, true);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  }

  function isConnected(provider) {
    return member.auth.providers.some(function (prv) {
      return prv.provider === provider.provider;
    });
  }
  var func = function func(provider, prv) {
    return prv.provider === provider.provider;
  };
  function emailinput_emailInputValid_binding(value) {
    emailInputValid = value;
    $$invalidate(3, emailInputValid);
  }
  function emailinput_emailValue_binding(value) {
    emailValue = value;
    $$invalidate(2, emailValue);
  }
  var click_handler = function click_handler() {
    return $$invalidate(0, displayProfile = "changePassword");
  };
  var click_handler_1 = function click_handler_1(provider) {
    return disconnectProvider(provider.provider);
  };
  var click_handler_2 = function click_handler_2(provider) {
    return connectAdditionalProvider(provider.provider);
  };
  $$self.$$set = function ($$props) {
    if ('displayProfile' in $$props) $$invalidate(0, displayProfile = $$props.displayProfile);
    if ('member' in $$props) $$invalidate(1, member = $$props.member);
    if ('emailValue' in $$props) $$invalidate(2, emailValue = $$props.emailValue);
    if ('profileLoader' in $$props) $$invalidate(8, profileLoader = $$props.profileLoader);
  };
  return [displayProfile, member, emailValue, emailInputValid, $app, submitEmailChange, disconnectProvider, connectAdditionalProvider, profileLoader, func, emailinput_emailInputValid_binding, emailinput_emailValue_binding, click_handler, click_handler_1, click_handler_2];
}
var SecurityInfoContent = /** @class */function (_super) {
  __extends(SecurityInfoContent, _super);
  function SecurityInfoContent(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$b, create_fragment$d, safe_not_equal, {
      displayProfile: 0,
      member: 1,
      emailValue: 2,
      profileLoader: 8
    });
    return _this;
  }
  return SecurityInfoContent;
}(SvelteComponent);
/* src/components/PasswordInfoContent.svelte generated by Svelte v3.48.0 */
function create_else_block$3(ctx) {
  var t;
  return {
    c: function c() {
      t = text("Change Password");
    },
    m: function m(target, anchor) {
      insert(target, t, anchor);
    },
    d: function d(detaching) {
      if (detaching) detach(t);
    }
  };
}
// (63:4) {#if !member.auth.hasPassword}
function create_if_block_1$6(ctx) {
  var t;
  return {
    c: function c() {
      t = text("Set Password");
    },
    m: function m(target, anchor) {
      insert(target, t, anchor);
    },
    d: function d(detaching) {
      if (detaching) detach(t);
    }
  };
}
// (71:2) {#if member.auth.hasPassword}
function create_if_block$8(ctx) {
  var passwordinput;
  var updating_passwordValue;
  var updating_passwordInputValid;
  var current;
  function passwordinput_passwordValue_binding(value) {
    /*passwordinput_passwordValue_binding*/ctx[11](value);
  }
  function passwordinput_passwordInputValid_binding(value) {
    /*passwordinput_passwordInputValid_binding*/ctx[12](value);
  }
  var passwordinput_props = {
    passwordLabel: "Current Password",
    passwordPlaceholder: "Enter a strong password"
  };
  if ( /*currentPasswordValue*/ctx[2] !== void 0) {
    passwordinput_props.passwordValue = /*currentPasswordValue*/ctx[2];
  }
  if ( /*currentPasswordValid*/ctx[5] !== void 0) {
    passwordinput_props.passwordInputValid = /*currentPasswordValid*/ctx[5];
  }
  passwordinput = new PasswordInput({
    props: passwordinput_props
  });
  binding_callbacks.push(function () {
    return bind(passwordinput, 'passwordValue', passwordinput_passwordValue_binding);
  });
  binding_callbacks.push(function () {
    return bind(passwordinput, 'passwordInputValid', passwordinput_passwordInputValid_binding);
  });
  return {
    c: function c() {
      create_component(passwordinput.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(passwordinput, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var passwordinput_changes = {};
      if (!updating_passwordValue && dirty & /*currentPasswordValue*/4) {
        updating_passwordValue = true;
        passwordinput_changes.passwordValue = /*currentPasswordValue*/ctx[2];
        add_flush_callback(function () {
          return updating_passwordValue = false;
        });
      }
      if (!updating_passwordInputValid && dirty & /*currentPasswordValid*/32) {
        updating_passwordInputValid = true;
        passwordinput_changes.passwordInputValid = /*currentPasswordValid*/ctx[5];
        add_flush_callback(function () {
          return updating_passwordInputValid = false;
        });
      }
      passwordinput.$set(passwordinput_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(passwordinput.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(passwordinput.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(passwordinput, detaching);
    }
  };
}
function create_fragment$c(ctx) {
  var div3;
  var div1;
  var div0;
  var button0;
  var backicon;
  var t0;
  var h2;
  var t1;
  var div2;
  var button1;
  var t2;
  var button1_disabled_value;
  var t3;
  var form;
  var t4;
  var passwordinput0;
  var updating_passwordValue;
  var updating_passwordInputValid;
  var t5;
  var passwordinput1;
  var updating_passwordValue_1;
  var updating_passwordInputValid_1;
  var current;
  var mounted;
  var dispose;
  backicon = new BackIcon({});
  function select_block_type(ctx, dirty) {
    if (!ctx[1].auth.hasPassword) return create_if_block_1$6;
    return create_else_block$3;
  }
  var current_block_type = select_block_type(ctx);
  var if_block0 = current_block_type(ctx);
  var if_block1 = /*member*/ctx[1].auth.hasPassword && create_if_block$8(ctx);
  function passwordinput0_passwordValue_binding(value) {
    /*passwordinput0_passwordValue_binding*/ctx[13](value);
  }
  function passwordinput0_passwordInputValid_binding(value) {
    /*passwordinput0_passwordInputValid_binding*/ctx[14](value);
  }
  var passwordinput0_props = {
    passwordLabel: "New Password",
    passwordPlaceholder: "Enter a strong password"
  };
  if ( /*newPasswordValue*/ctx[3] !== void 0) {
    passwordinput0_props.passwordValue = /*newPasswordValue*/ctx[3];
  }
  if ( /*newPasswordValid*/ctx[6] !== void 0) {
    passwordinput0_props.passwordInputValid = /*newPasswordValid*/ctx[6];
  }
  passwordinput0 = new PasswordInput({
    props: passwordinput0_props
  });
  binding_callbacks.push(function () {
    return bind(passwordinput0, 'passwordValue', passwordinput0_passwordValue_binding);
  });
  binding_callbacks.push(function () {
    return bind(passwordinput0, 'passwordInputValid', passwordinput0_passwordInputValid_binding);
  });
  function passwordinput1_passwordValue_binding(value) {
    /*passwordinput1_passwordValue_binding*/ctx[15](value);
  }
  function passwordinput1_passwordInputValid_binding(value) {
    /*passwordinput1_passwordInputValid_binding*/ctx[16](value);
  }
  var passwordinput1_props = {
    passwordLabel: "Confirm New Password",
    passwordPlaceholder: "Enter a strong password"
  };
  if ( /*confirmPasswordValue*/ctx[4] !== void 0) {
    passwordinput1_props.passwordValue = /*confirmPasswordValue*/ctx[4];
  }
  if ( /*confirmPasswordValid*/ctx[7] !== void 0) {
    passwordinput1_props.passwordInputValid = /*confirmPasswordValid*/ctx[7];
  }
  passwordinput1 = new PasswordInput({
    props: passwordinput1_props
  });
  binding_callbacks.push(function () {
    return bind(passwordinput1, 'passwordValue', passwordinput1_passwordValue_binding);
  });
  binding_callbacks.push(function () {
    return bind(passwordinput1, 'passwordInputValid', passwordinput1_passwordInputValid_binding);
  });
  return {
    c: function c() {
      div3 = element("div");
      div1 = element("div");
      div0 = element("div");
      button0 = element("button");
      create_component(backicon.$$.fragment);
      t0 = space();
      h2 = element("h2");
      if_block0.c();
      t1 = space();
      div2 = element("div");
      button1 = element("button");
      t2 = text("Save");
      t3 = space();
      form = element("form");
      if (if_block1) if_block1.c();
      t4 = space();
      create_component(passwordinput0.$$.fragment);
      t5 = space();
      create_component(passwordinput1.$$.fragment);
      attr(div0, "class", "ms-modal__profile-back");
      attr(h2, "class", "ms-modal__title ms-modal__title--profile");
      attr(div1, "class", "ms-modal__title-group");
      attr(button1, "class", "ms-modal__save-button");
      button1.disabled = button1_disabled_value = /*member*/ctx[1].auth.hasPassword && !ctx[5] || !ctx[6] || !ctx[7];
      attr(div2, "class", "ms-modal__action-container");
      attr(div3, "class", "ms-modal__title-container");
      attr(form, "class", "ms-form");
      attr(form, "action", "");
      attr(form, "method", "post");
      attr(form, "autocomplete", "off");
    },
    m: function m(target, anchor) {
      insert(target, div3, anchor);
      append(div3, div1);
      append(div1, div0);
      append(div0, button0);
      mount_component(backicon, button0, null);
      append(div1, t0);
      append(div1, h2);
      if_block0.m(h2, null);
      append(div3, t1);
      append(div3, div2);
      append(div2, button1);
      append(button1, t2);
      insert(target, t3, anchor);
      insert(target, form, anchor);
      if (if_block1) if_block1.m(form, null);
      append(form, t4);
      mount_component(passwordinput0, form, null);
      append(form, t5);
      mount_component(passwordinput1, form, null);
      current = true;
      if (!mounted) {
        dispose = [listen(button0, "click", /*click_handler*/ctx[10]), listen(button1, "click", /*submitPasswordChange*/ctx[8]), listen(form, "submit", stop_propagation(prevent_default( /*submitPasswordChange*/ctx[8])))];
        mounted = true;
      }
    },
    p: function p(ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      if (current_block_type !== (current_block_type = select_block_type(ctx))) {
        if_block0.d(1);
        if_block0 = current_block_type(ctx);
        if (if_block0) {
          if_block0.c();
          if_block0.m(h2, null);
        }
      }
      if (!current || dirty & /*member, currentPasswordValid, newPasswordValid, confirmPasswordValid*/226 && button1_disabled_value !== (button1_disabled_value = /*member*/ctx[1].auth.hasPassword && !ctx[5] || !ctx[6] || !ctx[7])) {
        button1.disabled = button1_disabled_value;
      }
      if ( /*member*/ctx[1].auth.hasPassword) {
        if (if_block1) {
          if_block1.p(ctx, dirty);
          if (dirty & /*member*/2) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block$8(ctx);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(form, t4);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, function () {
          if_block1 = null;
        });
        check_outros();
      }
      var passwordinput0_changes = {};
      if (!updating_passwordValue && dirty & /*newPasswordValue*/8) {
        updating_passwordValue = true;
        passwordinput0_changes.passwordValue = /*newPasswordValue*/ctx[3];
        add_flush_callback(function () {
          return updating_passwordValue = false;
        });
      }
      if (!updating_passwordInputValid && dirty & /*newPasswordValid*/64) {
        updating_passwordInputValid = true;
        passwordinput0_changes.passwordInputValid = /*newPasswordValid*/ctx[6];
        add_flush_callback(function () {
          return updating_passwordInputValid = false;
        });
      }
      passwordinput0.$set(passwordinput0_changes);
      var passwordinput1_changes = {};
      if (!updating_passwordValue_1 && dirty & /*confirmPasswordValue*/16) {
        updating_passwordValue_1 = true;
        passwordinput1_changes.passwordValue = /*confirmPasswordValue*/ctx[4];
        add_flush_callback(function () {
          return updating_passwordValue_1 = false;
        });
      }
      if (!updating_passwordInputValid_1 && dirty & /*confirmPasswordValid*/128) {
        updating_passwordInputValid_1 = true;
        passwordinput1_changes.passwordInputValid = /*confirmPasswordValid*/ctx[7];
        add_flush_callback(function () {
          return updating_passwordInputValid_1 = false;
        });
      }
      passwordinput1.$set(passwordinput1_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(backicon.$$.fragment, local);
      transition_in(if_block1);
      transition_in(passwordinput0.$$.fragment, local);
      transition_in(passwordinput1.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(backicon.$$.fragment, local);
      transition_out(if_block1);
      transition_out(passwordinput0.$$.fragment, local);
      transition_out(passwordinput1.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div3);
      destroy_component(backicon);
      if_block0.d();
      if (detaching) detach(t3);
      if (detaching) detach(form);
      if (if_block1) if_block1.d();
      destroy_component(passwordinput0);
      destroy_component(passwordinput1);
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$a($$self, $$props, $$invalidate) {
  var displayProfile = $$props.displayProfile;
  var profileLoader = $$props.profileLoader;
  var member = $$props.member;
  var currentPasswordValue = "";
  var newPasswordValue = "";
  var confirmPasswordValue = "";
  var currentPasswordValid = false;
  var newPasswordValid = false;
  var confirmPasswordValid = false;
  function submitPasswordChange(e) {
    return __awaiter(this, void 0, void 0, function () {
      var err_11;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (member.auth.hasPassword && !currentPasswordValid && !newPasswordValid && !confirmPasswordValid) return [2 /*return*/];
            if (!member.auth.hasPassword && !newPasswordValid && !confirmPasswordValid) return [2 /*return*/];
            if (newPasswordValue !== confirmPasswordValue) {
              window.$memberstackDom._showMessage("New password and confirm password do not match", true);
              return [2 /*return*/];
            }

            $$invalidate(9, profileLoader = true);
            _a.label = 1;
          case 1:
            _a.trys.push([1, 6,, 7]);
            if (!member.auth.hasPassword) return [3 /*break*/, 3];
            return [4 /*yield*/, window.$memberstackDom.updateMemberAuth({
              oldPassword: currentPasswordValue,
              newPassword: newPasswordValue
            })];
          case 2:
            _a.sent();
            return [3 /*break*/, 5];
          case 3:
            return [4 /*yield*/, window.$memberstackDom.setPassword({
              password: newPasswordValue
            })];
          case 4:
            _a.sent();
            $$invalidate(1, member.auth.hasPassword = true, member);
            _a.label = 5;
          case 5:
            window.$memberstackDom._showMessage("Password successfully changed", false);
            $$invalidate(2, currentPasswordValue = "");
            $$invalidate(3, newPasswordValue = "");
            $$invalidate(4, confirmPasswordValue = "");
            $$invalidate(9, profileLoader = false);
            return [3 /*break*/, 7];
          case 6:
            err_11 = _a.sent();
            window.$memberstackDom._showMessage(err_11.message, true);
            $$invalidate(9, profileLoader = false);
            return [3 /*break*/, 7];
          case 7:
            return [2 /*return*/];
        }
      });
    });
  }

  var click_handler = function click_handler() {
    return $$invalidate(0, displayProfile = "security");
  };
  function passwordinput_passwordValue_binding(value) {
    currentPasswordValue = value;
    $$invalidate(2, currentPasswordValue);
  }
  function passwordinput_passwordInputValid_binding(value) {
    currentPasswordValid = value;
    $$invalidate(5, currentPasswordValid);
  }
  function passwordinput0_passwordValue_binding(value) {
    newPasswordValue = value;
    $$invalidate(3, newPasswordValue);
  }
  function passwordinput0_passwordInputValid_binding(value) {
    newPasswordValid = value;
    $$invalidate(6, newPasswordValid);
  }
  function passwordinput1_passwordValue_binding(value) {
    confirmPasswordValue = value;
    $$invalidate(4, confirmPasswordValue);
  }
  function passwordinput1_passwordInputValid_binding(value) {
    confirmPasswordValid = value;
    $$invalidate(7, confirmPasswordValid);
  }
  $$self.$$set = function ($$props) {
    if ('displayProfile' in $$props) $$invalidate(0, displayProfile = $$props.displayProfile);
    if ('profileLoader' in $$props) $$invalidate(9, profileLoader = $$props.profileLoader);
    if ('member' in $$props) $$invalidate(1, member = $$props.member);
  };
  return [displayProfile, member, currentPasswordValue, newPasswordValue, confirmPasswordValue, currentPasswordValid, newPasswordValid, confirmPasswordValid, submitPasswordChange, profileLoader, click_handler, passwordinput_passwordValue_binding, passwordinput_passwordInputValid_binding, passwordinput0_passwordValue_binding, passwordinput0_passwordInputValid_binding, passwordinput1_passwordValue_binding, passwordinput1_passwordInputValid_binding];
}
var PasswordInfoContent = /** @class */function (_super) {
  __extends(PasswordInfoContent, _super);
  function PasswordInfoContent(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$a, create_fragment$c, safe_not_equal, {
      displayProfile: 0,
      profileLoader: 9,
      member: 1
    });
    return _this;
  }
  return PasswordInfoContent;
}(SvelteComponent);
function fade(node, _a) {
  var _b = _a === void 0 ? {} : _a,
    _c = _b.delay,
    delay = _c === void 0 ? 0 : _c,
    _d = _b.duration,
    duration = _d === void 0 ? 400 : _d,
    _e = _b.easing,
    easing = _e === void 0 ? identity : _e;
  var o = +getComputedStyle(node).opacity;
  return {
    delay: delay,
    duration: duration,
    easing: easing,
    css: function css(t) {
      return "opacity: " + t * o;
    }
  };
}
/* src/components/ProfileLoader.svelte generated by Svelte v3.48.0 */
function create_fragment$b(ctx) {
  var div;
  var loadingicon;
  var div_transition;
  var current;
  loadingicon = new LoadingIcon({});
  return {
    c: function c() {
      div = element("div");
      create_component(loadingicon.$$.fragment);
      attr(div, "class", "ms__profile__loader");
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      mount_component(loadingicon, div, null);
      current = true;
    },
    p: noop,
    i: function i(local) {
      if (current) return;
      transition_in(loadingicon.$$.fragment, local);
      add_render_callback(function () {
        if (!div_transition) div_transition = create_bidirectional_transition(div, fade, {}, true);
        div_transition.run(1);
      });
      current = true;
    },
    o: function o(local) {
      transition_out(loadingicon.$$.fragment, local);
      if (!div_transition) div_transition = create_bidirectional_transition(div, fade, {}, false);
      div_transition.run(0);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div);
      destroy_component(loadingicon);
      if (detaching && div_transition) div_transition.end();
    }
  };
}
var ProfileLoader = /** @class */function (_super) {
  __extends(ProfileLoader, _super);
  function ProfileLoader(options) {
    var _this = _super.call(this) || this;
    init(_this, options, null, create_fragment$b, safe_not_equal, {});
    return _this;
  }
  return ProfileLoader;
}(SvelteComponent);
/* src/components/RegularButton.svelte generated by Svelte v3.48.0 */
function create_fragment$a(ctx) {
  var button;
  var switch_instance0;
  var t0;
  var t1;
  var t2;
  var switch_instance1;
  var button_class_value;
  var current;
  var mounted;
  var dispose;
  var switch_value = /*buttonLeftIcon*/ctx[2];
  function switch_props(ctx) {
    return {};
  }
  if (switch_value) {
    switch_instance0 = new switch_value(switch_props());
  }
  var switch_value_1 = /*buttonRightIcon*/ctx[1];
  function switch_props_1(ctx) {
    return {};
  }
  if (switch_value_1) {
    switch_instance1 = new switch_value_1(switch_props_1());
  }
  return {
    c: function c() {
      button = element("button");
      if (switch_instance0) create_component(switch_instance0.$$.fragment);
      t0 = space();
      t1 = text( /*buttonText*/ctx[0]);
      t2 = space();
      if (switch_instance1) create_component(switch_instance1.$$.fragment);
      attr(button, "class", button_class_value = "ms-modal__regular-button " + ( /*$$restProps*/ctx[5].class || ''));
      set_style(button, "background", /*buttonColor*/ctx[4]);
    },
    m: function m(target, anchor) {
      insert(target, button, anchor);
      if (switch_instance0) {
        mount_component(switch_instance0, button, null);
      }
      append(button, t0);
      append(button, t1);
      append(button, t2);
      if (switch_instance1) {
        mount_component(switch_instance1, button, null);
      }
      current = true;
      if (!mounted) {
        dispose = listen(button, "click", function () {
          if (is_function( /*onClick*/ctx[3])) /*onClick*/
            ctx[3].apply(this, arguments);
        });
        mounted = true;
      }
    },
    p: function p(new_ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      ctx = new_ctx;
      if (switch_value !== (switch_value = /*buttonLeftIcon*/ctx[2])) {
        if (switch_instance0) {
          group_outros();
          var old_component_1 = switch_instance0;
          transition_out(old_component_1.$$.fragment, 1, 0, function () {
            destroy_component(old_component_1, 1);
          });
          check_outros();
        }
        if (switch_value) {
          switch_instance0 = new switch_value(switch_props());
          create_component(switch_instance0.$$.fragment);
          transition_in(switch_instance0.$$.fragment, 1);
          mount_component(switch_instance0, button, t0);
        } else {
          switch_instance0 = null;
        }
      }
      if (!current || dirty & /*buttonText*/1) set_data(t1, /*buttonText*/ctx[0]);
      if (switch_value_1 !== (switch_value_1 = /*buttonRightIcon*/ctx[1])) {
        if (switch_instance1) {
          group_outros();
          var old_component_2 = switch_instance1;
          transition_out(old_component_2.$$.fragment, 1, 0, function () {
            destroy_component(old_component_2, 1);
          });
          check_outros();
        }
        if (switch_value_1) {
          switch_instance1 = new switch_value_1(switch_props_1());
          create_component(switch_instance1.$$.fragment);
          transition_in(switch_instance1.$$.fragment, 1);
          mount_component(switch_instance1, button, null);
        } else {
          switch_instance1 = null;
        }
      }
      if (!current || dirty & /*$$restProps*/32 && button_class_value !== (button_class_value = "ms-modal__regular-button " + ( /*$$restProps*/ctx[5].class || ''))) {
        attr(button, "class", button_class_value);
      }
      if (!current || dirty & /*buttonColor*/16) {
        set_style(button, "background", /*buttonColor*/ctx[4]);
      }
    },
    i: function i(local) {
      if (current) return;
      if (switch_instance0) transition_in(switch_instance0.$$.fragment, local);
      if (switch_instance1) transition_in(switch_instance1.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      if (switch_instance0) transition_out(switch_instance0.$$.fragment, local);
      if (switch_instance1) transition_out(switch_instance1.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(button);
      if (switch_instance0) destroy_component(switch_instance0);
      if (switch_instance1) destroy_component(switch_instance1);
      mounted = false;
      dispose();
    }
  };
}
function instance$9($$self, $$props, $$invalidate) {
  var omit_props_names = ["buttonText", "buttonRightIcon", "buttonLeftIcon", "onClick"];
  var $$restProps = compute_rest_props($$props, omit_props_names);
  var $app;
  component_subscribe($$self, AppStore, function ($$value) {
    return $$invalidate(6, $app = $$value);
  });
  var _a = $$props.buttonText,
    buttonText = _a === void 0 ? "Submit" : _a;
  var _b = $$props.buttonRightIcon,
    buttonRightIcon = _b === void 0 ? null : _b;
  var _c = $$props.buttonLeftIcon,
    buttonLeftIcon = _c === void 0 ? null : _c;
  var _d = $$props.onClick,
    onClick = _d === void 0 ? function () {} : _d;
  var buttonColor = "rgb(41, 98, 255)";
  if ($app.branding.colors.lightMode.primaryButton) {
    buttonColor = $app.branding.colors.lightMode.primaryButton;
  }
  $$self.$$set = function ($$new_props) {
    $$props = assign(assign({}, $$props), exclude_internal_props($$new_props));
    $$invalidate(5, $$restProps = compute_rest_props($$props, omit_props_names));
    if ('buttonText' in $$new_props) $$invalidate(0, buttonText = $$new_props.buttonText);
    if ('buttonRightIcon' in $$new_props) $$invalidate(1, buttonRightIcon = $$new_props.buttonRightIcon);
    if ('buttonLeftIcon' in $$new_props) $$invalidate(2, buttonLeftIcon = $$new_props.buttonLeftIcon);
    if ('onClick' in $$new_props) $$invalidate(3, onClick = $$new_props.onClick);
  };
  return [buttonText, buttonRightIcon, buttonLeftIcon, onClick, buttonColor, $$restProps];
}
var RegularButton = /** @class */function (_super) {
  __extends(RegularButton, _super);
  function RegularButton(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$9, create_fragment$a, safe_not_equal, {
      buttonText: 0,
      buttonRightIcon: 1,
      buttonLeftIcon: 2,
      onClick: 3
    });
    return _this;
  }
  return RegularButton;
}(SvelteComponent);
/* src/components/TextButton.svelte generated by Svelte v3.48.0 */
function create_fragment$9(ctx) {
  var button;
  var t;
  var button_class_value;
  var mounted;
  var dispose;
  return {
    c: function c() {
      button = element("button");
      t = text( /*buttonText*/ctx[0]);
      attr(button, "class", button_class_value = "ms-modal__text-button " + /*$$restProps*/ctx[3].class);
      set_style(button, "color", /*buttonColor*/ctx[2]);
    },
    m: function m(target, anchor) {
      insert(target, button, anchor);
      append(button, t);
      if (!mounted) {
        dispose = listen(button, "click", function () {
          if (is_function( /*onClick*/ctx[1])) /*onClick*/
            ctx[1].apply(this, arguments);
        });
        mounted = true;
      }
    },
    p: function p(new_ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      ctx = new_ctx;
      if (dirty & /*buttonText*/1) set_data(t, /*buttonText*/ctx[0]);
      if (dirty & /*$$restProps*/8 && button_class_value !== (button_class_value = "ms-modal__text-button " + /*$$restProps*/ctx[3].class)) {
        attr(button, "class", button_class_value);
      }
      if (dirty & /*buttonColor*/4) {
        set_style(button, "color", /*buttonColor*/ctx[2]);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(button);
      mounted = false;
      dispose();
    }
  };
}
function instance$8($$self, $$props, $$invalidate) {
  var omit_props_names = ["buttonText", "onClick"];
  var $$restProps = compute_rest_props($$props, omit_props_names);
  var $app;
  component_subscribe($$self, AppStore, function ($$value) {
    return $$invalidate(4, $app = $$value);
  });
  var _a = $$props.buttonText,
    buttonText = _a === void 0 ? "Submit" : _a;
  var _b = $$props.onClick,
    onClick = _b === void 0 ? function () {} : _b;
  var buttonColor = "rgb(41, 98, 255)";
  if ($app.branding.colors.lightMode.primaryButton) {
    buttonColor = $app.branding.colors.lightMode.primaryButton;
  }
  $$self.$$set = function ($$new_props) {
    $$props = assign(assign({}, $$props), exclude_internal_props($$new_props));
    $$invalidate(3, $$restProps = compute_rest_props($$props, omit_props_names));
    if ('buttonText' in $$new_props) $$invalidate(0, buttonText = $$new_props.buttonText);
    if ('onClick' in $$new_props) $$invalidate(1, onClick = $$new_props.onClick);
  };
  return [buttonText, onClick, buttonColor, $$restProps];
}
var TextButton = /** @class */function (_super) {
  __extends(TextButton, _super);
  function TextButton(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$8, create_fragment$9, safe_not_equal, {
      buttonText: 0,
      onClick: 1
    });
    return _this;
  }
  return TextButton;
}(SvelteComponent);
/* src/components/PlansInfoContent.svelte generated by Svelte v3.48.0 */
function get_each_context$2(ctx, list, i) {
  var child_ctx = ctx.slice();
  child_ctx[8] = list[i];
  child_ctx[10] = i;
  return child_ctx;
}
// (41:0) {#if member.stripeCustomerId}
function create_if_block_2$4(ctx) {
  var div;
  var regularbutton;
  var current;
  regularbutton = new RegularButton({
    props: {
      onClick: /*launchPortal*/ctx[3],
      class: "ms-modal__regular-button--margin-right ms-modal__regular-button--left-icon",
      buttonText: "Manage Subscriptions",
      buttonLeftIcon: LinkOutIcon
    }
  });
  return {
    c: function c() {
      div = element("div");
      create_component(regularbutton.$$.fragment);
      set_style(div, "display", "flex");
      set_style(div, "flex-wrap", "wrap");
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      mount_component(regularbutton, div, null);
      current = true;
    },
    p: noop,
    i: function i(local) {
      if (current) return;
      transition_in(regularbutton.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(regularbutton.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div);
      destroy_component(regularbutton);
    }
  };
}
// (48:0) {#if freePlanConnections.length > 0}
function create_if_block_1$5(ctx) {
  var h3;
  var t1;
  var each_1_anchor;
  var current;
  var each_value = /*freePlanConnections*/ctx[1];
  var each_blocks = [];
  for (var i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$2(get_each_context$2(ctx, each_value, i));
  }
  var out = function out(i) {
    return transition_out(each_blocks[i], 1, 1, function () {
      each_blocks[i] = null;
    });
  };
  return {
    c: function c() {
      h3 = element("h3");
      h3.textContent = "Free Plans";
      t1 = space();
      for (var i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      each_1_anchor = empty();
      set_style(h3, "font-size", "18px");
    },
    m: function m(target, anchor) {
      insert(target, h3, anchor);
      insert(target, t1, anchor);
      for (var i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].m(target, anchor);
      }
      insert(target, each_1_anchor, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      if (dirty & /*removeFreePlan, freePlanConnections, $app*/22) {
        each_value = /*freePlanConnections*/ctx[1];
        var i = void 0;
        for (i = 0; i < each_value.length; i += 1) {
          var child_ctx = get_each_context$2(ctx, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
            transition_in(each_blocks[i], 1);
          } else {
            each_blocks[i] = create_each_block$2(child_ctx);
            each_blocks[i].c();
            transition_in(each_blocks[i], 1);
            each_blocks[i].m(each_1_anchor.parentNode, each_1_anchor);
          }
        }
        group_outros();
        for (i = each_value.length; i < each_blocks.length; i += 1) {
          out(i);
        }
        check_outros();
      }
    },
    i: function i(local) {
      if (current) return;
      for (var i = 0; i < each_value.length; i += 1) {
        transition_in(each_blocks[i]);
      }
      current = true;
    },
    o: function o(local) {
      each_blocks = each_blocks.filter(Boolean);
      for (var i = 0; i < each_blocks.length; i += 1) {
        transition_out(each_blocks[i]);
      }
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(h3);
      if (detaching) detach(t1);
      destroy_each(each_blocks, detaching);
      if (detaching) detach(each_1_anchor);
    }
  };
}
// (50:1) {#each freePlanConnections as memberPlan, i}
function create_each_block$2(ctx) {
  var div1;
  var div0;
  var b;
  var t0_value = /*$app*/ctx[2].plans.find(func).name + "";
  var t0;
  var t1;
  var textbutton;
  var t2;
  var current;
  function func() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    return (/*func*/ctx[6].apply( /*func*/ctx, __spread([/*memberPlan*/ctx[8]], args))
    );
  }
  function func_1() {
    return (/*func_1*/ctx[7]( /*memberPlan*/ctx[8])
    );
  }
  textbutton = new TextButton({
    props: {
      buttonText: "Remove",
      onClick: func_1
    }
  });
  return {
    c: function c() {
      div1 = element("div");
      div0 = element("div");
      b = element("b");
      t0 = text(t0_value);
      t1 = space();
      create_component(textbutton.$$.fragment);
      t2 = space();
      attr(div1, "class", "ms-modal__card");
    },
    m: function m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, div0);
      append(div0, b);
      append(b, t0);
      append(div1, t1);
      mount_component(textbutton, div1, null);
      append(div1, t2);
      current = true;
    },
    p: function p(new_ctx, dirty) {
      ctx = new_ctx;
      if ((!current || dirty & /*$app, freePlanConnections*/6) && t0_value !== (t0_value = /*$app*/ctx[2].plans.find(func).name + "")) set_data(t0, t0_value);
      var textbutton_changes = {};
      if (dirty & /*freePlanConnections*/2) textbutton_changes.onClick = func_1;
      textbutton.$set(textbutton_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(textbutton.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(textbutton.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div1);
      destroy_component(textbutton);
    }
  };
}
// (60:0) {#if !member.stripeCustomerId && freePlanConnections.length === 0}
function create_if_block$7(ctx) {
  var div;
  return {
    c: function c() {
      div = element("div");
      div.textContent = "You currently have no plans.";
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
    },
    d: function d(detaching) {
      if (detaching) detach(div);
    }
  };
}
function create_fragment$8(ctx) {
  var div;
  var t1;
  var t2;
  var t3;
  var if_block2_anchor;
  var current;
  var if_block0 = /*member*/ctx[0].stripeCustomerId && create_if_block_2$4(ctx);
  var if_block1 = /*freePlanConnections*/ctx[1].length > 0 && create_if_block_1$5(ctx);
  var if_block2 = !ctx[0].stripeCustomerId && /*freePlanConnections*/ctx[1].length === 0 && create_if_block$7();
  return {
    c: function c() {
      div = element("div");
      div.innerHTML = "<h2 class=\"ms-modal__title ms-modal__title--profile\">Plans</h2>";
      t1 = space();
      if (if_block0) if_block0.c();
      t2 = space();
      if (if_block1) if_block1.c();
      t3 = space();
      if (if_block2) if_block2.c();
      if_block2_anchor = empty();
      attr(div, "class", "ms-modal__title-container");
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      insert(target, t1, anchor);
      if (if_block0) if_block0.m(target, anchor);
      insert(target, t2, anchor);
      if (if_block1) if_block1.m(target, anchor);
      insert(target, t3, anchor);
      if (if_block2) if_block2.m(target, anchor);
      insert(target, if_block2_anchor, anchor);
      current = true;
    },
    p: function p(ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      if ( /*member*/ctx[0].stripeCustomerId) {
        if (if_block0) {
          if_block0.p(ctx, dirty);
          if (dirty & /*member*/1) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_2$4(ctx);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(t2.parentNode, t2);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, function () {
          if_block0 = null;
        });
        check_outros();
      }
      if ( /*freePlanConnections*/ctx[1].length > 0) {
        if (if_block1) {
          if_block1.p(ctx, dirty);
          if (dirty & /*freePlanConnections*/2) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block_1$5(ctx);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(t3.parentNode, t3);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, function () {
          if_block1 = null;
        });
        check_outros();
      }
      if (!ctx[0].stripeCustomerId && /*freePlanConnections*/ctx[1].length === 0) {
        if (if_block2) ;else {
          if_block2 = create_if_block$7();
          if_block2.c();
          if_block2.m(if_block2_anchor.parentNode, if_block2_anchor);
        }
      } else if (if_block2) {
        if_block2.d(1);
        if_block2 = null;
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(if_block0);
      transition_in(if_block1);
      current = true;
    },
    o: function o(local) {
      transition_out(if_block0);
      transition_out(if_block1);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div);
      if (detaching) detach(t1);
      if (if_block0) if_block0.d(detaching);
      if (detaching) detach(t2);
      if (if_block1) if_block1.d(detaching);
      if (detaching) detach(t3);
      if (if_block2) if_block2.d(detaching);
      if (detaching) detach(if_block2_anchor);
    }
  };
}
function instance$7($$self, $$props, $$invalidate) {
  var freePlanConnections;
  var $app;
  component_subscribe($$self, AppStore, function ($$value) {
    return $$invalidate(2, $app = $$value);
  });
  var profileLoader = $$props.profileLoader;
  var member = $$props.member;
  function launchPortal(e) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            $$invalidate(5, profileLoader = true);
            return [4 /*yield*/, window.$memberstackDom.launchStripeCustomerPortal({
              priceIds: [],
              autoRedirect: true
            })];
          case 1:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  }

  function removeFreePlan(planId) {
    return __awaiter(this, void 0, void 0, function () {
      var err_12;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            $$invalidate(5, profileLoader = true);
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3, 4, 5]);
            return [4 /*yield*/, window.$memberstackDom.removePlan({
              planId: planId
            })];
          case 2:
            _a.sent();
            $$invalidate(0, member.planConnections = member.planConnections.filter(function (plan) {
              return plan.planId !== planId;
            }), member);
            return [3 /*break*/, 5];
          case 3:
            err_12 = _a.sent();
            console.log(err_12);
            window.$memberstackDom._showMessage(err_12.message, true);
            return [3 /*break*/, 5];
          case 4:
            $$invalidate(5, profileLoader = false);
            return [7 /*endfinally*/];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  }

  var func = function func(memberPlan, plan) {
    return plan.id === memberPlan.planId;
  };
  var func_1 = function func_1(memberPlan) {
    return removeFreePlan(memberPlan.planId);
  };
  $$self.$$set = function ($$props) {
    if ('profileLoader' in $$props) $$invalidate(5, profileLoader = $$props.profileLoader);
    if ('member' in $$props) $$invalidate(0, member = $$props.member);
  };
  $$self.$$.update = function () {
    if ($$self.$$.dirty & /*member*/1) {
      $$invalidate(1, freePlanConnections = member.planConnections.filter(function (plan) {
        return plan.type === "FREE";
      }));
    }
  };
  return [member, freePlanConnections, $app, launchPortal, removeFreePlan, profileLoader, func, func_1];
}
var PlansInfoContent = /** @class */function (_super) {
  __extends(PlansInfoContent, _super);
  function PlansInfoContent(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$7, create_fragment$8, safe_not_equal, {
      profileLoader: 5,
      member: 0
    });
    return _this;
  }
  return PlansInfoContent;
}(SvelteComponent);
/* src/modals/ProfileModal.svelte generated by Svelte v3.48.0 */
function create_if_block_4$2(ctx) {
  var profileloader;
  var current;
  profileloader = new ProfileLoader({});
  return {
    c: function c() {
      create_component(profileloader.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(profileloader, target, anchor);
      current = true;
    },
    i: function i(local) {
      if (current) return;
      transition_in(profileloader.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(profileloader.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(profileloader, detaching);
    }
  };
}
// (49:45) 
function create_if_block_3$2(ctx) {
  var plansinfocontent;
  var updating_member;
  var updating_profileLoader;
  var current;
  function plansinfocontent_member_binding(value) {
    /*plansinfocontent_member_binding*/ctx[18](value);
  }
  function plansinfocontent_profileLoader_binding(value) {
    /*plansinfocontent_profileLoader_binding*/ctx[19](value);
  }
  var plansinfocontent_props = {};
  if ( /*member*/ctx[1] !== void 0) {
    plansinfocontent_props.member = /*member*/ctx[1];
  }
  if ( /*profileLoader*/ctx[5] !== void 0) {
    plansinfocontent_props.profileLoader = /*profileLoader*/ctx[5];
  }
  plansinfocontent = new PlansInfoContent({
    props: plansinfocontent_props
  });
  binding_callbacks.push(function () {
    return bind(plansinfocontent, 'member', plansinfocontent_member_binding);
  });
  binding_callbacks.push(function () {
    return bind(plansinfocontent, 'profileLoader', plansinfocontent_profileLoader_binding);
  });
  return {
    c: function c() {
      create_component(plansinfocontent.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(plansinfocontent, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var plansinfocontent_changes = {};
      if (!updating_member && dirty & /*member*/2) {
        updating_member = true;
        plansinfocontent_changes.member = /*member*/ctx[1];
        add_flush_callback(function () {
          return updating_member = false;
        });
      }
      if (!updating_profileLoader && dirty & /*profileLoader*/32) {
        updating_profileLoader = true;
        plansinfocontent_changes.profileLoader = /*profileLoader*/ctx[5];
        add_flush_callback(function () {
          return updating_profileLoader = false;
        });
      }
      plansinfocontent.$set(plansinfocontent_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(plansinfocontent.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(plansinfocontent.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(plansinfocontent, detaching);
    }
  };
}
// (47:52) 
function create_if_block_2$3(ctx) {
  var passwordinfocontent;
  var updating_displayProfile;
  var updating_profileLoader;
  var updating_member;
  var current;
  function passwordinfocontent_displayProfile_binding(value) {
    /*passwordinfocontent_displayProfile_binding*/ctx[15](value);
  }
  function passwordinfocontent_profileLoader_binding(value) {
    /*passwordinfocontent_profileLoader_binding*/ctx[16](value);
  }
  function passwordinfocontent_member_binding(value) {
    /*passwordinfocontent_member_binding*/ctx[17](value);
  }
  var passwordinfocontent_props = {};
  if ( /*displayProfile*/ctx[0] !== void 0) {
    passwordinfocontent_props.displayProfile = /*displayProfile*/ctx[0];
  }
  if ( /*profileLoader*/ctx[5] !== void 0) {
    passwordinfocontent_props.profileLoader = /*profileLoader*/ctx[5];
  }
  if ( /*member*/ctx[1] !== void 0) {
    passwordinfocontent_props.member = /*member*/ctx[1];
  }
  passwordinfocontent = new PasswordInfoContent({
    props: passwordinfocontent_props
  });
  binding_callbacks.push(function () {
    return bind(passwordinfocontent, 'displayProfile', passwordinfocontent_displayProfile_binding);
  });
  binding_callbacks.push(function () {
    return bind(passwordinfocontent, 'profileLoader', passwordinfocontent_profileLoader_binding);
  });
  binding_callbacks.push(function () {
    return bind(passwordinfocontent, 'member', passwordinfocontent_member_binding);
  });
  return {
    c: function c() {
      create_component(passwordinfocontent.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(passwordinfocontent, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var passwordinfocontent_changes = {};
      if (!updating_displayProfile && dirty & /*displayProfile*/1) {
        updating_displayProfile = true;
        passwordinfocontent_changes.displayProfile = /*displayProfile*/ctx[0];
        add_flush_callback(function () {
          return updating_displayProfile = false;
        });
      }
      if (!updating_profileLoader && dirty & /*profileLoader*/32) {
        updating_profileLoader = true;
        passwordinfocontent_changes.profileLoader = /*profileLoader*/ctx[5];
        add_flush_callback(function () {
          return updating_profileLoader = false;
        });
      }
      if (!updating_member && dirty & /*member*/2) {
        updating_member = true;
        passwordinfocontent_changes.member = /*member*/ctx[1];
        add_flush_callback(function () {
          return updating_member = false;
        });
      }
      passwordinfocontent.$set(passwordinfocontent_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(passwordinfocontent.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(passwordinfocontent.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(passwordinfocontent, detaching);
    }
  };
}
// (45:46) 
function create_if_block_1$4(ctx) {
  var securityinfocontent;
  var updating_displayProfile;
  var updating_profileLoader;
  var updating_member;
  var current;
  function securityinfocontent_displayProfile_binding(value) {
    /*securityinfocontent_displayProfile_binding*/ctx[12](value);
  }
  function securityinfocontent_profileLoader_binding(value) {
    /*securityinfocontent_profileLoader_binding*/ctx[13](value);
  }
  function securityinfocontent_member_binding(value) {
    /*securityinfocontent_member_binding*/ctx[14](value);
  }
  var securityinfocontent_props = {};
  if ( /*displayProfile*/ctx[0] !== void 0) {
    securityinfocontent_props.displayProfile = /*displayProfile*/ctx[0];
  }
  if ( /*profileLoader*/ctx[5] !== void 0) {
    securityinfocontent_props.profileLoader = /*profileLoader*/ctx[5];
  }
  if ( /*member*/ctx[1] !== void 0) {
    securityinfocontent_props.member = /*member*/ctx[1];
  }
  securityinfocontent = new SecurityInfoContent({
    props: securityinfocontent_props
  });
  binding_callbacks.push(function () {
    return bind(securityinfocontent, 'displayProfile', securityinfocontent_displayProfile_binding);
  });
  binding_callbacks.push(function () {
    return bind(securityinfocontent, 'profileLoader', securityinfocontent_profileLoader_binding);
  });
  binding_callbacks.push(function () {
    return bind(securityinfocontent, 'member', securityinfocontent_member_binding);
  });
  return {
    c: function c() {
      create_component(securityinfocontent.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(securityinfocontent, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var securityinfocontent_changes = {};
      if (!updating_displayProfile && dirty & /*displayProfile*/1) {
        updating_displayProfile = true;
        securityinfocontent_changes.displayProfile = /*displayProfile*/ctx[0];
        add_flush_callback(function () {
          return updating_displayProfile = false;
        });
      }
      if (!updating_profileLoader && dirty & /*profileLoader*/32) {
        updating_profileLoader = true;
        securityinfocontent_changes.profileLoader = /*profileLoader*/ctx[5];
        add_flush_callback(function () {
          return updating_profileLoader = false;
        });
      }
      if (!updating_member && dirty & /*member*/2) {
        updating_member = true;
        securityinfocontent_changes.member = /*member*/ctx[1];
        add_flush_callback(function () {
          return updating_member = false;
        });
      }
      securityinfocontent.$set(securityinfocontent_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(securityinfocontent.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(securityinfocontent.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(securityinfocontent, detaching);
    }
  };
}
// (43:6) {#if displayProfile === "profile"}
function create_if_block$6(ctx) {
  var profileinfocontent;
  var updating_member;
  var updating_profileLoader;
  var current;
  function profileinfocontent_member_binding(value) {
    /*profileinfocontent_member_binding*/ctx[10](value);
  }
  function profileinfocontent_profileLoader_binding(value) {
    /*profileinfocontent_profileLoader_binding*/ctx[11](value);
  }
  var profileinfocontent_props = {
    customFields: /*$app*/ctx[6].customFields
  };
  if ( /*member*/ctx[1] !== void 0) {
    profileinfocontent_props.member = /*member*/ctx[1];
  }
  if ( /*profileLoader*/ctx[5] !== void 0) {
    profileinfocontent_props.profileLoader = /*profileLoader*/ctx[5];
  }
  profileinfocontent = new ProfileInfoContent({
    props: profileinfocontent_props
  });
  binding_callbacks.push(function () {
    return bind(profileinfocontent, 'member', profileinfocontent_member_binding);
  });
  binding_callbacks.push(function () {
    return bind(profileinfocontent, 'profileLoader', profileinfocontent_profileLoader_binding);
  });
  return {
    c: function c() {
      create_component(profileinfocontent.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(profileinfocontent, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var profileinfocontent_changes = {};
      if (dirty & /*$app*/64) profileinfocontent_changes.customFields = /*$app*/ctx[6].customFields;
      if (!updating_member && dirty & /*member*/2) {
        updating_member = true;
        profileinfocontent_changes.member = /*member*/ctx[1];
        add_flush_callback(function () {
          return updating_member = false;
        });
      }
      if (!updating_profileLoader && dirty & /*profileLoader*/32) {
        updating_profileLoader = true;
        profileinfocontent_changes.profileLoader = /*profileLoader*/ctx[5];
        add_flush_callback(function () {
          return updating_profileLoader = false;
        });
      }
      profileinfocontent.$set(profileinfocontent_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(profileinfocontent.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(profileinfocontent.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(profileinfocontent, detaching);
    }
  };
}
function create_fragment$7(ctx) {
  var div5;
  var div1;
  var div0;
  var t0_value = /*member*/ctx[1].auth.email + "";
  var t0;
  var t1;
  var closebutton;
  var t2;
  var div4;
  var div2;
  var profilemodalnav;
  var updating_member;
  var updating_displayProfile;
  var updating_profileLoader;
  var t3;
  var div3;
  var t4;
  var current_block_type_index;
  var if_block1;
  var t5;
  var modalfooter;
  var current;
  closebutton = new CloseButton({
    props: {
      closeModal: /*closeModal*/ctx[3]
    }
  });
  function profilemodalnav_member_binding(value) {
    /*profilemodalnav_member_binding*/ctx[7](value);
  }
  function profilemodalnav_displayProfile_binding(value) {
    /*profilemodalnav_displayProfile_binding*/ctx[8](value);
  }
  function profilemodalnav_profileLoader_binding(value) {
    /*profilemodalnav_profileLoader_binding*/ctx[9](value);
  }
  var profilemodalnav_props = {
    onSuccessLogout: /*onSuccessLogout*/ctx[2],
    hideProfileSection: /*hideProfileSection*/ctx[4]
  };
  if ( /*member*/ctx[1] !== void 0) {
    profilemodalnav_props.member = /*member*/ctx[1];
  }
  if ( /*displayProfile*/ctx[0] !== void 0) {
    profilemodalnav_props.displayProfile = /*displayProfile*/ctx[0];
  }
  if ( /*profileLoader*/ctx[5] !== void 0) {
    profilemodalnav_props.profileLoader = /*profileLoader*/ctx[5];
  }
  profilemodalnav = new ProfileModalNav({
    props: profilemodalnav_props
  });
  binding_callbacks.push(function () {
    return bind(profilemodalnav, 'member', profilemodalnav_member_binding);
  });
  binding_callbacks.push(function () {
    return bind(profilemodalnav, 'displayProfile', profilemodalnav_displayProfile_binding);
  });
  binding_callbacks.push(function () {
    return bind(profilemodalnav, 'profileLoader', profilemodalnav_profileLoader_binding);
  });
  var if_block0 = /*profileLoader*/ctx[5] && create_if_block_4$2();
  var if_block_creators = [create_if_block$6, create_if_block_1$4, create_if_block_2$3, create_if_block_3$2];
  var if_blocks = [];
  function select_block_type(ctx, dirty) {
    if ( /*displayProfile*/ctx[0] === "profile") return 0;
    if ( /*displayProfile*/ctx[0] === "security") return 1;
    if ( /*displayProfile*/ctx[0] === "changePassword") return 2;
    if ( /*displayProfile*/ctx[0] === "plans") return 3;
    return -1;
  }
  if (~(current_block_type_index = select_block_type(ctx))) {
    if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  }
  modalfooter = new ModalFooter({});
  return {
    c: function c() {
      div5 = element("div");
      div1 = element("div");
      div0 = element("div");
      t0 = text(t0_value);
      t1 = space();
      create_component(closebutton.$$.fragment);
      t2 = space();
      div4 = element("div");
      div2 = element("div");
      create_component(profilemodalnav.$$.fragment);
      t3 = space();
      div3 = element("div");
      if (if_block0) if_block0.c();
      t4 = space();
      if (if_block1) if_block1.c();
      t5 = space();
      create_component(modalfooter.$$.fragment);
      attr(div1, "class", "ms-modal__header");
      attr(div2, "class", "ms-modal__content-left");
      attr(div3, "class", "ms-modal__content-right");
      attr(div4, "class", "ms-modal__content ms-modal__content--profile");
      attr(div5, "class", "ms-modal ms-modal--profile");
      attr(div5, "id", "ProfileModal");
    },
    m: function m(target, anchor) {
      insert(target, div5, anchor);
      append(div5, div1);
      append(div1, div0);
      append(div0, t0);
      append(div1, t1);
      mount_component(closebutton, div1, null);
      append(div5, t2);
      append(div5, div4);
      append(div4, div2);
      mount_component(profilemodalnav, div2, null);
      append(div4, t3);
      append(div4, div3);
      if (if_block0) if_block0.m(div3, null);
      append(div3, t4);
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].m(div3, null);
      }
      append(div5, t5);
      mount_component(modalfooter, div5, null);
      current = true;
    },
    p: function p(ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      if ((!current || dirty & /*member*/2) && t0_value !== (t0_value = /*member*/ctx[1].auth.email + "")) set_data(t0, t0_value);
      var closebutton_changes = {};
      if (dirty & /*closeModal*/8) closebutton_changes.closeModal = /*closeModal*/ctx[3];
      closebutton.$set(closebutton_changes);
      var profilemodalnav_changes = {};
      if (dirty & /*onSuccessLogout*/4) profilemodalnav_changes.onSuccessLogout = /*onSuccessLogout*/ctx[2];
      if (dirty & /*hideProfileSection*/16) profilemodalnav_changes.hideProfileSection = /*hideProfileSection*/ctx[4];
      if (!updating_member && dirty & /*member*/2) {
        updating_member = true;
        profilemodalnav_changes.member = /*member*/ctx[1];
        add_flush_callback(function () {
          return updating_member = false;
        });
      }
      if (!updating_displayProfile && dirty & /*displayProfile*/1) {
        updating_displayProfile = true;
        profilemodalnav_changes.displayProfile = /*displayProfile*/ctx[0];
        add_flush_callback(function () {
          return updating_displayProfile = false;
        });
      }
      if (!updating_profileLoader && dirty & /*profileLoader*/32) {
        updating_profileLoader = true;
        profilemodalnav_changes.profileLoader = /*profileLoader*/ctx[5];
        add_flush_callback(function () {
          return updating_profileLoader = false;
        });
      }
      profilemodalnav.$set(profilemodalnav_changes);
      if ( /*profileLoader*/ctx[5]) {
        if (if_block0) {
          if (dirty & /*profileLoader*/32) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_4$2();
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(div3, t4);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, function () {
          if_block0 = null;
        });
        check_outros();
      }
      var previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx);
      if (current_block_type_index === previous_block_index) {
        if (~current_block_type_index) {
          if_blocks[current_block_type_index].p(ctx, dirty);
        }
      } else {
        if (if_block1) {
          group_outros();
          transition_out(if_blocks[previous_block_index], 1, 1, function () {
            if_blocks[previous_block_index] = null;
          });
          check_outros();
        }
        if (~current_block_type_index) {
          if_block1 = if_blocks[current_block_type_index];
          if (!if_block1) {
            if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
            if_block1.c();
          } else {
            if_block1.p(ctx, dirty);
          }
          transition_in(if_block1, 1);
          if_block1.m(div3, null);
        } else {
          if_block1 = null;
        }
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(closebutton.$$.fragment, local);
      transition_in(profilemodalnav.$$.fragment, local);
      transition_in(if_block0);
      transition_in(if_block1);
      transition_in(modalfooter.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(closebutton.$$.fragment, local);
      transition_out(profilemodalnav.$$.fragment, local);
      transition_out(if_block0);
      transition_out(if_block1);
      transition_out(modalfooter.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div5);
      destroy_component(closebutton);
      destroy_component(profilemodalnav);
      if (if_block0) if_block0.d();
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].d();
      }
      destroy_component(modalfooter);
    }
  };
}
function instance$6($$self, $$props, $$invalidate) {
  var $app;
  component_subscribe($$self, AppStore, function ($$value) {
    return $$invalidate(6, $app = $$value);
  });
  var onSuccessLogout = $$props.onSuccessLogout;
  var closeModal = $$props.closeModal;
  var _a = $$props.displayProfile,
    displayProfile = _a === void 0 ? "profile" : _a;
  var member = $$props.member;
  var hideProfileSection = false;
  var profileLoader = false;
  if (!$app.customFields.filter(function (field) {
    return !field.hidden;
  }).length) {
    displayProfile = "security";
    hideProfileSection = true;
  }
  function profilemodalnav_member_binding(value) {
    member = value;
    $$invalidate(1, member);
  }
  function profilemodalnav_displayProfile_binding(value) {
    displayProfile = value;
    $$invalidate(0, displayProfile);
  }
  function profilemodalnav_profileLoader_binding(value) {
    profileLoader = value;
    $$invalidate(5, profileLoader);
  }
  function profileinfocontent_member_binding(value) {
    member = value;
    $$invalidate(1, member);
  }
  function profileinfocontent_profileLoader_binding(value) {
    profileLoader = value;
    $$invalidate(5, profileLoader);
  }
  function securityinfocontent_displayProfile_binding(value) {
    displayProfile = value;
    $$invalidate(0, displayProfile);
  }
  function securityinfocontent_profileLoader_binding(value) {
    profileLoader = value;
    $$invalidate(5, profileLoader);
  }
  function securityinfocontent_member_binding(value) {
    member = value;
    $$invalidate(1, member);
  }
  function passwordinfocontent_displayProfile_binding(value) {
    displayProfile = value;
    $$invalidate(0, displayProfile);
  }
  function passwordinfocontent_profileLoader_binding(value) {
    profileLoader = value;
    $$invalidate(5, profileLoader);
  }
  function passwordinfocontent_member_binding(value) {
    member = value;
    $$invalidate(1, member);
  }
  function plansinfocontent_member_binding(value) {
    member = value;
    $$invalidate(1, member);
  }
  function plansinfocontent_profileLoader_binding(value) {
    profileLoader = value;
    $$invalidate(5, profileLoader);
  }
  $$self.$$set = function ($$props) {
    if ('onSuccessLogout' in $$props) $$invalidate(2, onSuccessLogout = $$props.onSuccessLogout);
    if ('closeModal' in $$props) $$invalidate(3, closeModal = $$props.closeModal);
    if ('displayProfile' in $$props) $$invalidate(0, displayProfile = $$props.displayProfile);
    if ('member' in $$props) $$invalidate(1, member = $$props.member);
  };
  return [displayProfile, member, onSuccessLogout, closeModal, hideProfileSection, profileLoader, $app, profilemodalnav_member_binding, profilemodalnav_displayProfile_binding, profilemodalnav_profileLoader_binding, profileinfocontent_member_binding, profileinfocontent_profileLoader_binding, securityinfocontent_displayProfile_binding, securityinfocontent_profileLoader_binding, securityinfocontent_member_binding, passwordinfocontent_displayProfile_binding, passwordinfocontent_profileLoader_binding, passwordinfocontent_member_binding, plansinfocontent_member_binding, plansinfocontent_profileLoader_binding];
}
var ProfileModal = /** @class */function (_super) {
  __extends(ProfileModal, _super);
  function ProfileModal(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$6, create_fragment$7, safe_not_equal, {
      onSuccessLogout: 2,
      closeModal: 3,
      displayProfile: 0,
      member: 1
    });
    return _this;
  }
  return ProfileModal;
}(SvelteComponent);
/* src/icons/ForwardIcon.svelte generated by Svelte v3.48.0 */
function create_fragment$6(ctx) {
  var svg;
  var path;
  return {
    c: function c() {
      svg = svg_element("svg");
      path = svg_element("path");
      attr(path, "fill", "currentColor");
      attr(path, "d", "M7.41 1.41L6 0L0 6L6 12L7.41 10.59L2.83 6L7.41 1.41Z");
      attr(svg, "fill", "none");
      attr(svg, "transform", "rotate(180)");
      attr(svg, "viewBox", "0 0 8 12");
      attr(svg, "xmlns", "http://www.w3.org/2000/svg");
    },
    m: function m(target, anchor) {
      insert(target, svg, anchor);
      append(svg, path);
    },
    p: noop,
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(svg);
    }
  };
}
var ForwardIcon = /** @class */function (_super) {
  __extends(ForwardIcon, _super);
  function ForwardIcon(options) {
    var _this = _super.call(this) || this;
    init(_this, options, null, create_fragment$6, safe_not_equal, {});
    return _this;
  }
  return ForwardIcon;
}(SvelteComponent);
/* src/components/MobileProfileModalNav.svelte generated by Svelte v3.48.0 */
function create_if_block_1$3(ctx) {
  var button;
  var div;
  var profileicon;
  var t0;
  var t1;
  var forwardicon;
  var current;
  var mounted;
  var dispose;
  profileicon = new ProfileIcon({});
  forwardicon = new ForwardIcon({});
  return {
    c: function c() {
      button = element("button");
      div = element("div");
      create_component(profileicon.$$.fragment);
      t0 = text(" Profile");
      t1 = space();
      create_component(forwardicon.$$.fragment);
      attr(button, "class", "ms-modal__profile-option");
      toggle_class(button, "ms-modal__profile-option--active", /*displayProfile*/ctx[0] === "profile");
    },
    m: function m(target, anchor) {
      insert(target, button, anchor);
      append(button, div);
      mount_component(profileicon, div, null);
      append(div, t0);
      append(button, t1);
      mount_component(forwardicon, button, null);
      current = true;
      if (!mounted) {
        dispose = listen(button, "click", /*click_handler*/ctx[7]);
        mounted = true;
      }
    },
    p: function p(ctx, dirty) {
      if (dirty & /*displayProfile*/1) {
        toggle_class(button, "ms-modal__profile-option--active", /*displayProfile*/ctx[0] === "profile");
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(profileicon.$$.fragment, local);
      transition_in(forwardicon.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(profileicon.$$.fragment, local);
      transition_out(forwardicon.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(button);
      destroy_component(profileicon);
      destroy_component(forwardicon);
      mounted = false;
      dispose();
    }
  };
}
// (80:2) {#if member.stripeCustomerId}
function create_if_block$5(ctx) {
  var button;
  var div;
  var linkouticon;
  var t0;
  var t1;
  var forwardicon;
  var current;
  var mounted;
  var dispose;
  linkouticon = new LinkOutIcon({});
  forwardicon = new ForwardIcon({});
  return {
    c: function c() {
      button = element("button");
      div = element("div");
      create_component(linkouticon.$$.fragment);
      t0 = text(" Billing Portal");
      t1 = space();
      create_component(forwardicon.$$.fragment);
      attr(button, "class", "ms-modal__profile-option");
    },
    m: function m(target, anchor) {
      insert(target, button, anchor);
      append(button, div);
      mount_component(linkouticon, div, null);
      append(div, t0);
      append(button, t1);
      mount_component(forwardicon, button, null);
      current = true;
      if (!mounted) {
        dispose = listen(button, "click", /*launchPortal*/ctx[4]);
        mounted = true;
      }
    },
    p: noop,
    i: function i(local) {
      if (current) return;
      transition_in(linkouticon.$$.fragment, local);
      transition_in(forwardicon.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(linkouticon.$$.fragment, local);
      transition_out(forwardicon.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(button);
      destroy_component(linkouticon);
      destroy_component(forwardicon);
      mounted = false;
      dispose();
    }
  };
}
function create_fragment$5(ctx) {
  var div2;
  var t0;
  var button0;
  var div0;
  var securityicon;
  var t1;
  var t2;
  var forwardicon0;
  var t3;
  var t4;
  var button1;
  var div1;
  var logouticon;
  var t5;
  var t6;
  var forwardicon1;
  var current;
  var mounted;
  var dispose;
  var if_block0 = !ctx[2] && create_if_block_1$3(ctx);
  securityicon = new SecurityIcon({});
  forwardicon0 = new ForwardIcon({});
  var if_block1 = /*member*/ctx[1].stripeCustomerId && create_if_block$5(ctx);
  logouticon = new LogoutIcon({});
  forwardicon1 = new ForwardIcon({});
  return {
    c: function c() {
      div2 = element("div");
      if (if_block0) if_block0.c();
      t0 = space();
      button0 = element("button");
      div0 = element("div");
      create_component(securityicon.$$.fragment);
      t1 = text(" Security");
      t2 = space();
      create_component(forwardicon0.$$.fragment);
      t3 = space();
      if (if_block1) if_block1.c();
      t4 = space();
      button1 = element("button");
      div1 = element("div");
      create_component(logouticon.$$.fragment);
      t5 = text(" Logout");
      t6 = space();
      create_component(forwardicon1.$$.fragment);
      attr(button0, "class", "ms-modal__profile-option");
      toggle_class(button0, "ms-modal__profile-option--active", /*displayProfile*/ctx[0] === "security" || /*displayProfile*/ctx[0] === "changePassword");
      attr(button1, "class", "ms-modal__profile-option");
      attr(div2, "class", "ms-modal__mobile-profile-nav");
    },
    m: function m(target, anchor) {
      insert(target, div2, anchor);
      if (if_block0) if_block0.m(div2, null);
      append(div2, t0);
      append(div2, button0);
      append(button0, div0);
      mount_component(securityicon, div0, null);
      append(div0, t1);
      append(button0, t2);
      mount_component(forwardicon0, button0, null);
      append(div2, t3);
      if (if_block1) if_block1.m(div2, null);
      append(div2, t4);
      append(div2, button1);
      append(button1, div1);
      mount_component(logouticon, div1, null);
      append(div1, t5);
      append(button1, t6);
      mount_component(forwardicon1, button1, null);
      current = true;
      if (!mounted) {
        dispose = [listen(button0, "click", /*click_handler_1*/ctx[8]), listen(button1, "click", /*logout*/ctx[3])];
        mounted = true;
      }
    },
    p: function p(ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      if (!ctx[2]) {
        if (if_block0) {
          if_block0.p(ctx, dirty);
          if (dirty & /*hideProfileSection*/4) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_1$3(ctx);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(div2, t0);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, function () {
          if_block0 = null;
        });
        check_outros();
      }
      if (dirty & /*displayProfile*/1) {
        toggle_class(button0, "ms-modal__profile-option--active", /*displayProfile*/ctx[0] === "security" || /*displayProfile*/ctx[0] === "changePassword");
      }
      if ( /*member*/ctx[1].stripeCustomerId) {
        if (if_block1) {
          if_block1.p(ctx, dirty);
          if (dirty & /*member*/2) {
            transition_in(if_block1, 1);
          }
        } else {
          if_block1 = create_if_block$5(ctx);
          if_block1.c();
          transition_in(if_block1, 1);
          if_block1.m(div2, t4);
        }
      } else if (if_block1) {
        group_outros();
        transition_out(if_block1, 1, 1, function () {
          if_block1 = null;
        });
        check_outros();
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(if_block0);
      transition_in(securityicon.$$.fragment, local);
      transition_in(forwardicon0.$$.fragment, local);
      transition_in(if_block1);
      transition_in(logouticon.$$.fragment, local);
      transition_in(forwardicon1.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(if_block0);
      transition_out(securityicon.$$.fragment, local);
      transition_out(forwardicon0.$$.fragment, local);
      transition_out(if_block1);
      transition_out(logouticon.$$.fragment, local);
      transition_out(forwardicon1.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div2);
      if (if_block0) if_block0.d();
      destroy_component(securityicon);
      destroy_component(forwardicon0);
      if (if_block1) if_block1.d();
      destroy_component(logouticon);
      destroy_component(forwardicon1);
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$5($$self, $$props, $$invalidate) {
  var member = $$props.member;
  var onSuccessLogout = $$props.onSuccessLogout;
  var displayProfile = $$props.displayProfile;
  var profileLoader = $$props.profileLoader;
  var hideProfileSection = $$props.hideProfileSection;
  var unsubscribe = AppStore.subscribe(function (data) {
    if (!data.initialValue) {
      var container = document.getElementById("msOverlay");
      var css = document.createElement("style");
      var color = data.branding.colors.lightMode.primaryButton;
      var fullCSS = ".ms-modal__profile-option:hover { color: " + color + ";} .ms-modal__profile-option--active { color: " + color + ";} .ms-modal__save-button { background: " + color + ";} .ms-modal__save-button:disabled { background: " + color + ";}";
      css.appendChild(document.createTextNode(fullCSS));
      container.appendChild(css);
    }
  });
  onDestroy(function () {
    unsubscribe();
  });
  function logout(e) {
    return __awaiter(this, void 0, void 0, function () {
      var data, err_13;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 2,, 3]);
            return [4 /*yield*/, window.$memberstackDom.logout()];
          case 1:
            data = _a.sent().data;
            window.$memberstackDom._showMessage("Logout successful", false);
            onSuccessLogout({
              type: "LOGOUT",
              data: data
            });
            return [3 /*break*/, 3];
          case 2:
            err_13 = _a.sent();
            window.$memberstackDom._showMessage(err_13.message, true);
            return [3 /*break*/, 3];
          case 3:
            return [2 /*return*/];
        }
      });
    });
  }

  function launchPortal(e) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            $$invalidate(5, profileLoader = true);
            return [4 /*yield*/, window.$memberstackDom.launchStripeCustomerPortal({
              priceIds: [],
              autoRedirect: true
            })];
          case 1:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  }

  var click_handler = function click_handler() {
    return $$invalidate(0, displayProfile = "profile");
  };
  var click_handler_1 = function click_handler_1() {
    return $$invalidate(0, displayProfile = "security");
  };
  $$self.$$set = function ($$props) {
    if ('member' in $$props) $$invalidate(1, member = $$props.member);
    if ('onSuccessLogout' in $$props) $$invalidate(6, onSuccessLogout = $$props.onSuccessLogout);
    if ('displayProfile' in $$props) $$invalidate(0, displayProfile = $$props.displayProfile);
    if ('profileLoader' in $$props) $$invalidate(5, profileLoader = $$props.profileLoader);
    if ('hideProfileSection' in $$props) $$invalidate(2, hideProfileSection = $$props.hideProfileSection);
  };
  return [displayProfile, member, hideProfileSection, logout, launchPortal, profileLoader, onSuccessLogout, click_handler, click_handler_1];
}
var MobileProfileModalNav = /** @class */function (_super) {
  __extends(MobileProfileModalNav, _super);
  function MobileProfileModalNav(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$5, create_fragment$5, safe_not_equal, {
      member: 1,
      onSuccessLogout: 6,
      displayProfile: 0,
      profileLoader: 5,
      hideProfileSection: 2
    });
    return _this;
  }
  return MobileProfileModalNav;
}(SvelteComponent);
/* src/components/MobileProfileInfoContent.svelte generated by Svelte v3.48.0 */
function get_each_context$1(ctx, list, i) {
  var child_ctx = ctx.slice();
  child_ctx[5] = list[i];
  child_ctx[6] = list;
  child_ctx[7] = i;
  return child_ctx;
}
// (18:1) {#if customField.hidden !== true}
function create_if_block$4(ctx) {
  var div1;
  var div0;
  var label;
  var t0_value = /*customField*/ctx[5].label + "";
  var t0;
  var label_for_value;
  var t1;
  var input;
  var input_placeholder_value;
  var input_name_value;
  var t2;
  var mounted;
  var dispose;
  function input_input_handler() {
    /*input_input_handler*/ctx[4].call(input, /*customField*/ctx[5]);
  }
  return {
    c: function c() {
      div1 = element("div");
      div0 = element("div");
      label = element("label");
      t0 = text(t0_value);
      t1 = space();
      input = element("input");
      t2 = space();
      attr(label, "class", "ms-form__label");
      attr(label, "for", label_for_value = /*customField*/ctx[5].key);
      attr(input, "class", "ms-form__input");
      attr(input, "type", "text");
      attr(input, "placeholder", input_placeholder_value = /*customField*/ctx[5].label);
      attr(input, "name", input_name_value = /*customField*/ctx[5].key);
      attr(div0, "class", "ms-form__group");
      attr(div1, "class", "ms-modal__custom-field-container");
    },
    m: function m(target, anchor) {
      insert(target, div1, anchor);
      append(div1, div0);
      append(div0, label);
      append(label, t0);
      append(div0, t1);
      append(div0, input);
      set_input_value(input, /*member*/ctx[0].customFields[/*customField*/ctx[5].key]);
      append(div1, t2);
      if (!mounted) {
        dispose = listen(input, "input", input_input_handler);
        mounted = true;
      }
    },
    p: function p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty & /*customFields*/2 && t0_value !== (t0_value = /*customField*/ctx[5].label + "")) set_data(t0, t0_value);
      if (dirty & /*customFields*/2 && label_for_value !== (label_for_value = /*customField*/ctx[5].key)) {
        attr(label, "for", label_for_value);
      }
      if (dirty & /*customFields*/2 && input_placeholder_value !== (input_placeholder_value = /*customField*/ctx[5].label)) {
        attr(input, "placeholder", input_placeholder_value);
      }
      if (dirty & /*customFields*/2 && input_name_value !== (input_name_value = /*customField*/ctx[5].key)) {
        attr(input, "name", input_name_value);
      }
      if (dirty & /*member, customFields*/3 && input.value !== /*member*/ctx[0].customFields[/*customField*/ctx[5].key]) {
        set_input_value(input, /*member*/ctx[0].customFields[/*customField*/ctx[5].key]);
      }
    },
    d: function d(detaching) {
      if (detaching) detach(div1);
      mounted = false;
      dispose();
    }
  };
}
// (17:0) {#each customFields as customField, i}
function create_each_block$1(ctx) {
  var if_block_anchor;
  var if_block = /*customField*/ctx[5].hidden !== true && create_if_block$4(ctx);
  return {
    c: function c() {
      if (if_block) if_block.c();
      if_block_anchor = empty();
    },
    m: function m(target, anchor) {
      if (if_block) if_block.m(target, anchor);
      insert(target, if_block_anchor, anchor);
    },
    p: function p(ctx, dirty) {
      if ( /*customField*/ctx[5].hidden !== true) {
        if (if_block) {
          if_block.p(ctx, dirty);
        } else {
          if_block = create_if_block$4(ctx);
          if_block.c();
          if_block.m(if_block_anchor.parentNode, if_block_anchor);
        }
      } else if (if_block) {
        if_block.d(1);
        if_block = null;
      }
    },
    d: function d(detaching) {
      if (if_block) if_block.d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
function create_fragment$4(ctx) {
  var form;
  var t0;
  var div;
  var button;
  var mounted;
  var dispose;
  var each_value = /*customFields*/ctx[1];
  var each_blocks = [];
  for (var i = 0; i < each_value.length; i += 1) {
    each_blocks[i] = create_each_block$1(get_each_context$1(ctx, each_value, i));
  }
  return {
    c: function c() {
      form = element("form");
      for (var i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      t0 = space();
      div = element("div");
      button = element("button");
      button.textContent = "Save";
      attr(form, "class", "ms-form");
      attr(form, "action", "");
      attr(form, "method", "post");
      attr(form, "autocomplete", "off");
      attr(button, "class", "ms-modal__save-button ms-modal__save-button--large");
      attr(div, "class", "ms-modal__action-container");
    },
    m: function m(target, anchor) {
      insert(target, form, anchor);
      for (var i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].m(form, null);
      }
      insert(target, t0, anchor);
      insert(target, div, anchor);
      append(div, button);
      if (!mounted) {
        dispose = [listen(form, "submit", stop_propagation(prevent_default( /*saveProfile*/ctx[2]))), listen(button, "click", /*saveProfile*/ctx[2])];
        mounted = true;
      }
    },
    p: function p(ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      if (dirty & /*customFields, member*/3) {
        each_value = /*customFields*/ctx[1];
        var i = void 0;
        for (i = 0; i < each_value.length; i += 1) {
          var child_ctx = get_each_context$1(ctx, each_value, i);
          if (each_blocks[i]) {
            each_blocks[i].p(child_ctx, dirty);
          } else {
            each_blocks[i] = create_each_block$1(child_ctx);
            each_blocks[i].c();
            each_blocks[i].m(form, null);
          }
        }
        for (; i < each_blocks.length; i += 1) {
          each_blocks[i].d(1);
        }
        each_blocks.length = each_value.length;
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(form);
      destroy_each(each_blocks, detaching);
      if (detaching) detach(t0);
      if (detaching) detach(div);
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$4($$self, $$props, $$invalidate) {
  var customFields = $$props.customFields;
  var member = $$props.member;
  var profileLoader = $$props.profileLoader;
  function saveProfile(e) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            $$invalidate(3, profileLoader = true);
            return [4 /*yield*/, window.$memberstackDom.updateMember({
              customFields: member.customFields
            })];
          case 1:
            _a.sent();
            $$invalidate(3, profileLoader = false);
            return [2 /*return*/];
        }
      });
    });
  }

  function input_input_handler(customField) {
    member.customFields[customField.key] = this.value;
    $$invalidate(0, member);
  }
  $$self.$$set = function ($$props) {
    if ('customFields' in $$props) $$invalidate(1, customFields = $$props.customFields);
    if ('member' in $$props) $$invalidate(0, member = $$props.member);
    if ('profileLoader' in $$props) $$invalidate(3, profileLoader = $$props.profileLoader);
  };
  return [member, customFields, saveProfile, profileLoader, input_input_handler];
}
var MobileProfileInfoContent = /** @class */function (_super) {
  __extends(MobileProfileInfoContent, _super);
  function MobileProfileInfoContent(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$4, create_fragment$4, safe_not_equal, {
      customFields: 1,
      member: 0,
      profileLoader: 3
    });
    return _this;
  }
  return MobileProfileInfoContent;
}(SvelteComponent);
/* src/components/MobileSecurityInfoContent.svelte generated by Svelte v3.48.0 */
function get_each_context(ctx, list, i) {
  var child_ctx = ctx.slice();
  child_ctx[16] = list[i];
  return child_ctx;
}
// (90:69) {:else}
function create_else_block_1(ctx) {
  var t;
  return {
    c: function c() {
      t = text("Change Password");
    },
    m: function m(target, anchor) {
      insert(target, t, anchor);
    },
    d: function d(detaching) {
      if (detaching) detach(t);
    }
  };
}
// (90:25) {#if !member.auth.hasPassword}
function create_if_block_2$2(ctx) {
  var t;
  return {
    c: function c() {
      t = text("Set Password");
    },
    m: function m(target, anchor) {
      insert(target, t, anchor);
    },
    d: function d(detaching) {
      if (detaching) detach(t);
    }
  };
}
// (94:0) {#if $app.authProviders.length > 0}
function create_if_block$3(ctx) {
  var p;
  var t1;
  var div;
  var each_blocks = [];
  var each_1_lookup = new Map();
  var each_value = /*$app*/ctx[4].authProviders;
  var get_key = function get_key(ctx) {
    /*provider*/return ctx[16].provider;
  };
  for (var i = 0; i < each_value.length; i += 1) {
    var child_ctx = get_each_context(ctx, each_value, i);
    var key = get_key(child_ctx);
    each_1_lookup.set(key, each_blocks[i] = create_each_block(key, child_ctx));
  }
  return {
    c: function c() {
      p = element("p");
      p.textContent = "Connect Additional Accounts";
      t1 = space();
      div = element("div");
      for (var i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].c();
      }
      attr(p, "class", "ms-form__label");
      attr(div, "class", "ms-modal__social");
    },
    m: function m(target, anchor) {
      insert(target, p, anchor);
      insert(target, t1, anchor);
      insert(target, div, anchor);
      for (var i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].m(div, null);
      }
    },
    p: function p(ctx, dirty) {
      if (dirty & /*disconnectProvider, $app, member, connectAdditionalProvider*/210) {
        each_value = /*$app*/ctx[4].authProviders;
        each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, div, destroy_block, create_each_block, null, get_each_context);
      }
    },
    d: function d(detaching) {
      if (detaching) detach(p);
      if (detaching) detach(t1);
      if (detaching) detach(div);
      for (var i = 0; i < each_blocks.length; i += 1) {
        each_blocks[i].d();
      }
    }
  };
}
// (104:6) {:else}
function create_else_block$2(ctx) {
  var button;
  var img;
  var img_src_value;
  var img_alt_value;
  var t0;
  var span;
  var t1;
  var t2_value = /*provider*/ctx[16].name + "";
  var t2;
  var mounted;
  var dispose;
  function click_handler_2() {
    return (/*click_handler_2*/ctx[14]( /*provider*/ctx[16])
    );
  }
  return {
    c: function c() {
      button = element("button");
      img = element("img");
      t0 = space();
      span = element("span");
      t1 = text("Connect with ");
      t2 = text(t2_value);
      if (!src_url_equal(img.src, img_src_value = /*provider*/ctx[16].icon)) attr(img, "src", img_src_value);
      attr(img, "alt", img_alt_value = /*provider*/ctx[16].name);
      attr(button, "class", "ms-modal__social-button");
      attr(button, "type", "button");
    },
    m: function m(target, anchor) {
      insert(target, button, anchor);
      append(button, img);
      append(button, t0);
      append(button, span);
      append(span, t1);
      append(span, t2);
      if (!mounted) {
        dispose = listen(button, "click", click_handler_2);
        mounted = true;
      }
    },
    p: function p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty & /*$app*/16 && !src_url_equal(img.src, img_src_value = /*provider*/ctx[16].icon)) {
        attr(img, "src", img_src_value);
      }
      if (dirty & /*$app*/16 && img_alt_value !== (img_alt_value = /*provider*/ctx[16].name)) {
        attr(img, "alt", img_alt_value);
      }
      if (dirty & /*$app*/16 && t2_value !== (t2_value = /*provider*/ctx[16].name + "")) set_data(t2, t2_value);
    },
    d: function d(detaching) {
      if (detaching) detach(button);
      mounted = false;
      dispose();
    }
  };
}
// (99:6) {#if member.auth.providers.some((prv) => prv.provider === provider.provider)}
function create_if_block_1$2(ctx) {
  var button;
  var img;
  var img_src_value;
  var img_alt_value;
  var t0;
  var span;
  var t1;
  var t2_value = /*provider*/ctx[16].name + "";
  var t2;
  var mounted;
  var dispose;
  function click_handler_1() {
    return (/*click_handler_1*/ctx[13]( /*provider*/ctx[16])
    );
  }
  return {
    c: function c() {
      button = element("button");
      img = element("img");
      t0 = space();
      span = element("span");
      t1 = text("Disconnect ");
      t2 = text(t2_value);
      if (!src_url_equal(img.src, img_src_value = /*provider*/ctx[16].icon)) attr(img, "src", img_src_value);
      attr(img, "alt", img_alt_value = /*provider*/ctx[16].name);
      attr(button, "class", "ms-modal__social-button");
      set_style(button, "background-color", "#F6F6F6");
      attr(button, "type", "button");
    },
    m: function m(target, anchor) {
      insert(target, button, anchor);
      append(button, img);
      append(button, t0);
      append(button, span);
      append(span, t1);
      append(span, t2);
      if (!mounted) {
        dispose = listen(button, "click", click_handler_1);
        mounted = true;
      }
    },
    p: function p(new_ctx, dirty) {
      ctx = new_ctx;
      if (dirty & /*$app*/16 && !src_url_equal(img.src, img_src_value = /*provider*/ctx[16].icon)) {
        attr(img, "src", img_src_value);
      }
      if (dirty & /*$app*/16 && img_alt_value !== (img_alt_value = /*provider*/ctx[16].name)) {
        attr(img, "alt", img_alt_value);
      }
      if (dirty & /*$app*/16 && t2_value !== (t2_value = /*provider*/ctx[16].name + "")) set_data(t2, t2_value);
    },
    d: function d(detaching) {
      if (detaching) detach(button);
      mounted = false;
      dispose();
    }
  };
}
// (97:2) {#each $app.authProviders as provider (provider.provider)}
function create_each_block(key_1, ctx) {
  var div;
  var show_if;
  var t;
  function func() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    return (/*func*/ctx[9].apply( /*func*/ctx, __spread([/*provider*/ctx[16]], args))
    );
  }
  function select_block_type_1(ctx, dirty) {
    if (dirty & /*member, $app*/18) show_if = null;
    if (show_if == null) show_if = !!ctx[1].auth.providers.some(func);
    if (show_if) return create_if_block_1$2;
    return create_else_block$2;
  }
  var current_block_type = select_block_type_1(ctx, -1);
  var if_block = current_block_type(ctx);
  return {
    key: key_1,
    first: null,
    c: function c() {
      div = element("div");
      if_block.c();
      t = space();
      attr(div, "class", "ms-modal__social-buttons");
      this.first = div;
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      if_block.m(div, null);
      append(div, t);
    },
    p: function p(new_ctx, dirty) {
      ctx = new_ctx;
      if (current_block_type === (current_block_type = select_block_type_1(ctx, dirty)) && if_block) {
        if_block.p(ctx, dirty);
      } else {
        if_block.d(1);
        if_block = current_block_type(ctx);
        if (if_block) {
          if_block.c();
          if_block.m(div, t);
        }
      }
    },
    d: function d(detaching) {
      if (detaching) detach(div);
      if_block.d();
    }
  };
}
function create_fragment$3(ctx) {
  var form;
  var emailinput;
  var updating_emailInputValid;
  var updating_emailValue;
  var t0;
  var div0;
  var label;
  var t2;
  var button0;
  var passwordlockicon;
  var t3;
  var t4;
  var t5;
  var div1;
  var button1;
  var t6;
  var button1_disabled_value;
  var current;
  var mounted;
  var dispose;
  function emailinput_emailInputValid_binding(value) {
    /*emailinput_emailInputValid_binding*/ctx[10](value);
  }
  function emailinput_emailValue_binding(value) {
    /*emailinput_emailValue_binding*/ctx[11](value);
  }
  var emailinput_props = {};
  if ( /*emailInputValid*/ctx[3] !== void 0) {
    emailinput_props.emailInputValid = /*emailInputValid*/ctx[3];
  }
  if ( /*emailValue*/ctx[2] !== void 0) {
    emailinput_props.emailValue = /*emailValue*/ctx[2];
  }
  emailinput = new EmailInput({
    props: emailinput_props
  });
  binding_callbacks.push(function () {
    return bind(emailinput, 'emailInputValid', emailinput_emailInputValid_binding);
  });
  binding_callbacks.push(function () {
    return bind(emailinput, 'emailValue', emailinput_emailValue_binding);
  });
  passwordlockicon = new PasswordLockIcon({});
  function select_block_type(ctx, dirty) {
    if (!ctx[1].auth.hasPassword) return create_if_block_2$2;
    return create_else_block_1;
  }
  var current_block_type = select_block_type(ctx);
  var if_block0 = current_block_type(ctx);
  var if_block1 = /*$app*/ctx[4].authProviders.length > 0 && create_if_block$3(ctx);
  return {
    c: function c() {
      form = element("form");
      create_component(emailinput.$$.fragment);
      t0 = space();
      div0 = element("div");
      label = element("label");
      label.textContent = "Password";
      t2 = space();
      button0 = element("button");
      create_component(passwordlockicon.$$.fragment);
      t3 = space();
      if_block0.c();
      t4 = space();
      if (if_block1) if_block1.c();
      t5 = space();
      div1 = element("div");
      button1 = element("button");
      t6 = text("Save");
      attr(form, "class", "ms-form");
      attr(form, "action", "");
      attr(form, "method", "post");
      attr(form, "autocomplete", "off");
      attr(label, "class", "ms-form__label");
      attr(label, "for", "setPassword");
      attr(button0, "class", "ms-modal__outline-button ms-modal__outline-button--mobile");
      attr(button0, "name", "setPassword");
      attr(div0, "class", "ms-form__group");
      attr(button1, "class", "ms-modal__save-button ms-modal__save-button--large");
      button1.disabled = button1_disabled_value = !ctx[3];
      attr(div1, "class", "ms-modal__action-container");
    },
    m: function m(target, anchor) {
      insert(target, form, anchor);
      mount_component(emailinput, form, null);
      insert(target, t0, anchor);
      insert(target, div0, anchor);
      append(div0, label);
      append(div0, t2);
      append(div0, button0);
      mount_component(passwordlockicon, button0, null);
      append(button0, t3);
      if_block0.m(button0, null);
      insert(target, t4, anchor);
      if (if_block1) if_block1.m(target, anchor);
      insert(target, t5, anchor);
      insert(target, div1, anchor);
      append(div1, button1);
      append(button1, t6);
      current = true;
      if (!mounted) {
        dispose = [listen(form, "submit", stop_propagation(prevent_default( /*submitEmailChange*/ctx[5]))), listen(button0, "click", /*click_handler*/ctx[12]), listen(button1, "click", /*submitEmailChange*/ctx[5])];
        mounted = true;
      }
    },
    p: function p(ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      var emailinput_changes = {};
      if (!updating_emailInputValid && dirty & /*emailInputValid*/8) {
        updating_emailInputValid = true;
        emailinput_changes.emailInputValid = /*emailInputValid*/ctx[3];
        add_flush_callback(function () {
          return updating_emailInputValid = false;
        });
      }
      if (!updating_emailValue && dirty & /*emailValue*/4) {
        updating_emailValue = true;
        emailinput_changes.emailValue = /*emailValue*/ctx[2];
        add_flush_callback(function () {
          return updating_emailValue = false;
        });
      }
      emailinput.$set(emailinput_changes);
      if (current_block_type !== (current_block_type = select_block_type(ctx))) {
        if_block0.d(1);
        if_block0 = current_block_type(ctx);
        if (if_block0) {
          if_block0.c();
          if_block0.m(button0, null);
        }
      }
      if ( /*$app*/ctx[4].authProviders.length > 0) {
        if (if_block1) {
          if_block1.p(ctx, dirty);
        } else {
          if_block1 = create_if_block$3(ctx);
          if_block1.c();
          if_block1.m(t5.parentNode, t5);
        }
      } else if (if_block1) {
        if_block1.d(1);
        if_block1 = null;
      }
      if (!current || dirty & /*emailInputValid*/8 && button1_disabled_value !== (button1_disabled_value = !ctx[3])) {
        button1.disabled = button1_disabled_value;
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(emailinput.$$.fragment, local);
      transition_in(passwordlockicon.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(emailinput.$$.fragment, local);
      transition_out(passwordlockicon.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(form);
      destroy_component(emailinput);
      if (detaching) detach(t0);
      if (detaching) detach(div0);
      destroy_component(passwordlockicon);
      if_block0.d();
      if (detaching) detach(t4);
      if (if_block1) if_block1.d(detaching);
      if (detaching) detach(t5);
      if (detaching) detach(div1);
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$3($$self, $$props, $$invalidate) {
  var $app;
  component_subscribe($$self, AppStore, function ($$value) {
    return $$invalidate(4, $app = $$value);
  });
  var displayProfile = $$props.displayProfile;
  var member = $$props.member;
  var emailValue = $$props.emailValue;
  var profileLoader = $$props.profileLoader;
  // sort
  $app.authProviders.sort(function (a, b) {
    if (isConnected(a) === isConnected(b)) {
      return a.order - b.order;
    }
    return isConnected(a) ? -1 : 1;
  });
  var emailInputValid = false;
  function submitEmailChange(e) {
    return __awaiter(this, void 0, void 0, function () {
      var err_14;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!emailInputValid || !emailValue) return [2 /*return*/];
            $$invalidate(8, profileLoader = true);
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, window.$memberstackDom.updateMemberAuth({
              email: emailValue
            })];
          case 2:
            _a.sent();
            window.$memberstackDom._showMessage("Email successfully changed", false);
            $$invalidate(8, profileLoader = false);
            return [3 /*break*/, 4];
          case 3:
            err_14 = _a.sent();
            window.$memberstackDom._showMessage(err_14.message, true);
            $$invalidate(8, profileLoader = false);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  }

  function disconnectProvider(provider) {
    return __awaiter(this, void 0, void 0, function () {
      var data, err_15;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            $$invalidate(8, profileLoader = true);
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, window.$memberstackDom.disconnectProvider({
              provider: provider
            })];
          case 2:
            data = _a.sent().data;
            $$invalidate(1, member = __assign(__assign({}, member), {
              auth: __assign(__assign({}, member.auth), {
                providers: data.providers
              })
            }));
            window.$memberstackDom._showMessage("Provider successfully disconnected", false);
            $$invalidate(8, profileLoader = false);
            return [3 /*break*/, 4];
          case 3:
            err_15 = _a.sent();
            window.$memberstackDom._showMessage(err_15.message, true);
            $$invalidate(8, profileLoader = false);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  }

  function connectAdditionalProvider(provider) {
    return __awaiter(this, void 0, void 0, function () {
      var data, err_16;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            console.log("connect", provider);
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, window.$memberstackDom.connectProvider({
              provider: provider
            })];
          case 2:
            data = _a.sent().data;
            $$invalidate(1, member = __assign(__assign({}, member), {
              auth: __assign(__assign({}, member.auth), {
                providers: data.providers
              })
            }));
            window.$memberstackDom._showMessage("You have successfully connected your account.", false);
            return [3 /*break*/, 4];
          case 3:
            err_16 = _a.sent();
            window.$memberstackDom._showMessage(err_16.message, true);
            return [3 /*break*/, 4];
          case 4:
            return [2 /*return*/];
        }
      });
    });
  }

  function isConnected(provider) {
    return member.auth.providers.some(function (prv) {
      return prv.provider === provider.provider;
    });
  }
  var func = function func(provider, prv) {
    return prv.provider === provider.provider;
  };
  function emailinput_emailInputValid_binding(value) {
    emailInputValid = value;
    $$invalidate(3, emailInputValid);
  }
  function emailinput_emailValue_binding(value) {
    emailValue = value;
    $$invalidate(2, emailValue);
  }
  var click_handler = function click_handler() {
    return $$invalidate(0, displayProfile = "changePassword");
  };
  var click_handler_1 = function click_handler_1(provider) {
    return disconnectProvider(provider.provider);
  };
  var click_handler_2 = function click_handler_2(provider) {
    return connectAdditionalProvider(provider.provider);
  };
  $$self.$$set = function ($$props) {
    if ('displayProfile' in $$props) $$invalidate(0, displayProfile = $$props.displayProfile);
    if ('member' in $$props) $$invalidate(1, member = $$props.member);
    if ('emailValue' in $$props) $$invalidate(2, emailValue = $$props.emailValue);
    if ('profileLoader' in $$props) $$invalidate(8, profileLoader = $$props.profileLoader);
  };
  return [displayProfile, member, emailValue, emailInputValid, $app, submitEmailChange, disconnectProvider, connectAdditionalProvider, profileLoader, func, emailinput_emailInputValid_binding, emailinput_emailValue_binding, click_handler, click_handler_1, click_handler_2];
}
var MobileSecurityInfoContent = /** @class */function (_super) {
  __extends(MobileSecurityInfoContent, _super);
  function MobileSecurityInfoContent(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$3, create_fragment$3, safe_not_equal, {
      displayProfile: 0,
      member: 1,
      emailValue: 2,
      profileLoader: 8
    });
    return _this;
  }
  return MobileSecurityInfoContent;
}(SvelteComponent);
/* src/components/MobilePasswordInfoContent.svelte generated by Svelte v3.48.0 */
function create_if_block$2(ctx) {
  var passwordinput;
  var updating_passwordValue;
  var updating_passwordInputValid;
  var current;
  function passwordinput_passwordValue_binding(value) {
    /*passwordinput_passwordValue_binding*/ctx[9](value);
  }
  function passwordinput_passwordInputValid_binding(value) {
    /*passwordinput_passwordInputValid_binding*/ctx[10](value);
  }
  var passwordinput_props = {
    passwordLabel: "Current Password",
    passwordPlaceholder: "Enter a strong password"
  };
  if ( /*currentPasswordValue*/ctx[1] !== void 0) {
    passwordinput_props.passwordValue = /*currentPasswordValue*/ctx[1];
  }
  if ( /*currentPasswordValid*/ctx[4] !== void 0) {
    passwordinput_props.passwordInputValid = /*currentPasswordValid*/ctx[4];
  }
  passwordinput = new PasswordInput({
    props: passwordinput_props
  });
  binding_callbacks.push(function () {
    return bind(passwordinput, 'passwordValue', passwordinput_passwordValue_binding);
  });
  binding_callbacks.push(function () {
    return bind(passwordinput, 'passwordInputValid', passwordinput_passwordInputValid_binding);
  });
  return {
    c: function c() {
      create_component(passwordinput.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(passwordinput, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var passwordinput_changes = {};
      if (!updating_passwordValue && dirty & /*currentPasswordValue*/2) {
        updating_passwordValue = true;
        passwordinput_changes.passwordValue = /*currentPasswordValue*/ctx[1];
        add_flush_callback(function () {
          return updating_passwordValue = false;
        });
      }
      if (!updating_passwordInputValid && dirty & /*currentPasswordValid*/16) {
        updating_passwordInputValid = true;
        passwordinput_changes.passwordInputValid = /*currentPasswordValid*/ctx[4];
        add_flush_callback(function () {
          return updating_passwordInputValid = false;
        });
      }
      passwordinput.$set(passwordinput_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(passwordinput.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(passwordinput.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(passwordinput, detaching);
    }
  };
}
function create_fragment$2(ctx) {
  var form;
  var t0;
  var passwordinput0;
  var updating_passwordValue;
  var updating_passwordInputValid;
  var t1;
  var passwordinput1;
  var updating_passwordValue_1;
  var updating_passwordInputValid_1;
  var t2;
  var div;
  var button;
  var t3;
  var button_disabled_value;
  var current;
  var mounted;
  var dispose;
  var if_block = /*member*/ctx[0].auth.hasPassword && create_if_block$2(ctx);
  function passwordinput0_passwordValue_binding(value) {
    /*passwordinput0_passwordValue_binding*/ctx[11](value);
  }
  function passwordinput0_passwordInputValid_binding(value) {
    /*passwordinput0_passwordInputValid_binding*/ctx[12](value);
  }
  var passwordinput0_props = {
    passwordLabel: "New Password",
    passwordPlaceholder: "Enter a strong password"
  };
  if ( /*newPasswordValue*/ctx[2] !== void 0) {
    passwordinput0_props.passwordValue = /*newPasswordValue*/ctx[2];
  }
  if ( /*newPasswordValid*/ctx[5] !== void 0) {
    passwordinput0_props.passwordInputValid = /*newPasswordValid*/ctx[5];
  }
  passwordinput0 = new PasswordInput({
    props: passwordinput0_props
  });
  binding_callbacks.push(function () {
    return bind(passwordinput0, 'passwordValue', passwordinput0_passwordValue_binding);
  });
  binding_callbacks.push(function () {
    return bind(passwordinput0, 'passwordInputValid', passwordinput0_passwordInputValid_binding);
  });
  function passwordinput1_passwordValue_binding(value) {
    /*passwordinput1_passwordValue_binding*/ctx[13](value);
  }
  function passwordinput1_passwordInputValid_binding(value) {
    /*passwordinput1_passwordInputValid_binding*/ctx[14](value);
  }
  var passwordinput1_props = {
    passwordLabel: "Confirm New Password",
    passwordPlaceholder: "Enter a strong password"
  };
  if ( /*confirmPasswordValue*/ctx[3] !== void 0) {
    passwordinput1_props.passwordValue = /*confirmPasswordValue*/ctx[3];
  }
  if ( /*confirmPasswordValid*/ctx[6] !== void 0) {
    passwordinput1_props.passwordInputValid = /*confirmPasswordValid*/ctx[6];
  }
  passwordinput1 = new PasswordInput({
    props: passwordinput1_props
  });
  binding_callbacks.push(function () {
    return bind(passwordinput1, 'passwordValue', passwordinput1_passwordValue_binding);
  });
  binding_callbacks.push(function () {
    return bind(passwordinput1, 'passwordInputValid', passwordinput1_passwordInputValid_binding);
  });
  return {
    c: function c() {
      form = element("form");
      if (if_block) if_block.c();
      t0 = space();
      create_component(passwordinput0.$$.fragment);
      t1 = space();
      create_component(passwordinput1.$$.fragment);
      t2 = space();
      div = element("div");
      button = element("button");
      t3 = text("Save");
      attr(form, "class", "ms-form");
      attr(form, "action", "");
      attr(form, "method", "post");
      attr(form, "autocomplete", "off");
      attr(button, "class", "ms-modal__save-button ms-modal__save-button--large");
      button.disabled = button_disabled_value = /*member*/ctx[0].auth.hasPassword && !ctx[4] || !ctx[5] || !ctx[6];
      attr(div, "class", "ms-modal__action-container");
    },
    m: function m(target, anchor) {
      insert(target, form, anchor);
      if (if_block) if_block.m(form, null);
      append(form, t0);
      mount_component(passwordinput0, form, null);
      append(form, t1);
      mount_component(passwordinput1, form, null);
      insert(target, t2, anchor);
      insert(target, div, anchor);
      append(div, button);
      append(button, t3);
      current = true;
      if (!mounted) {
        dispose = [listen(form, "submit", stop_propagation(prevent_default( /*submitPasswordChange*/ctx[7]))), listen(button, "click", /*submitPasswordChange*/ctx[7])];
        mounted = true;
      }
    },
    p: function p(ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      if ( /*member*/ctx[0].auth.hasPassword) {
        if (if_block) {
          if_block.p(ctx, dirty);
          if (dirty & /*member*/1) {
            transition_in(if_block, 1);
          }
        } else {
          if_block = create_if_block$2(ctx);
          if_block.c();
          transition_in(if_block, 1);
          if_block.m(form, t0);
        }
      } else if (if_block) {
        group_outros();
        transition_out(if_block, 1, 1, function () {
          if_block = null;
        });
        check_outros();
      }
      var passwordinput0_changes = {};
      if (!updating_passwordValue && dirty & /*newPasswordValue*/4) {
        updating_passwordValue = true;
        passwordinput0_changes.passwordValue = /*newPasswordValue*/ctx[2];
        add_flush_callback(function () {
          return updating_passwordValue = false;
        });
      }
      if (!updating_passwordInputValid && dirty & /*newPasswordValid*/32) {
        updating_passwordInputValid = true;
        passwordinput0_changes.passwordInputValid = /*newPasswordValid*/ctx[5];
        add_flush_callback(function () {
          return updating_passwordInputValid = false;
        });
      }
      passwordinput0.$set(passwordinput0_changes);
      var passwordinput1_changes = {};
      if (!updating_passwordValue_1 && dirty & /*confirmPasswordValue*/8) {
        updating_passwordValue_1 = true;
        passwordinput1_changes.passwordValue = /*confirmPasswordValue*/ctx[3];
        add_flush_callback(function () {
          return updating_passwordValue_1 = false;
        });
      }
      if (!updating_passwordInputValid_1 && dirty & /*confirmPasswordValid*/64) {
        updating_passwordInputValid_1 = true;
        passwordinput1_changes.passwordInputValid = /*confirmPasswordValid*/ctx[6];
        add_flush_callback(function () {
          return updating_passwordInputValid_1 = false;
        });
      }
      passwordinput1.$set(passwordinput1_changes);
      if (!current || dirty & /*member, currentPasswordValid, newPasswordValid, confirmPasswordValid*/113 && button_disabled_value !== (button_disabled_value = /*member*/ctx[0].auth.hasPassword && !ctx[4] || !ctx[5] || !ctx[6])) {
        button.disabled = button_disabled_value;
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(if_block);
      transition_in(passwordinput0.$$.fragment, local);
      transition_in(passwordinput1.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(if_block);
      transition_out(passwordinput0.$$.fragment, local);
      transition_out(passwordinput1.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(form);
      if (if_block) if_block.d();
      destroy_component(passwordinput0);
      destroy_component(passwordinput1);
      if (detaching) detach(t2);
      if (detaching) detach(div);
      mounted = false;
      run_all(dispose);
    }
  };
}
function instance$2($$self, $$props, $$invalidate) {
  var profileLoader = $$props.profileLoader;
  var member = $$props.member;
  var currentPasswordValue = "";
  var newPasswordValue = "";
  var confirmPasswordValue = "";
  var currentPasswordValid = false;
  var newPasswordValid = false;
  var confirmPasswordValid = false;
  function submitPasswordChange(e) {
    return __awaiter(this, void 0, void 0, function () {
      var err_17;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (member.auth.hasPassword && !currentPasswordValid && !newPasswordValid && !confirmPasswordValid) return [2 /*return*/];
            if (!member.auth.hasPassword && !newPasswordValid && !confirmPasswordValid) return [2 /*return*/];
            if (newPasswordValue !== confirmPasswordValue) {
              window.$memberstackDom._showMessage("New password and confirm password do not match", true);
              return [2 /*return*/];
            }

            $$invalidate(8, profileLoader = true);
            _a.label = 1;
          case 1:
            _a.trys.push([1, 6,, 7]);
            if (!member.auth.hasPassword) return [3 /*break*/, 3];
            return [4 /*yield*/, window.$memberstackDom.updateMemberAuth({
              oldPassword: currentPasswordValue,
              newPassword: newPasswordValue
            })];
          case 2:
            _a.sent();
            return [3 /*break*/, 5];
          case 3:
            return [4 /*yield*/, window.$memberstackDom.setPassword({
              password: newPasswordValue
            })];
          case 4:
            _a.sent();
            $$invalidate(0, member.auth.hasPassword = true, member);
            _a.label = 5;
          case 5:
            window.$memberstackDom._showMessage("Password successfully changed", false);
            $$invalidate(1, currentPasswordValue = "");
            $$invalidate(2, newPasswordValue = "");
            $$invalidate(3, confirmPasswordValue = "");
            $$invalidate(8, profileLoader = false);
            return [3 /*break*/, 7];
          case 6:
            err_17 = _a.sent();
            window.$memberstackDom._showMessage(err_17.message, true);
            $$invalidate(8, profileLoader = false);
            return [3 /*break*/, 7];
          case 7:
            return [2 /*return*/];
        }
      });
    });
  }

  function passwordinput_passwordValue_binding(value) {
    currentPasswordValue = value;
    $$invalidate(1, currentPasswordValue);
  }
  function passwordinput_passwordInputValid_binding(value) {
    currentPasswordValid = value;
    $$invalidate(4, currentPasswordValid);
  }
  function passwordinput0_passwordValue_binding(value) {
    newPasswordValue = value;
    $$invalidate(2, newPasswordValue);
  }
  function passwordinput0_passwordInputValid_binding(value) {
    newPasswordValid = value;
    $$invalidate(5, newPasswordValid);
  }
  function passwordinput1_passwordValue_binding(value) {
    confirmPasswordValue = value;
    $$invalidate(3, confirmPasswordValue);
  }
  function passwordinput1_passwordInputValid_binding(value) {
    confirmPasswordValid = value;
    $$invalidate(6, confirmPasswordValid);
  }
  $$self.$$set = function ($$props) {
    if ('profileLoader' in $$props) $$invalidate(8, profileLoader = $$props.profileLoader);
    if ('member' in $$props) $$invalidate(0, member = $$props.member);
  };
  return [member, currentPasswordValue, newPasswordValue, confirmPasswordValue, currentPasswordValid, newPasswordValid, confirmPasswordValid, submitPasswordChange, profileLoader, passwordinput_passwordValue_binding, passwordinput_passwordInputValid_binding, passwordinput0_passwordValue_binding, passwordinput0_passwordInputValid_binding, passwordinput1_passwordValue_binding, passwordinput1_passwordInputValid_binding];
}
var MobilePasswordInfoContent = /** @class */function (_super) {
  __extends(MobilePasswordInfoContent, _super);
  function MobilePasswordInfoContent(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$2, create_fragment$2, safe_not_equal, {
      profileLoader: 8,
      member: 0
    });
    return _this;
  }
  return MobilePasswordInfoContent;
}(SvelteComponent);
/* src/modals/MobileProfileModal.svelte generated by Svelte v3.48.0 */
function create_if_block_6$1(ctx) {
  var div;
  var button;
  var backicon;
  var current;
  var mounted;
  var dispose;
  backicon = new BackIcon({});
  return {
    c: function c() {
      div = element("div");
      button = element("button");
      create_component(backicon.$$.fragment);
      attr(div, "class", "ms-modal__profile-back--mobile");
    },
    m: function m(target, anchor) {
      insert(target, div, anchor);
      append(div, button);
      mount_component(backicon, button, null);
      current = true;
      if (!mounted) {
        dispose = listen(button, "click", /*click_handler*/ctx[8]);
        mounted = true;
      }
    },
    p: noop,
    i: function i(local) {
      if (current) return;
      transition_in(backicon.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(backicon.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div);
      destroy_component(backicon);
      mounted = false;
      dispose();
    }
  };
}
// (61:4) {:else}
function create_else_block$1(ctx) {
  var memberstackicon;
  var current;
  memberstackicon = new MemberstackIcon({});
  return {
    c: function c() {
      create_component(memberstackicon.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(memberstackicon, target, anchor);
      current = true;
    },
    p: noop,
    i: function i(local) {
      if (current) return;
      transition_in(memberstackicon.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(memberstackicon.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(memberstackicon, detaching);
    }
  };
}
// (59:4) {#if $app.branding.logo}
function create_if_block_5$1(ctx) {
  var img;
  var img_src_value;
  var img_alt_value;
  return {
    c: function c() {
      img = element("img");
      if (!src_url_equal(img.src, img_src_value = /*$app*/ctx[7].branding.logo)) attr(img, "src", img_src_value);
      attr(img, "alt", img_alt_value = /*$app*/ctx[7].name);
    },
    m: function m(target, anchor) {
      insert(target, img, anchor);
    },
    p: function p(ctx, dirty) {
      if (dirty & /*$app*/128 && !src_url_equal(img.src, img_src_value = /*$app*/ctx[7].branding.logo)) {
        attr(img, "src", img_src_value);
      }
      if (dirty & /*$app*/128 && img_alt_value !== (img_alt_value = /*$app*/ctx[7].name)) {
        attr(img, "alt", img_alt_value);
      }
    },
    i: noop,
    o: noop,
    d: function d(detaching) {
      if (detaching) detach(img);
    }
  };
}
// (74:5) {#if profileLoader}
function create_if_block_4$1(ctx) {
  var profileloader;
  var current;
  profileloader = new ProfileLoader({});
  return {
    c: function c() {
      create_component(profileloader.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(profileloader, target, anchor);
      current = true;
    },
    i: function i(local) {
      if (current) return;
      transition_in(profileloader.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(profileloader.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(profileloader, detaching);
    }
  };
}
// (93:51) 
function create_if_block_3$1(ctx) {
  var mobilepasswordinfocontent;
  var updating_displayProfile;
  var updating_profileLoader;
  var updating_member;
  var current;
  function mobilepasswordinfocontent_displayProfile_binding(value) {
    /*mobilepasswordinfocontent_displayProfile_binding*/ctx[17](value);
  }
  function mobilepasswordinfocontent_profileLoader_binding(value) {
    /*mobilepasswordinfocontent_profileLoader_binding*/ctx[18](value);
  }
  function mobilepasswordinfocontent_member_binding(value) {
    /*mobilepasswordinfocontent_member_binding*/ctx[19](value);
  }
  var mobilepasswordinfocontent_props = {};
  if ( /*displayProfile*/ctx[0] !== void 0) {
    mobilepasswordinfocontent_props.displayProfile = /*displayProfile*/ctx[0];
  }
  if ( /*profileLoader*/ctx[6] !== void 0) {
    mobilepasswordinfocontent_props.profileLoader = /*profileLoader*/ctx[6];
  }
  if ( /*member*/ctx[1] !== void 0) {
    mobilepasswordinfocontent_props.member = /*member*/ctx[1];
  }
  mobilepasswordinfocontent = new MobilePasswordInfoContent({
    props: mobilepasswordinfocontent_props
  });
  binding_callbacks.push(function () {
    return bind(mobilepasswordinfocontent, 'displayProfile', mobilepasswordinfocontent_displayProfile_binding);
  });
  binding_callbacks.push(function () {
    return bind(mobilepasswordinfocontent, 'profileLoader', mobilepasswordinfocontent_profileLoader_binding);
  });
  binding_callbacks.push(function () {
    return bind(mobilepasswordinfocontent, 'member', mobilepasswordinfocontent_member_binding);
  });
  return {
    c: function c() {
      create_component(mobilepasswordinfocontent.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(mobilepasswordinfocontent, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var mobilepasswordinfocontent_changes = {};
      if (!updating_displayProfile && dirty & /*displayProfile*/1) {
        updating_displayProfile = true;
        mobilepasswordinfocontent_changes.displayProfile = /*displayProfile*/ctx[0];
        add_flush_callback(function () {
          return updating_displayProfile = false;
        });
      }
      if (!updating_profileLoader && dirty & /*profileLoader*/64) {
        updating_profileLoader = true;
        mobilepasswordinfocontent_changes.profileLoader = /*profileLoader*/ctx[6];
        add_flush_callback(function () {
          return updating_profileLoader = false;
        });
      }
      if (!updating_member && dirty & /*member*/2) {
        updating_member = true;
        mobilepasswordinfocontent_changes.member = /*member*/ctx[1];
        add_flush_callback(function () {
          return updating_member = false;
        });
      }
      mobilepasswordinfocontent.$set(mobilepasswordinfocontent_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(mobilepasswordinfocontent.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(mobilepasswordinfocontent.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(mobilepasswordinfocontent, detaching);
    }
  };
}
// (91:45) 
function create_if_block_2$1(ctx) {
  var mobilesecurityinfocontent;
  var updating_displayProfile;
  var updating_profileLoader;
  var updating_member;
  var current;
  function mobilesecurityinfocontent_displayProfile_binding(value) {
    /*mobilesecurityinfocontent_displayProfile_binding*/ctx[14](value);
  }
  function mobilesecurityinfocontent_profileLoader_binding(value) {
    /*mobilesecurityinfocontent_profileLoader_binding*/ctx[15](value);
  }
  function mobilesecurityinfocontent_member_binding(value) {
    /*mobilesecurityinfocontent_member_binding*/ctx[16](value);
  }
  var mobilesecurityinfocontent_props = {};
  if ( /*displayProfile*/ctx[0] !== void 0) {
    mobilesecurityinfocontent_props.displayProfile = /*displayProfile*/ctx[0];
  }
  if ( /*profileLoader*/ctx[6] !== void 0) {
    mobilesecurityinfocontent_props.profileLoader = /*profileLoader*/ctx[6];
  }
  if ( /*member*/ctx[1] !== void 0) {
    mobilesecurityinfocontent_props.member = /*member*/ctx[1];
  }
  mobilesecurityinfocontent = new MobileSecurityInfoContent({
    props: mobilesecurityinfocontent_props
  });
  binding_callbacks.push(function () {
    return bind(mobilesecurityinfocontent, 'displayProfile', mobilesecurityinfocontent_displayProfile_binding);
  });
  binding_callbacks.push(function () {
    return bind(mobilesecurityinfocontent, 'profileLoader', mobilesecurityinfocontent_profileLoader_binding);
  });
  binding_callbacks.push(function () {
    return bind(mobilesecurityinfocontent, 'member', mobilesecurityinfocontent_member_binding);
  });
  return {
    c: function c() {
      create_component(mobilesecurityinfocontent.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(mobilesecurityinfocontent, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var mobilesecurityinfocontent_changes = {};
      if (!updating_displayProfile && dirty & /*displayProfile*/1) {
        updating_displayProfile = true;
        mobilesecurityinfocontent_changes.displayProfile = /*displayProfile*/ctx[0];
        add_flush_callback(function () {
          return updating_displayProfile = false;
        });
      }
      if (!updating_profileLoader && dirty & /*profileLoader*/64) {
        updating_profileLoader = true;
        mobilesecurityinfocontent_changes.profileLoader = /*profileLoader*/ctx[6];
        add_flush_callback(function () {
          return updating_profileLoader = false;
        });
      }
      if (!updating_member && dirty & /*member*/2) {
        updating_member = true;
        mobilesecurityinfocontent_changes.member = /*member*/ctx[1];
        add_flush_callback(function () {
          return updating_member = false;
        });
      }
      mobilesecurityinfocontent.$set(mobilesecurityinfocontent_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(mobilesecurityinfocontent.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(mobilesecurityinfocontent.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(mobilesecurityinfocontent, detaching);
    }
  };
}
// (85:44) 
function create_if_block_1$1(ctx) {
  var mobileprofileinfocontent;
  var updating_member;
  var updating_profileLoader;
  var current;
  function mobileprofileinfocontent_member_binding(value) {
    /*mobileprofileinfocontent_member_binding*/ctx[12](value);
  }
  function mobileprofileinfocontent_profileLoader_binding(value) {
    /*mobileprofileinfocontent_profileLoader_binding*/ctx[13](value);
  }
  var mobileprofileinfocontent_props = {
    customFields: /*$app*/ctx[7].customFields
  };
  if ( /*member*/ctx[1] !== void 0) {
    mobileprofileinfocontent_props.member = /*member*/ctx[1];
  }
  if ( /*profileLoader*/ctx[6] !== void 0) {
    mobileprofileinfocontent_props.profileLoader = /*profileLoader*/ctx[6];
  }
  mobileprofileinfocontent = new MobileProfileInfoContent({
    props: mobileprofileinfocontent_props
  });
  binding_callbacks.push(function () {
    return bind(mobileprofileinfocontent, 'member', mobileprofileinfocontent_member_binding);
  });
  binding_callbacks.push(function () {
    return bind(mobileprofileinfocontent, 'profileLoader', mobileprofileinfocontent_profileLoader_binding);
  });
  return {
    c: function c() {
      create_component(mobileprofileinfocontent.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(mobileprofileinfocontent, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var mobileprofileinfocontent_changes = {};
      if (dirty & /*$app*/128) mobileprofileinfocontent_changes.customFields = /*$app*/ctx[7].customFields;
      if (!updating_member && dirty & /*member*/2) {
        updating_member = true;
        mobileprofileinfocontent_changes.member = /*member*/ctx[1];
        add_flush_callback(function () {
          return updating_member = false;
        });
      }
      if (!updating_profileLoader && dirty & /*profileLoader*/64) {
        updating_profileLoader = true;
        mobileprofileinfocontent_changes.profileLoader = /*profileLoader*/ctx[6];
        add_flush_callback(function () {
          return updating_profileLoader = false;
        });
      }
      mobileprofileinfocontent.$set(mobileprofileinfocontent_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(mobileprofileinfocontent.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(mobileprofileinfocontent.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(mobileprofileinfocontent, detaching);
    }
  };
}
// (77:5) {#if displayProfile === "profile-nav"}
function create_if_block$1(ctx) {
  var mobileprofilemodalnav;
  var updating_member;
  var updating_displayProfile;
  var updating_profileLoader;
  var current;
  function mobileprofilemodalnav_member_binding(value) {
    /*mobileprofilemodalnav_member_binding*/ctx[9](value);
  }
  function mobileprofilemodalnav_displayProfile_binding(value) {
    /*mobileprofilemodalnav_displayProfile_binding*/ctx[10](value);
  }
  function mobileprofilemodalnav_profileLoader_binding(value) {
    /*mobileprofilemodalnav_profileLoader_binding*/ctx[11](value);
  }
  var mobileprofilemodalnav_props = {
    onSuccessLogout: /*onSuccessLogout*/ctx[3],
    hideProfileSection: /*hideProfileSection*/ctx[5]
  };
  if ( /*member*/ctx[1] !== void 0) {
    mobileprofilemodalnav_props.member = /*member*/ctx[1];
  }
  if ( /*displayProfile*/ctx[0] !== void 0) {
    mobileprofilemodalnav_props.displayProfile = /*displayProfile*/ctx[0];
  }
  if ( /*profileLoader*/ctx[6] !== void 0) {
    mobileprofilemodalnav_props.profileLoader = /*profileLoader*/ctx[6];
  }
  mobileprofilemodalnav = new MobileProfileModalNav({
    props: mobileprofilemodalnav_props
  });
  binding_callbacks.push(function () {
    return bind(mobileprofilemodalnav, 'member', mobileprofilemodalnav_member_binding);
  });
  binding_callbacks.push(function () {
    return bind(mobileprofilemodalnav, 'displayProfile', mobileprofilemodalnav_displayProfile_binding);
  });
  binding_callbacks.push(function () {
    return bind(mobileprofilemodalnav, 'profileLoader', mobileprofilemodalnav_profileLoader_binding);
  });
  return {
    c: function c() {
      create_component(mobileprofilemodalnav.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(mobileprofilemodalnav, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var mobileprofilemodalnav_changes = {};
      if (dirty & /*onSuccessLogout*/8) mobileprofilemodalnav_changes.onSuccessLogout = /*onSuccessLogout*/ctx[3];
      if (dirty & /*hideProfileSection*/32) mobileprofilemodalnav_changes.hideProfileSection = /*hideProfileSection*/ctx[5];
      if (!updating_member && dirty & /*member*/2) {
        updating_member = true;
        mobileprofilemodalnav_changes.member = /*member*/ctx[1];
        add_flush_callback(function () {
          return updating_member = false;
        });
      }
      if (!updating_displayProfile && dirty & /*displayProfile*/1) {
        updating_displayProfile = true;
        mobileprofilemodalnav_changes.displayProfile = /*displayProfile*/ctx[0];
        add_flush_callback(function () {
          return updating_displayProfile = false;
        });
      }
      if (!updating_profileLoader && dirty & /*profileLoader*/64) {
        updating_profileLoader = true;
        mobileprofilemodalnav_changes.profileLoader = /*profileLoader*/ctx[6];
        add_flush_callback(function () {
          return updating_profileLoader = false;
        });
      }
      mobileprofilemodalnav.$set(mobileprofilemodalnav_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(mobileprofilemodalnav.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(mobileprofilemodalnav.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(mobileprofilemodalnav, detaching);
    }
  };
}
function create_fragment$1(ctx) {
  var div5;
  var div2;
  var t0;
  var div1;
  var figure;
  var current_block_type_index;
  var if_block1;
  var t1;
  var div0;
  var b;
  var t2;
  var t3;
  var closebutton;
  var t4;
  var div4;
  var div3;
  var t5;
  var current_block_type_index_1;
  var if_block3;
  var t6;
  var modalfooter;
  var current;
  var if_block0 = ( /*displayProfile*/ctx[0] === "profile" || /*displayProfile*/ctx[0] === "changePassword" || /*displayProfile*/ctx[0] === "security") && create_if_block_6$1(ctx);
  var if_block_creators = [create_if_block_5$1, create_else_block$1];
  var if_blocks = [];
  function select_block_type(ctx, dirty) {
    if ( /*$app*/ctx[7].branding.logo) return 0;
    return 1;
  }
  current_block_type_index = select_block_type(ctx);
  if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  closebutton = new CloseButton({
    props: {
      closeModal: /*closeModal*/ctx[4]
    }
  });
  var if_block2 = /*profileLoader*/ctx[6] && create_if_block_4$1();
  var if_block_creators_1 = [create_if_block$1, create_if_block_1$1, create_if_block_2$1, create_if_block_3$1];
  var if_blocks_1 = [];
  function select_block_type_1(ctx, dirty) {
    if ( /*displayProfile*/ctx[0] === "profile-nav") return 0;
    if ( /*displayProfile*/ctx[0] === "profile") return 1;
    if ( /*displayProfile*/ctx[0] === "security") return 2;
    if ( /*displayProfile*/ctx[0] === "changePassword") return 3;
    return -1;
  }
  if (~(current_block_type_index_1 = select_block_type_1(ctx))) {
    if_block3 = if_blocks_1[current_block_type_index_1] = if_block_creators_1[current_block_type_index_1](ctx);
  }
  modalfooter = new ModalFooter({});
  return {
    c: function c() {
      div5 = element("div");
      div2 = element("div");
      if (if_block0) if_block0.c();
      t0 = space();
      div1 = element("div");
      figure = element("figure");
      if_block1.c();
      t1 = space();
      div0 = element("div");
      b = element("b");
      t2 = text( /*profileTitle*/ctx[2]);
      t3 = space();
      create_component(closebutton.$$.fragment);
      t4 = space();
      div4 = element("div");
      div3 = element("div");
      if (if_block2) if_block2.c();
      t5 = space();
      if (if_block3) if_block3.c();
      t6 = space();
      create_component(modalfooter.$$.fragment);
      attr(figure, "class", "ms-modal__figure ms-modal__figure--mobile");
      attr(div1, "class", "ms-modal__header--center");
      attr(div2, "class", "ms-modal__header--mobile");
      attr(div3, "class", "ms-modal__content--mobile");
      attr(div4, "class", "ms-modal__content ms-modal__content--profile");
      attr(div5, "class", "ms-modal ms-modal--profile");
      attr(div5, "id", "MobileProfileModal");
    },
    m: function m(target, anchor) {
      insert(target, div5, anchor);
      append(div5, div2);
      if (if_block0) if_block0.m(div2, null);
      append(div2, t0);
      append(div2, div1);
      append(div1, figure);
      if_blocks[current_block_type_index].m(figure, null);
      append(div1, t1);
      append(div1, div0);
      append(div0, b);
      append(b, t2);
      append(div2, t3);
      mount_component(closebutton, div2, null);
      append(div5, t4);
      append(div5, div4);
      append(div4, div3);
      if (if_block2) if_block2.m(div3, null);
      append(div3, t5);
      if (~current_block_type_index_1) {
        if_blocks_1[current_block_type_index_1].m(div3, null);
      }
      append(div5, t6);
      mount_component(modalfooter, div5, null);
      current = true;
    },
    p: function p(ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      if ( /*displayProfile*/ctx[0] === "profile" || /*displayProfile*/ctx[0] === "changePassword" || /*displayProfile*/ctx[0] === "security") {
        if (if_block0) {
          if_block0.p(ctx, dirty);
          if (dirty & /*displayProfile*/1) {
            transition_in(if_block0, 1);
          }
        } else {
          if_block0 = create_if_block_6$1(ctx);
          if_block0.c();
          transition_in(if_block0, 1);
          if_block0.m(div2, t0);
        }
      } else if (if_block0) {
        group_outros();
        transition_out(if_block0, 1, 1, function () {
          if_block0 = null;
        });
        check_outros();
      }
      var previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, function () {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block1 = if_blocks[current_block_type_index];
        if (!if_block1) {
          if_block1 = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
          if_block1.c();
        } else {
          if_block1.p(ctx, dirty);
        }
        transition_in(if_block1, 1);
        if_block1.m(figure, null);
      }
      if (!current || dirty & /*profileTitle*/4) set_data(t2, /*profileTitle*/ctx[2]);
      var closebutton_changes = {};
      if (dirty & /*closeModal*/16) closebutton_changes.closeModal = /*closeModal*/ctx[4];
      closebutton.$set(closebutton_changes);
      if ( /*profileLoader*/ctx[6]) {
        if (if_block2) {
          if (dirty & /*profileLoader*/64) {
            transition_in(if_block2, 1);
          }
        } else {
          if_block2 = create_if_block_4$1();
          if_block2.c();
          transition_in(if_block2, 1);
          if_block2.m(div3, t5);
        }
      } else if (if_block2) {
        group_outros();
        transition_out(if_block2, 1, 1, function () {
          if_block2 = null;
        });
        check_outros();
      }
      var previous_block_index_1 = current_block_type_index_1;
      current_block_type_index_1 = select_block_type_1(ctx);
      if (current_block_type_index_1 === previous_block_index_1) {
        if (~current_block_type_index_1) {
          if_blocks_1[current_block_type_index_1].p(ctx, dirty);
        }
      } else {
        if (if_block3) {
          group_outros();
          transition_out(if_blocks_1[previous_block_index_1], 1, 1, function () {
            if_blocks_1[previous_block_index_1] = null;
          });
          check_outros();
        }
        if (~current_block_type_index_1) {
          if_block3 = if_blocks_1[current_block_type_index_1];
          if (!if_block3) {
            if_block3 = if_blocks_1[current_block_type_index_1] = if_block_creators_1[current_block_type_index_1](ctx);
            if_block3.c();
          } else {
            if_block3.p(ctx, dirty);
          }
          transition_in(if_block3, 1);
          if_block3.m(div3, null);
        } else {
          if_block3 = null;
        }
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(if_block0);
      transition_in(if_block1);
      transition_in(closebutton.$$.fragment, local);
      transition_in(if_block2);
      transition_in(if_block3);
      transition_in(modalfooter.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(if_block0);
      transition_out(if_block1);
      transition_out(closebutton.$$.fragment, local);
      transition_out(if_block2);
      transition_out(if_block3);
      transition_out(modalfooter.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(div5);
      if (if_block0) if_block0.d();
      if_blocks[current_block_type_index].d();
      destroy_component(closebutton);
      if (if_block2) if_block2.d();
      if (~current_block_type_index_1) {
        if_blocks_1[current_block_type_index_1].d();
      }
      destroy_component(modalfooter);
    }
  };
}
function instance$1($$self, $$props, $$invalidate) {
  var $app;
  component_subscribe($$self, AppStore, function ($$value) {
    return $$invalidate(7, $app = $$value);
  });
  var onSuccessLogout = $$props.onSuccessLogout;
  var closeModal = $$props.closeModal;
  var _a = $$props.displayProfile,
    displayProfile = _a === void 0 ? "profile-nav" : _a;
  var member = $$props.member;
  var _b = $$props.profileTitle,
    profileTitle = _b === void 0 ? member.auth.email : _b;
  var hideProfileSection = false;
  var profileLoader = false;
  if (!$app.customFields.filter(function (field) {
    return !field.hidden;
  }).length) {
    displayProfile = "security";
    hideProfileSection = true;
  }
  var click_handler = function click_handler() {
    return $$invalidate(0, displayProfile = "profile-nav");
  };
  function mobileprofilemodalnav_member_binding(value) {
    member = value;
    $$invalidate(1, member);
  }
  function mobileprofilemodalnav_displayProfile_binding(value) {
    displayProfile = value;
    $$invalidate(0, displayProfile);
  }
  function mobileprofilemodalnav_profileLoader_binding(value) {
    profileLoader = value;
    $$invalidate(6, profileLoader);
  }
  function mobileprofileinfocontent_member_binding(value) {
    member = value;
    $$invalidate(1, member);
  }
  function mobileprofileinfocontent_profileLoader_binding(value) {
    profileLoader = value;
    $$invalidate(6, profileLoader);
  }
  function mobilesecurityinfocontent_displayProfile_binding(value) {
    displayProfile = value;
    $$invalidate(0, displayProfile);
  }
  function mobilesecurityinfocontent_profileLoader_binding(value) {
    profileLoader = value;
    $$invalidate(6, profileLoader);
  }
  function mobilesecurityinfocontent_member_binding(value) {
    member = value;
    $$invalidate(1, member);
  }
  function mobilepasswordinfocontent_displayProfile_binding(value) {
    displayProfile = value;
    $$invalidate(0, displayProfile);
  }
  function mobilepasswordinfocontent_profileLoader_binding(value) {
    profileLoader = value;
    $$invalidate(6, profileLoader);
  }
  function mobilepasswordinfocontent_member_binding(value) {
    member = value;
    $$invalidate(1, member);
  }
  $$self.$$set = function ($$props) {
    if ('onSuccessLogout' in $$props) $$invalidate(3, onSuccessLogout = $$props.onSuccessLogout);
    if ('closeModal' in $$props) $$invalidate(4, closeModal = $$props.closeModal);
    if ('displayProfile' in $$props) $$invalidate(0, displayProfile = $$props.displayProfile);
    if ('member' in $$props) $$invalidate(1, member = $$props.member);
    if ('profileTitle' in $$props) $$invalidate(2, profileTitle = $$props.profileTitle);
  };
  $$self.$$.update = function () {
    if ($$self.$$.dirty & /*displayProfile, member*/3) {
      if (displayProfile === "profile-nav") {
        $$invalidate(2, profileTitle = member.auth.email);
      } else if (displayProfile === "profile") {
        $$invalidate(2, profileTitle = "My Profile");
      } else if (displayProfile === "security") {
        $$invalidate(2, profileTitle = "Security");
      } else if (displayProfile === "changePassword") {
        if (!member.auth.hasPassword) {
          $$invalidate(2, profileTitle = "Set Password");
        } else {
          $$invalidate(2, profileTitle = "Change Password");
        }
      }
    }
  };
  return [displayProfile, member, profileTitle, onSuccessLogout, closeModal, hideProfileSection, profileLoader, $app, click_handler, mobileprofilemodalnav_member_binding, mobileprofilemodalnav_displayProfile_binding, mobileprofilemodalnav_profileLoader_binding, mobileprofileinfocontent_member_binding, mobileprofileinfocontent_profileLoader_binding, mobilesecurityinfocontent_displayProfile_binding, mobilesecurityinfocontent_profileLoader_binding, mobilesecurityinfocontent_member_binding, mobilepasswordinfocontent_displayProfile_binding, mobilepasswordinfocontent_profileLoader_binding, mobilepasswordinfocontent_member_binding];
}
var MobileProfileModal = /** @class */function (_super) {
  __extends(MobileProfileModal, _super);
  function MobileProfileModal(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance$1, create_fragment$1, safe_not_equal, {
      onSuccessLogout: 3,
      closeModal: 4,
      displayProfile: 0,
      member: 1,
      profileTitle: 2
    });
    return _this;
  }
  return MobileProfileModal;
}(SvelteComponent);
/* src/Main.svelte generated by Svelte v3.48.0 */
function add_css(target) {
  append_styles(target, "svelte-bbv5du", "@import url(\"https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap\");.svelte-bbv5du{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}#msOverlay.svelte-bbv5du{position:fixed;display:flex;justify-content:center;align-items:center;width:100%;height:100%;top:0;left:0;right:0;bottom:0;background-color:rgba(0, 0, 0, 0.5);z-index:99999;overflow:scroll;font-family:\"Plus Jakarta Sans\", sans-serif;padding:5vh 5vw}.--hide{display:none}.--flex-h-center{display:flex;align-items:center}.ms__loader{position:relative;z-index:10000000}#msLoader path{fill:#007ace}.ms__profile__loader{position:absolute;top:0;left:0;width:100%;height:100%;display:flex;justify-content:center;align-items:center;background:rgb(255 255 255 / 75%)}.ms-modal{box-sizing:border-box;margin:auto;min-width:0;position:relative;outline:none;background:white;border-radius:16px;box-shadow:2px 2px 12px rgb(0 0 0 / 10%);width:360px;color:rgb(10, 10, 10)}.ms-modal--profile{width:700px}.ms-modal__close{box-sizing:border-box;margin:0;min-width:0;position:absolute;top:16px;right:16px;z-index:10;line-height:0}.ms-modal__close button{appearance:none;padding:0;outline:none;width:12px;border:0;background:transparent;cursor:pointer;color:#5c5c5c}.ms-modal__close button:hover{color:#0a0a0a}.ms-modal__back{box-sizing:border-box;margin:0;min-width:0;position:absolute;top:16px;left:16px;z-index:10;line-height:0}.ms-modal__back button{appearance:none;padding:0;outline:none;width:12px;border:0;background:transparent;cursor:pointer;color:#5c5c5c}.ms-modal__back button:hover, .ms-modal__profile-back button:hover{color:#0a0a0a}.ms-modal__back svg{height:12px}.ms-modal__profile-back button{appearance:none;padding:5px;margin-right:6px;outline:none;width:25px;height:25px;border:0;background:transparent;cursor:pointer;color:#5c5c5c;display:flex;align-items:stretch;justify-content:center}.ms-modal__profile-back--mobile{box-sizing:border-box;margin:0;min-width:0;position:absolute;top:16px;left:16px;z-index:10;line-height:0}.ms-modal__profile-back--mobile button{appearance:none;padding:0;outline:none;height:11px;width:7px;border:0;background:transparent;cursor:pointer;color:#5c5c5c}.ms-modal__profile-back--mobile button:hover{color:#0a0a0a}.ms-modal__header{display:flex;align-items:center;padding:12px}.ms-modal__header--mobile{display:flex;padding:42px 42px 16px 42px;flex-direction:column;flex-wrap:wrap;justify-content:center;align-items:center}.ms-modal__header--center{display:flex;flex-direction:column;flex-wrap:wrap;justify-content:center;align-items:center}.ms-modal__content{padding:28px 28px 20px;width:100%;box-sizing:border-box;margin:0 auto}.ms-modal__content--profile{padding:0;display:flex;flex-wrap:wrap;align-content:stretch;align-items:stretch;border-top:1px solid #DDDDDD}.ms-modal__content-left{display:flex;flex-direction:column;align-items:flex-start;padding:20px;border-right:1px solid #DDDDDD;min-width:160px}.ms-modal__content-right{padding:20px;flex-grow:1;height:55vh;min-height:300px;overflow-y:auto;position:relative;transition:height 0.3s ease-in-out}.ms-modal__content--mobile{padding:12px;flex-grow:1;height:42vh;min-height:300px;overflow-y:auto;position:relative;transition:height 0.3s ease-in-out}.ms-modal__mobile-profile-nav{display:flex;flex-direction:column;align-content:center;align-items:stretch;flex-wrap:nowrap}.ms-modal__mobile-profile-nav button{display:flex;flex-direction:row;align-content:center;align-items:center;flex-wrap:nowrap;justify-content:space-between;padding:12px;width:100%;margin-bottom:10px}.ms-modal__figure{margin:8px auto;display:flex;position:relative;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center;flex-shrink:0;line-height:1}.ms-modal__figure--profile{width:24px;height:24px;padding:0px;margin:0px 8px 0px 0px}.ms-modal__figure--mobile{margin:0px 0px 8px 0px}.ms-modal__figure img, .ms-modal__figure svg{width:auto;height:100%;max-height:42px;text-align:center;object-fit:cover;color:transparent}.ms-modal__title-container{display:flex;justify-content:space-between;align-items:center;margin-bottom:24px}.ms-modal__title{margin-bottom:36px;margin-top:0;text-align:center;font-size:24px;line-height:32px;font-weight:700}.ms-modal__title--profile{margin-bottom:0px}.ms-modal__title-group{display:flex;align-items:center}.ms-modal__title--sub-text{margin-bottom:8px}.ms-modal__text{font-weight:500;font-size:16px;line-height:28px;text-align:center;margin:0 0 20px 0}.ms-modal__regular-button{color:#fff;padding:8px;border-radius:4px;border:none;font-weight:700;font-size:14px;line-height:16px;cursor:pointer;display:flex;align-items:center}.ms-modal__regular-button svg{height:16px;margin-left:6px}.ms-modal__regular-button--left-icon svg{margin-right:6px;margin-left:0px}.ms-modal__regular-button--right-icon svg{margin-left:6px;margin-right:0px}.ms-modal__regular-button--margin-right{margin-right:12px}.ms-modal__text-button{color:#fff;background-color:transparent;padding:8px;border-radius:4px;border:none;font-weight:700;font-size:14px;line-height:16px;cursor:pointer;display:flex;align-items:center}.ms-modal__card{box-shadow:0 0 #0000,0 0 #0000,0 0 #0000,0 0 #0000,0px 2px 2px rgba(0,0,0,0.04);padding:12px;display:flex;flex-direction:row;margin-bottom:12px;border:1px solid rgb(221, 221, 221);border-radius:10px;box-sizing:border-box;width:100%;cursor:default;background:rgb(255, 255, 255);align-items:center;justify-content:space-between}.ms-form{width:100%}.ms-form__group{margin-bottom:20px}.ms-form__flex{display:flex;justify-content:space-between;align-content:center}.ms-form__flex--centered{justify-content:center}.ms-form__label{margin-bottom:4px;margin-top:0px;font-size:14px;line-height:24px;font-weight:700;text-align:left}.ms-form__fieldset{display:flex;justify-content:space-between;padding:0;border:none}.ms-form__input{box-sizing:border-box;margin:0px;border:1px solid rgb(201, 201, 201);border-radius:6px;font-size:16px;font-weight:400;padding:15px;width:100%}.ms-form__password-container{display:flex;justify-content:space-between;align-content:center;box-sizing:border-box;margin:0px;border:1px solid rgb(201, 201, 201);border-radius:6px;width:100%}.ms-form__password-container:focus-within{border:1px solid rgb(0, 68, 252);outline:rgb(0, 68, 252) solid 1px}.ms-form__password-container:focus-within input{outline:none;border-color:rgb(201, 201, 201);box-shadow:none}.ms-form__input--password{border:none}.ms-form__input--token{font-weight:500;font-size:24.19px;line-height:32px;text-align:center;color:#000000;padding:9px;max-width:42px}.ms-form__show-toggle{cursor:pointer;background:transparent;border-radius:0px 6px 6px 0px;padding:0px 8px;display:flex;align-items:center}.ms-form__eye{display:block;width:22px}.ms-form__eye-slash{display:block;width:22px}.ms-form__error{font-weight:500;font-size:12px;line-height:16px;color:#e40023;margin-top:4px;display:flex;align-items:baseline}.ms-form__error svg{width:10px;height:10px;margin-right:5px}.ms-form__label--right a{color:rgb(10, 10, 10) !important;text-decoration:none;font-weight:400}.ms-form__button{border-radius:6px;font-weight:700;font-size:16px;padding-left:22px;padding-right:22px;height:52px;border:none;display:block;width:100%;background-color:rgb(41, 98, 255);color:#fff;transition:background-color 0.5s ease;cursor:pointer}.ms-form__button:hover{background-color:#0745ff}.ms-form__button:disabled{background-color:#96C0FE;color:#fff;pointer-events:none;display:flex;justify-content:center;align-items:center}.ms-form__button--text{background-color:transparent;padding:0px;height:auto;margin-bottom:0px;margin-top:0px;font-size:14px;line-height:28px;font-weight:500;color:#0A0A0A;opacity:0.8}.ms-form__button--text:hover{background-color:transparent}.ms-form__button--top-spacing{margin-top:10px}#msFormLoader path{fill:#fff}a.ms-form__link, div.ms-form__link{margin-top:8px;font-weight:500;font-size:14px;line-height:24px;color:rgb(10, 10, 10) !important;text-decoration:none;opacity:0.8;cursor:pointer}.ms-modal__cancel-button{background:#F6F6F6;color:#828282;padding:8px;margin-right:8px;border-radius:4px;border:none;font-weight:700;font-size:14px;line-height:16px;cursor:pointer}.ms-modal__save-button{background:#2962FF;color:#fff;padding:8px;border-radius:4px;border:none;font-weight:700;font-size:14px;line-height:16px;cursor:pointer}.ms-modal__save-button:disabled{background:#80a1fc;color:#fff;cursor:default}.ms-modal__save-button--large{padding:12px;font-weight:700;font-size:14px;line-height:16px;width:100%}.ms-modal__outline-button{background:#fff;color:#0A0A0A;font-weight:700;font-size:14px;line-height:16px;padding:12px;margin-right:8px;border-radius:4px;border:1px solid #DDDDDD;cursor:pointer}.ms-modal__outline-button svg{height:14px;margin-right:6px}.ms-modal__outline-button--mobile{width:100%}.ms-modal__button-label{margin-bottom:4px;margin-top:0px;font-size:14px;line-height:28px;font-weight:500}.ms-modal__profile-option{cursor:pointer;margin-bottom:20px;font-weight:500;font-size:16px;line-height:28px;background:transparent;border:none;padding:0px}.ms-modal__profile-option svg{height:14px;margin-right:8px}.ms-modal__profile-option:hover{color:#2962FF}.ms-modal__profile-option--active{color:#2962FF}.ms-modal__social-button{display:flex;align-items:center;justify-content:center;width:100%;height:52px;border-radius:6px;font-weight:700;font-size:16px;line-height:28px;color:#0A0A0A;background:none;border:1px solid #C9C9C9;cursor:pointer;margin-bottom:8px}.ms-modal__social-button img{height:16px;margin-right:8px}.ms-modal__social-button[disabled]{background:#F6F6F6}.ms-modal__social-divider{display:flex;align-items:center;margin:20px 0px}.ms-modal__divider-line{text-align:center;background:#dddddd;height:1px;width:100%}.ms-modal__divider-text{padding:0px 4px}.ms-modal__footer{text-align:center;width:100%;box-sizing:border-box;margin:0;min-width:0;background:#f6f6f6;padding-top:10px;padding-bottom:10px;border-bottom-left-radius:16px;border-bottom-right-radius:16px;border-top:1px solid;border-top-color:#dddddd;font-size:12px;line-height:16px;font-weight:500}.ms-modal__footer a{color:rgb(10, 10, 10);text-decoration:none;display:flex;justify-content:center;align-items:center}.ms-modal__footer svg{height:12px;width:12px;margin-right:5.5px}");
}
// (91:36) 
function create_if_block_6(ctx) {
  var mediaquery;
  var current;
  mediaquery = new MediaQuery({
    props: {
      query: "(max-width: 520px)",
      $$slots: {
        default: [create_default_slot, function (_a) {
          var matches = _a.matches;
          return {
            21: matches
          };
        }, function (_a) {
          var matches = _a.matches;
          return matches ? 2097152 : 0;
        }]
      },
      $$scope: {
        ctx: ctx
      }
    }
  });
  return {
    c: function c() {
      create_component(mediaquery.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(mediaquery, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var mediaquery_changes = {};
      if (dirty & /*$$scope, onSuccess, member, display, matches*/6291469) {
        mediaquery_changes.$$scope = {
          dirty: dirty,
          ctx: ctx
        };
      }
      mediaquery.$set(mediaquery_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(mediaquery.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(mediaquery.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(mediaquery, detaching);
    }
  };
}
// (89:51) 
function create_if_block_5(ctx) {
  var passwordsuccessmodal;
  var updating_display;
  var current;
  function passwordsuccessmodal_display_binding(value) {
    /*passwordsuccessmodal_display_binding*/ctx[14](value);
  }
  var passwordsuccessmodal_props = {
    closeModal: /*closeModal*/ctx[5]
  };
  if ( /*display*/ctx[0] !== void 0) {
    passwordsuccessmodal_props.display = /*display*/ctx[0];
  }
  passwordsuccessmodal = new PassSuccessModal({
    props: passwordsuccessmodal_props
  });
  binding_callbacks.push(function () {
    return bind(passwordsuccessmodal, 'display', passwordsuccessmodal_display_binding);
  });
  return {
    c: function c() {
      create_component(passwordsuccessmodal.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(passwordsuccessmodal, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var passwordsuccessmodal_changes = {};
      if (!updating_display && dirty & /*display*/1) {
        updating_display = true;
        passwordsuccessmodal_changes.display = /*display*/ctx[0];
        add_flush_callback(function () {
          return updating_display = false;
        });
      }
      passwordsuccessmodal.$set(passwordsuccessmodal_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(passwordsuccessmodal.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(passwordsuccessmodal.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(passwordsuccessmodal, detaching);
    }
  };
}
// (87:43) 
function create_if_block_4(ctx) {
  var passwordtokenmodal;
  var updating_display;
  var current;
  function passwordtokenmodal_display_binding(value) {
    /*passwordtokenmodal_display_binding*/ctx[13](value);
  }
  var passwordtokenmodal_props = {
    closeModal: /*closeModal*/ctx[5],
    onSuccessPasswordReset: /*onSuccess*/ctx[2]
  };
  if ( /*display*/ctx[0] !== void 0) {
    passwordtokenmodal_props.display = /*display*/ctx[0];
  }
  passwordtokenmodal = new PassTokenModal({
    props: passwordtokenmodal_props
  });
  binding_callbacks.push(function () {
    return bind(passwordtokenmodal, 'display', passwordtokenmodal_display_binding);
  });
  return {
    c: function c() {
      create_component(passwordtokenmodal.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(passwordtokenmodal, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var passwordtokenmodal_changes = {};
      if (dirty & /*onSuccess*/4) passwordtokenmodal_changes.onSuccessPasswordReset = /*onSuccess*/ctx[2];
      if (!updating_display && dirty & /*display*/1) {
        updating_display = true;
        passwordtokenmodal_changes.display = /*display*/ctx[0];
        add_flush_callback(function () {
          return updating_display = false;
        });
      }
      passwordtokenmodal.$set(passwordtokenmodal_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(passwordtokenmodal.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(passwordtokenmodal.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(passwordtokenmodal, detaching);
    }
  };
}
// (85:44) 
function create_if_block_3(ctx) {
  var passwordresetmodal;
  var updating_display;
  var current;
  function passwordresetmodal_display_binding(value) {
    /*passwordresetmodal_display_binding*/ctx[12](value);
  }
  var passwordresetmodal_props = {
    closeModal: /*closeModal*/ctx[5]
  };
  if ( /*display*/ctx[0] !== void 0) {
    passwordresetmodal_props.display = /*display*/ctx[0];
  }
  passwordresetmodal = new PassResetModal({
    props: passwordresetmodal_props
  });
  binding_callbacks.push(function () {
    return bind(passwordresetmodal, 'display', passwordresetmodal_display_binding);
  });
  return {
    c: function c() {
      create_component(passwordresetmodal.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(passwordresetmodal, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var passwordresetmodal_changes = {};
      if (!updating_display && dirty & /*display*/1) {
        updating_display = true;
        passwordresetmodal_changes.display = /*display*/ctx[0];
        add_flush_callback(function () {
          return updating_display = false;
        });
      }
      passwordresetmodal.$set(passwordresetmodal_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(passwordresetmodal.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(passwordresetmodal.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(passwordresetmodal, detaching);
    }
  };
}
// (83:35) 
function create_if_block_2(ctx) {
  var signupmodal;
  var updating_display;
  var updating_params;
  var current;
  function signupmodal_display_binding(value) {
    /*signupmodal_display_binding*/ctx[10](value);
  }
  function signupmodal_params_binding(value) {
    /*signupmodal_params_binding*/ctx[11](value);
  }
  var signupmodal_props = {
    closeModal: /*closeModal*/ctx[5],
    onSuccessSignup: /*onSuccess*/ctx[2]
  };
  if ( /*display*/ctx[0] !== void 0) {
    signupmodal_props.display = /*display*/ctx[0];
  }
  if ( /*params*/ctx[1] !== void 0) {
    signupmodal_props.params = /*params*/ctx[1];
  }
  signupmodal = new SignupModal({
    props: signupmodal_props
  });
  binding_callbacks.push(function () {
    return bind(signupmodal, 'display', signupmodal_display_binding);
  });
  binding_callbacks.push(function () {
    return bind(signupmodal, 'params', signupmodal_params_binding);
  });
  return {
    c: function c() {
      create_component(signupmodal.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(signupmodal, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var signupmodal_changes = {};
      if (dirty & /*onSuccess*/4) signupmodal_changes.onSuccessSignup = /*onSuccess*/ctx[2];
      if (!updating_display && dirty & /*display*/1) {
        updating_display = true;
        signupmodal_changes.display = /*display*/ctx[0];
        add_flush_callback(function () {
          return updating_display = false;
        });
      }
      if (!updating_params && dirty & /*params*/2) {
        updating_params = true;
        signupmodal_changes.params = /*params*/ctx[1];
        add_flush_callback(function () {
          return updating_params = false;
        });
      }
      signupmodal.$set(signupmodal_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(signupmodal.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(signupmodal.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(signupmodal, detaching);
    }
  };
}
// (81:4) {#if display === "login"}
function create_if_block_1(ctx) {
  var loginmodal;
  var updating_display;
  var updating_params;
  var current;
  function loginmodal_display_binding(value) {
    /*loginmodal_display_binding*/ctx[8](value);
  }
  function loginmodal_params_binding(value) {
    /*loginmodal_params_binding*/ctx[9](value);
  }
  var loginmodal_props = {
    closeModal: /*closeModal*/ctx[5],
    onSuccessLogin: /*onSuccess*/ctx[2]
  };
  if ( /*display*/ctx[0] !== void 0) {
    loginmodal_props.display = /*display*/ctx[0];
  }
  if ( /*params*/ctx[1] !== void 0) {
    loginmodal_props.params = /*params*/ctx[1];
  }
  loginmodal = new LoginModal({
    props: loginmodal_props
  });
  binding_callbacks.push(function () {
    return bind(loginmodal, 'display', loginmodal_display_binding);
  });
  binding_callbacks.push(function () {
    return bind(loginmodal, 'params', loginmodal_params_binding);
  });
  return {
    c: function c() {
      create_component(loginmodal.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(loginmodal, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var loginmodal_changes = {};
      if (dirty & /*onSuccess*/4) loginmodal_changes.onSuccessLogin = /*onSuccess*/ctx[2];
      if (!updating_display && dirty & /*display*/1) {
        updating_display = true;
        loginmodal_changes.display = /*display*/ctx[0];
        add_flush_callback(function () {
          return updating_display = false;
        });
      }
      if (!updating_params && dirty & /*params*/2) {
        updating_params = true;
        loginmodal_changes.params = /*params*/ctx[1];
        add_flush_callback(function () {
          return updating_params = false;
        });
      }
      loginmodal.$set(loginmodal_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(loginmodal.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(loginmodal.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(loginmodal, detaching);
    }
  };
}
// (78:2) {#if showLoader}
function create_if_block(ctx) {
  var loader;
  var current;
  loader = new Loader({});
  return {
    c: function c() {
      create_component(loader.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(loader, target, anchor);
      current = true;
    },
    p: noop,
    i: function i(local) {
      if (current) return;
      transition_in(loader.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(loader.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(loader, detaching);
    }
  };
}
// (95:8) {:else}
function create_else_block(ctx) {
  var profilemodal;
  var updating_display;
  var current;
  function profilemodal_display_binding(value) {
    /*profilemodal_display_binding*/ctx[16](value);
  }
  var profilemodal_props = {
    closeModal: /*closeModal*/ctx[5],
    onSuccessLogout: /*onSuccess*/ctx[2],
    member: /*member*/ctx[3]
  };
  if ( /*display*/ctx[0] !== void 0) {
    profilemodal_props.display = /*display*/ctx[0];
  }
  profilemodal = new ProfileModal({
    props: profilemodal_props
  });
  binding_callbacks.push(function () {
    return bind(profilemodal, 'display', profilemodal_display_binding);
  });
  return {
    c: function c() {
      create_component(profilemodal.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(profilemodal, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var profilemodal_changes = {};
      if (dirty & /*onSuccess*/4) profilemodal_changes.onSuccessLogout = /*onSuccess*/ctx[2];
      if (dirty & /*member*/8) profilemodal_changes.member = /*member*/ctx[3];
      if (!updating_display && dirty & /*display*/1) {
        updating_display = true;
        profilemodal_changes.display = /*display*/ctx[0];
        add_flush_callback(function () {
          return updating_display = false;
        });
      }
      profilemodal.$set(profilemodal_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(profilemodal.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(profilemodal.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(profilemodal, detaching);
    }
  };
}
// (93:8) {#if matches}
function create_if_block_7(ctx) {
  var mobileprofilemodal;
  var updating_display;
  var current;
  function mobileprofilemodal_display_binding(value) {
    /*mobileprofilemodal_display_binding*/ctx[15](value);
  }
  var mobileprofilemodal_props = {
    closeModal: /*closeModal*/ctx[5],
    onSuccessLogout: /*onSuccess*/ctx[2],
    member: /*member*/ctx[3]
  };
  if ( /*display*/ctx[0] !== void 0) {
    mobileprofilemodal_props.display = /*display*/ctx[0];
  }
  mobileprofilemodal = new MobileProfileModal({
    props: mobileprofilemodal_props
  });
  binding_callbacks.push(function () {
    return bind(mobileprofilemodal, 'display', mobileprofilemodal_display_binding);
  });
  return {
    c: function c() {
      create_component(mobileprofilemodal.$$.fragment);
    },
    m: function m(target, anchor) {
      mount_component(mobileprofilemodal, target, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var mobileprofilemodal_changes = {};
      if (dirty & /*onSuccess*/4) mobileprofilemodal_changes.onSuccessLogout = /*onSuccess*/ctx[2];
      if (dirty & /*member*/8) mobileprofilemodal_changes.member = /*member*/ctx[3];
      if (!updating_display && dirty & /*display*/1) {
        updating_display = true;
        mobileprofilemodal_changes.display = /*display*/ctx[0];
        add_flush_callback(function () {
          return updating_display = false;
        });
      }
      mobileprofilemodal.$set(mobileprofilemodal_changes);
    },
    i: function i(local) {
      if (current) return;
      transition_in(mobileprofilemodal.$$.fragment, local);
      current = true;
    },
    o: function o(local) {
      transition_out(mobileprofilemodal.$$.fragment, local);
      current = false;
    },
    d: function d(detaching) {
      destroy_component(mobileprofilemodal, detaching);
    }
  };
}
// (92:6) <MediaQuery query="(max-width: 520px)" let:matches>
function create_default_slot(ctx) {
  var current_block_type_index;
  var if_block;
  var if_block_anchor;
  var current;
  var if_block_creators = [create_if_block_7, create_else_block];
  var if_blocks = [];
  function select_block_type_1(ctx, dirty) {
    if ( /*matches*/ctx[21]) return 0;
    return 1;
  }
  current_block_type_index = select_block_type_1(ctx);
  if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  return {
    c: function c() {
      if_block.c();
      if_block_anchor = empty();
    },
    m: function m(target, anchor) {
      if_blocks[current_block_type_index].m(target, anchor);
      insert(target, if_block_anchor, anchor);
      current = true;
    },
    p: function p(ctx, dirty) {
      var previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type_1(ctx);
      if (current_block_type_index === previous_block_index) {
        if_blocks[current_block_type_index].p(ctx, dirty);
      } else {
        group_outros();
        transition_out(if_blocks[previous_block_index], 1, 1, function () {
          if_blocks[previous_block_index] = null;
        });
        check_outros();
        if_block = if_blocks[current_block_type_index];
        if (!if_block) {
          if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
          if_block.c();
        } else {
          if_block.p(ctx, dirty);
        }
        transition_in(if_block, 1);
        if_block.m(if_block_anchor.parentNode, if_block_anchor);
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o: function o(local) {
      transition_out(if_block);
      current = false;
    },
    d: function d(detaching) {
      if_blocks[current_block_type_index].d(detaching);
      if (detaching) detach(if_block_anchor);
    }
  };
}
function create_fragment(ctx) {
  var main;
  var current_block_type_index;
  var if_block;
  var current;
  var if_block_creators = [create_if_block, create_if_block_1, create_if_block_2, create_if_block_3, create_if_block_4, create_if_block_5, create_if_block_6];
  var if_blocks = [];
  function select_block_type(ctx, dirty) {
    if ( /*showLoader*/ctx[4]) return 0;
    if ( /*display*/ctx[0] === "login") return 1;
    if ( /*display*/ctx[0] === "signup") return 2;
    if ( /*display*/ctx[0] === "forgot_password") return 3;
    if ( /*display*/ctx[0] === "reset_password") return 4;
    if ( /*display*/ctx[0] === "reset_password_success") return 5;
    if ( /*display*/ctx[0] === "profile") return 6;
    return -1;
  }
  if (~(current_block_type_index = select_block_type(ctx))) {
    if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
  }
  return {
    c: function c() {
      main = element("main");
      if (if_block) if_block.c();
      attr(main, "id", "msOverlay");
      attr(main, "class", "svelte-bbv5du");
    },
    m: function m(target, anchor) {
      insert(target, main, anchor);
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].m(main, null);
      }
      current = true;
    },
    p: function p(ctx, _a) {
      var _b = __read(_a, 1),
        dirty = _b[0];
      var previous_block_index = current_block_type_index;
      current_block_type_index = select_block_type(ctx);
      if (current_block_type_index === previous_block_index) {
        if (~current_block_type_index) {
          if_blocks[current_block_type_index].p(ctx, dirty);
        }
      } else {
        if (if_block) {
          group_outros();
          transition_out(if_blocks[previous_block_index], 1, 1, function () {
            if_blocks[previous_block_index] = null;
          });
          check_outros();
        }
        if (~current_block_type_index) {
          if_block = if_blocks[current_block_type_index];
          if (!if_block) {
            if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
            if_block.c();
          } else {
            if_block.p(ctx, dirty);
          }
          transition_in(if_block, 1);
          if_block.m(main, null);
        } else {
          if_block = null;
        }
      }
    },
    i: function i(local) {
      if (current) return;
      transition_in(if_block);
      current = true;
    },
    o: function o(local) {
      transition_out(if_block);
      current = false;
    },
    d: function d(detaching) {
      if (detaching) detach(main);
      if (~current_block_type_index) {
        if_blocks[current_block_type_index].d();
      }
    }
  };
}
function instance($$self, $$props, $$invalidate) {
  var _this = this;
  var showLoader;
  var _a = $$props.display,
    display = _a === void 0 ? "login" : _a; // or "signup", "forgot_password", "reset_password", "reset_password_success", and "profile"
  var onSuccess = $$props.onSuccess;
  var params = $$props.params;
  var appLoading = true;
  var memberLoading = display === "profile" ? true : false;
  var member;
  function setAppStore(data) {
    AppStore.update(function () {
      return data;
    });
    TextStore.set({
      text: data.ssoText || {}
    });
  }
  function closeModal() {
    // hacky way to remove all components prior to removing overlay
    $$invalidate(6, appLoading = true);
    onSuccess({
      type: "CLOSED"
    });
    document.querySelector("#msOverlay").remove();
  }
  var getApp = function getApp() {
    return __awaiter(_this, void 0, void 0, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, window.$memberstackDom.getApp()];
          case 1:
            data = _a.sent().data;
            setAppStore(data);
            return [2 /*return*/];
        }
      });
    });
  };

  function checkApp() {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!(params && params.app)) return [3 /*break*/, 1];
            setAppStore(params.app);
            return [3 /*break*/, 3];
          case 1:
            console.log("No app specified - request it");
            return [4 /*yield*/, getApp()];
          case 2:
            _a.sent();
            _a.label = 3;
          case 3:
            $$invalidate(6, appLoading = false);
            $$invalidate(4, showLoader = false);
            return [2 /*return*/];
        }
      });
    });
  }

  var getMember = function getMember() {
    return __awaiter(_this, void 0, void 0, function () {
      var data;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, window.$memberstackDom.getCurrentMember()];
          case 1:
            data = _a.sent().data;
            $$invalidate(7, memberLoading = false);
            $$invalidate(3, member = data);
            if (display === "profile" && !data) {
              closeModal();
              throw new Error("Member not logged in");
            }
            return [2 /*return*/];
        }
      });
    });
  };

  onMount(function () {
    checkApp();
    if (display === "profile") {
      getMember();
    }
  });
  function loginmodal_display_binding(value) {
    display = value;
    $$invalidate(0, display);
  }
  function loginmodal_params_binding(value) {
    params = value;
    $$invalidate(1, params);
  }
  function signupmodal_display_binding(value) {
    display = value;
    $$invalidate(0, display);
  }
  function signupmodal_params_binding(value) {
    params = value;
    $$invalidate(1, params);
  }
  function passwordresetmodal_display_binding(value) {
    display = value;
    $$invalidate(0, display);
  }
  function passwordtokenmodal_display_binding(value) {
    display = value;
    $$invalidate(0, display);
  }
  function passwordsuccessmodal_display_binding(value) {
    display = value;
    $$invalidate(0, display);
  }
  function mobileprofilemodal_display_binding(value) {
    display = value;
    $$invalidate(0, display);
  }
  function profilemodal_display_binding(value) {
    display = value;
    $$invalidate(0, display);
  }
  $$self.$$set = function ($$props) {
    if ('display' in $$props) $$invalidate(0, display = $$props.display);
    if ('onSuccess' in $$props) $$invalidate(2, onSuccess = $$props.onSuccess);
    if ('params' in $$props) $$invalidate(1, params = $$props.params);
  };
  $$self.$$.update = function () {
    if ($$self.$$.dirty & /*appLoading, memberLoading*/192) {
      $$invalidate(4, showLoader = appLoading || memberLoading);
    }
  };
  return [display, params, onSuccess, member, showLoader, closeModal, appLoading, memberLoading, loginmodal_display_binding, loginmodal_params_binding, signupmodal_display_binding, signupmodal_params_binding, passwordresetmodal_display_binding, passwordtokenmodal_display_binding, passwordsuccessmodal_display_binding, mobileprofilemodal_display_binding, profilemodal_display_binding];
}
var Main = /** @class */function (_super) {
  __extends(Main, _super);
  function Main(options) {
    var _this = _super.call(this) || this;
    init(_this, options, instance, create_fragment, safe_not_equal, {
      display: 0,
      onSuccess: 2,
      params: 1
    }, add_css);
    return _this;
  }
  return Main;
}(SvelteComponent);
exports.default = Main;